(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"humedalesanim_atlas_", frames: [[0,1303,363,198],[1102,1162,363,198],[730,1360,363,198],[1095,1362,363,198],[1095,1762,363,198],[365,1560,363,198],[365,1360,363,198],[1467,1162,363,198],[730,1760,363,198],[1460,1762,363,198],[1460,1562,363,198],[1095,1562,363,198],[365,1760,363,198],[0,1703,363,198],[730,1560,363,198],[0,1503,363,198],[1460,1362,363,198],[686,1162,414,196],[0,1162,684,139],[0,0,1900,1160]]},
		{name:"humedalesanim_atlas_2", frames: [[1095,1200,361,198],[1459,599,359,197],[1459,400,359,197],[0,0,363,198],[1095,400,362,198],[1095,200,362,198],[0,200,363,198],[0,400,363,198],[1459,798,359,197],[0,600,363,198],[0,1000,363,198],[0,800,363,198],[1459,200,359,198],[1459,997,359,197],[1458,1774,359,198],[0,1800,363,198],[0,1200,363,198],[1095,1400,361,198],[0,1400,363,198],[0,1600,363,198],[1095,600,362,198],[365,0,363,198],[365,200,363,198],[365,400,363,198],[365,600,363,198],[1458,1200,360,198],[1095,800,362,198],[365,800,363,198],[1095,1600,361,198],[365,1000,363,198],[365,1200,363,198],[730,800,363,198],[365,1400,363,198],[730,400,363,198],[1458,1400,360,198],[365,1600,363,198],[365,1800,363,198],[730,0,363,198],[730,200,363,198],[1095,1800,361,198],[730,600,363,198],[730,1000,363,198],[730,1600,363,198],[1095,0,363,198],[1460,0,359,198],[730,1200,363,198],[730,1800,363,198],[1095,1000,362,198],[730,1400,363,198],[1458,1600,414,172]]},
		{name:"humedalesanim_atlas_3", frames: [[0,0,359,197],[0,199,359,197],[361,0,359,197],[0,398,359,197],[361,199,359,197],[722,0,359,197],[0,597,359,197],[1180,987,175,156],[331,811,176,156],[1004,859,174,157],[361,651,174,158],[1533,1289,172,158],[0,1688,173,159],[1360,338,171,160],[0,1526,172,160],[1251,166,170,161],[0,1044,170,162],[1004,1018,168,162],[1591,0,169,163],[832,525,167,164],[1421,0,168,164],[1883,318,165,165],[1083,0,166,166],[176,1815,164,166],[164,796,165,167],[1883,485,162,168],[839,861,163,168],[674,792,163,168],[509,811,163,168],[1525,1635,164,159],[722,199,179,166],[1944,0,101,232],[535,398,116,240],[0,796,162,246],[361,398,172,251],[723,1902,355,66],[1691,1773,355,66],[723,1970,355,66],[1080,1902,355,66],[1174,1145,162,168],[839,691,163,168],[933,1182,159,170],[1533,338,160,171],[1876,801,156,173],[1369,500,157,174],[378,1276,153,176],[1703,616,153,177],[1047,1538,149,179],[746,1573,150,179],[1344,1431,146,181],[933,1354,147,182],[1685,1841,160,138],[1492,1449,143,184],[1198,1501,144,184],[1525,1796,158,140],[1691,1585,140,186],[1383,1635,140,187],[1238,1687,143,184],[1094,1315,144,184],[1890,1274,158,140],[1089,1719,147,181],[898,1538,147,182],[1847,1841,160,138],[937,1722,150,178],[1723,801,151,179],[1528,511,163,136],[535,1431,154,175],[1547,655,154,176],[1833,1585,166,134],[172,965,157,173],[1004,684,158,173],[1591,165,168,132],[674,962,160,170],[1423,166,161,170],[1070,199,164,167],[903,199,165,167],[1191,368,167,164],[1251,0,168,164],[1762,155,170,161],[0,1363,171,161],[1011,524,173,158],[0,1849,174,158],[1369,676,176,155],[653,398,177,155],[354,1510,179,152],[1762,0,180,153],[378,1125,182,149],[537,640,183,150],[1542,987,185,147],[1695,318,186,147],[1858,655,188,144],[1357,1141,188,145],[741,1284,190,141],[1707,1441,191,142],[742,1754,193,139],[182,1140,194,140],[691,1431,192,140],[1338,1288,193,141],[553,1608,191,141],[331,981,191,142],[1729,1130,190,142],[361,1664,190,143],[533,1897,188,143],[342,1815,189,144],[553,1751,187,144],[173,1363,188,145],[553,1284,186,145],[1164,687,187,146],[1729,982,185,146],[1695,467,186,147],[747,1134,184,147],[175,1665,184,148],[562,1134,183,148],[1357,990,183,149],[1707,1289,181,150],[1180,835,182,150],[1547,1136,180,151],[1186,534,181,151],[1542,833,179,152],[0,1208,180,153],[174,1510,178,153],[1011,368,178,154],[1364,833,176,155],[832,368,177,155]]},
		{name:"humedalesanim_atlas_4", frames: [[429,1438,137,74],[1120,853,182,117],[359,623,182,118],[1671,1436,137,74],[1487,746,181,118],[1769,536,181,119],[0,1489,136,74],[1864,771,179,119],[1402,497,180,120],[969,1442,136,74],[346,743,178,120],[507,382,179,121],[143,1450,136,74],[930,645,177,121],[870,266,178,122],[281,1450,136,74],[1587,622,176,122],[1521,244,177,123],[568,1501,135,74],[1221,527,175,123],[1008,135,176,124],[1517,1512,135,74],[854,509,174,124],[331,258,174,125],[1810,1439,135,75],[1041,402,173,125],[1227,400,173,125],[832,1442,135,75],[0,743,171,125],[1693,374,172,126],[165,1578,33,46],[97,1565,34,47],[233,1579,29,42],[186,385,176,123],[397,1096,155,120],[364,385,120,110],[1481,1197,130,122],[1888,892,138,140],[1670,746,36,23],[186,266,143,108],[506,144,154,112],[1391,1364,69,54],[1750,1556,67,61],[891,1551,48,92],[941,1551,46,85],[1989,1149,47,132],[1305,1517,44,122],[1376,1197,103,165],[1867,1034,114,169],[49,1565,46,77],[995,1518,55,96],[1351,1517,26,155],[1481,1321,37,24],[513,1514,53,107],[1983,1034,63,113],[849,1211,79,65],[1107,1515,92,76],[1107,1438,135,75],[1872,276,172,126],[1345,272,172,126],[1261,1517,42,128],[1052,1518,41,119],[581,876,93,88],[740,524,94,89],[2046,24,2,1],[156,135,3,1],[776,1357,44,50],[1109,1290,44,51],[1473,1573,40,43],[419,1514,92,77],[705,1501,92,78],[133,1578,30,51],[1819,1556,31,52],[2046,20,2,2],[162,131,3,2],[389,1526,27,42],[594,505,39,16],[635,505,39,16],[568,1577,67,27],[144,1338,70,33],[1402,400,112,90],[1227,276,112,90],[167,131,3,2],[1014,129,4,2],[42,608,39,15],[552,505,40,16],[981,993,98,83],[1294,652,99,83],[1020,129,4,2],[156,131,4,2],[1628,1114,196,94],[1769,502,86,25],[971,1194,196,94],[1879,24,1,21],[1879,0,1,22],[799,1519,194,30],[662,187,11,9],[1097,883,18,26],[109,608,18,12],[156,266,19,7],[506,125,7,15],[2046,0,2,18],[690,260,19,4],[1345,186,14,13],[668,198,1,5],[1691,191,1,6],[2043,196,1,6],[1691,182,1,7],[331,191,1,7],[2043,187,1,7],[331,182,1,7],[1521,131,1,6],[1527,131,1,6],[1530,131,1,6],[1524,131,1,6],[334,191,1,6],[665,198,1,5],[662,198,1,5],[334,181,1,8],[2043,177,1,8],[1613,1210,240,57],[740,615,26,10],[1253,771,37,54],[1253,827,38,24],[0,608,40,15],[1345,135,14,32],[2043,137,3,38],[1091,261,41,9],[264,1579,29,27],[331,169,1,11],[331,154,1,13],[331,138,1,14],[1879,100,1,15],[1879,83,1,15],[334,138,1,14],[515,125,1,15],[1691,139,1,13],[672,159,1,12],[672,144,1,13],[334,154,1,13],[1691,168,1,12],[1691,154,1,12],[334,169,1,10],[672,173,1,10],[1879,65,1,16],[1879,47,1,16],[662,144,8,41],[1376,1112,250,83],[687,1211,160,65],[637,1577,45,35],[1603,223,44,16],[216,1338,30,30],[1134,261,22,13],[83,608,24,14],[768,615,23,8],[1158,261,25,11],[1008,129,4,3],[274,710,46,30],[1826,1168,39,28],[1649,230,39,11],[1708,746,39,20],[1312,368,31,30],[0,1208,275,51],[1654,1516,204,38],[192,710,80,25],[1227,368,83,27],[1521,223,80,16],[836,524,16,16],[1345,169,14,15],[930,1211,37,52],[1826,1114,37,52],[200,1578,31,43],[1303,1200,71,138],[1958,536,83,126],[1379,1573,92,42],[1050,261,39,10],[1654,1556,94,44],[234,1526,92,51],[138,1526,94,50],[568,1438,105,45],[429,1377,108,45],[133,525,36,89],[799,1551,44,101],[2005,1519,26,95],[712,758,17,101],[486,385,17,114],[676,876,26,95],[326,628,27,109],[1653,139,36,89],[845,1551,44,101],[0,1565,47,83],[1201,1517,58,94],[328,1526,59,78],[1860,1516,70,88],[1932,1519,71,72],[1958,664,83,83],[691,1357,83,66],[1947,1439,96,78],[1244,1440,135,75],[173,743,171,125],[1519,369,172,126],[1381,1496,134,75],[0,395,169,128],[1362,0,170,129],[1909,1361,134,76],[1867,404,166,130],[337,125,167,131],[414,1298,133,77],[688,390,164,132],[1028,0,165,133],[1169,1283,132,78],[1882,0,162,135],[173,0,162,136],[1120,771,131,80],[1882,137,159,137],[0,525,131,81],[1186,135,157,139],[1521,139,130,82],[0,131,154,142],[518,0,155,142],[1169,1200,130,81],[1362,131,157,139],[554,1203,131,80],[1534,0,160,137],[192,628,132,80],[844,129,162,135],[1855,1205,132,79],[1195,0,165,133],[414,1218,133,78],[675,127,167,131],[0,1261,133,78],[1700,244,170,128],[0,0,171,129],[687,1278,134,77],[156,138,173,126],[853,0,173,127],[277,1218,135,77],[1050,276,175,124],[675,0,176,125],[549,1285,135,76],[690,266,178,122],[337,0,179,123],[1613,1269,136,76],[507,260,181,120],[1696,0,181,121],[275,1297,137,75],[1584,502,183,118],[1696,123,184,119],[135,1261,138,75],[171,510,186,116],[364,505,186,116],[968,1290,139,74],[740,635,188,114],[1030,529,189,114],[1625,1361,140,73],[0,982,190,111],[1765,657,191,112],[1751,1286,141,73],[1672,1003,193,109],[924,771,194,110],[0,1341,142,72],[774,1102,195,107],[383,876,196,108],[284,1377,143,71],[1176,1092,198,106],[581,983,199,106],[823,1278,143,72],[198,1099,197,106],[782,993,197,107],[1481,1347,142,72],[0,1099,196,107],[899,883,196,108],[823,1352,142,72],[384,986,195,108],[1304,866,195,109],[0,1415,141,72],[1692,892,194,109],[1097,972,194,109],[1894,1286,141,73],[981,1083,193,109],[0,870,193,110],[1767,1361,140,73],[581,1091,191,110],[1670,771,192,111],[1109,1363,140,73],[192,986,190,111],[1294,739,191,112],[549,1363,140,73],[1501,884,189,112],[0,628,190,113],[691,1426,139,73],[1482,998,188,112],[733,751,189,113],[1391,1421,139,73],[1293,977,187,113],[543,642,188,114],[1251,1364,138,74],[195,870,186,114],[1398,622,187,115],[967,1366,138,74],[712,866,185,115],[552,524,186,116],[144,1374,138,74],[526,758,184,116],[854,390,185,117],[1532,1436,137,74],[1109,652,183,117],[0,275,184,118]]}
];


// symbols:



(lib.BMP_0039e909_9113_4f97_b5c4_75a50fca7e2c = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.BMP_07bfe81a_5a2a_47a9_aba6_e5acacedc168 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.BMP_101f6613_7c41_40b0_ab1c_069749d8e2a0 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.BMP_136dc9fd_f41f_48db_863e_a4b277ac0232 = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.BMP_1426134b_2f58_4938_b274_17a84c2817bb = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.BMP_18f6840d_732f_4cd3_b076_7b7a37c6b9b9 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.BMP_1d9f0d3f_26ad_495b_81e5_79c5f9b22152 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.BMP_1fada321_8604_423f_bd2e_cecb5a58e76c = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.BMP_26c819df_d244_4119_8d91_34fd54ea03db = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.BMP_2a342ecf_ca03_4eb7_ada6_b57699f6f7f5 = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.BMP_33da36d6_137a_4103_80e2_21622e23873c = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.BMP_3be2981d_965c_4c96_ab3d_39eeece0f147 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.BMP_3fa2c1bf_8b68_485c_9fad_165128e2403d = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.BMP_3fc890df_d020_4a69_b064_4d24cfc5bc24 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.BMP_4a4c39c7_5e6e_4b72_94cb_ac21fa4955b3 = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.BMP_4c98a9ad_8eb4_4104_9245_f5b9779d2007 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.BMP_4cfd895f_ce5a_4085_8c22_76aa808d1d22 = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.BMP_56ba9556_8ba9_422a_a4cd_2e6359d3b493 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.BMP_56ede838_872c_4c76_aa25_cf9972872787 = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.BMP_5dc6d934_ccfe_4be3_9f2f_2ca5c1825984 = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.BMP_5f0dddab_0e22_4dc5_9482_a54f2966c00e = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.BMP_67d07f98_4fe8_4ea6_afd3_74665148c74b = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.BMP_7204e884_904b_4162_b731_0482d453cf1f = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.BMP_75430fcb_87e9_4c0b_ae4d_6a13900a1455 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.BMP_780db005_9699_4530_9277_dbc0f9d23d22 = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.BMP_80aa09da_5b98_491e_8be9_3b0a7429dd7b = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.BMP_881071d9_b057_4d90_b212_f45506a24f6a = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.BMP_8cdcf638_fe0f_422d_90d0_a1ee81eaad03 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.BMP_8e0e9871_90dd_4b20_a211_3ed0f6883d7f = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.BMP_8ef17a96_8d16_4be1_a75b_06cb350501a4 = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.BMP_90bb3712_32b0_44e5_9666_a570916e7fcd = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.BMP_9280328b_df68_4d29_8964_103bfcbf756b = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.BMP_96c19964_5971_4e9c_bddc_00a3a4941521 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.BMP_97375757_d075_49bb_83c7_0abba9be2e23 = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.BMP_986aa69d_ca1c_4f75_bba8_f5cbc87e5ea1 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.BMP_9a58cdf3_3af3_423d_8b53_fcf142a088e5 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.BMP_9dc7b225_7532_4660_b0dd_877e8601e60f = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.BMP_a856fcf9_202a_4753_a120_ff2441b5d6f3 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.BMP_aaf2e1ec_e03d_4de6_876d_641b80b32cad = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.BMP_ac1519f3_2d10_40e5_b856_9c8b76e053d2 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.BMP_afc4a0ec_8d54_4323_a2b8_48d06497516c = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.BMP_b248a9a1_dc51_4ad1_a999_676b548b3110 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.BMP_b67b950e_cd65_404a_923d_cdc567946aab = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.BMP_b7ca37b0_7916_4152_8e23_11fe57e8c9db = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.BMP_b842607c_11fb_4e10_87ed_aa53136649f1 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.BMP_bb04de0c_b5ca_401b_ae32_68d780e3d5c3 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.BMP_bc054416_be44_4787_8f80_d46e6bcc871d = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.BMP_bc2b0ddc_6aa4_458c_ba32_5e216e6e46c5 = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.BMP_bcee5066_f5cd_4718_afca_2c74dea604c3 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.BMP_bd0dddd7_863c_4f17_bc8f_06a8a466a779 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib.BMP_c12888b1_5d7c_4283_98f1_0adf29364a26 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();



(lib.BMP_c98b71f9_dd46_4681_82a1_4ead25d3756a = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(30);
}).prototype = p = new cjs.Sprite();



(lib.BMP_ce82f2c6_69eb_47d1_941e_55808f8a6edf = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(31);
}).prototype = p = new cjs.Sprite();



(lib.BMP_ce8338eb_cef1_47f4_9205_841ebece360b = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(32);
}).prototype = p = new cjs.Sprite();



(lib.BMP_d31d4e36_a0d8_4c42_ba3e_e704335a7575 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(33);
}).prototype = p = new cjs.Sprite();



(lib.BMP_d409241b_50e0_4a93_98ac_6068fef1ecb8 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(34);
}).prototype = p = new cjs.Sprite();



(lib.BMP_de6c92b2_3445_4c39_b8bd_4aeff0cd8883 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(35);
}).prototype = p = new cjs.Sprite();



(lib.BMP_dfa04e9e_f9e7_4ba9_9c53_a5bd8efff3d1 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(36);
}).prototype = p = new cjs.Sprite();



(lib.BMP_e692f0c9_cf9d_4094_a9ed_3f81922b5ce4 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.BMP_e70fab21_f523_4f15_9219_c50ab72ee7b7 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(37);
}).prototype = p = new cjs.Sprite();



(lib.BMP_e7d48300_8b10_4cd2_9658_860fab4cc9ad = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(38);
}).prototype = p = new cjs.Sprite();



(lib.BMP_e8d28562_1ad3_40ee_89ad_69f802d8a51e = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(39);
}).prototype = p = new cjs.Sprite();



(lib.BMP_f1510f03_de73_4fa4_86dd_aecc998e8402 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(40);
}).prototype = p = new cjs.Sprite();



(lib.BMP_f3d4a934_776c_487f_b801_ac2abd31b37b = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(41);
}).prototype = p = new cjs.Sprite();



(lib.BMP_f5090d4d_f119_4927_aba6_8dbc7d6cdcbc = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(42);
}).prototype = p = new cjs.Sprite();



(lib.BMP_f56b3921_5dd7_4a21_9327_d4c710de8c13 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.BMP_f6672567_f901_4dbc_a1d9_07c58febeb1e = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(43);
}).prototype = p = new cjs.Sprite();



(lib.BMP_f7688039_34f2_4d35_91a3_7acbd2a71c3d = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(44);
}).prototype = p = new cjs.Sprite();



(lib.BMP_fe7a8dcb_bf2d_4ee5_96ce_3da903d5c95a = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.BMP_fe88dd60_c197_439a_a521_2012be1ac092 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(45);
}).prototype = p = new cjs.Sprite();



(lib.BMP_fe8e15b7_d0b7_4c7e_bc82_917354123d4d = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(46);
}).prototype = p = new cjs.Sprite();



(lib.BMP_ff09aaf9_73e4_49bd_ae90_d2b5e4f0cf6c = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(47);
}).prototype = p = new cjs.Sprite();



(lib.BMP_ff4a3c92_22ce_4df8_a2ae_8eaaf49bad58 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(48);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1000 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1001 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1002 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1003 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1004 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1005 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1006 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1007 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1008 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1009 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1010 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1011 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1012 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1013 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1014 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1015 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1016 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1017 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1018 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1019 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1020 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1021 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1022 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1023 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1024 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1025 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1026 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1027 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1028 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1029 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1030 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1031 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1032 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1033 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1034 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1035 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1036 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1037 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1038 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1039 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1040 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1041 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1042 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1043 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1044 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1045 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1046 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1047 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1048 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1049 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1050 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(30);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1051 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(31);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1052 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(32);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1053 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(33);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1054 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(34);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1055 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(35);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1056 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(36);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1057 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(37);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1058 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(38);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1059 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(39);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1060 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(40);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1061 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(41);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1062 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(42);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1063 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(43);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1064 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(44);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1065 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(45);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1066 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(46);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1067 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(47);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1068 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(48);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1069 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(49);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1070 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(50);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1072 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(51);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1073 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(52);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1074 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(53);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1075 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(54);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1076 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(55);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1077 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(56);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1078 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(57);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1079 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1080 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1081 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(58);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1082 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(59);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1083 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1084 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(30);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1085 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(60);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1086 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(61);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1087 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(31);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1088 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(32);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1089 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(33);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_1090 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(34);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_546 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(62);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_547 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(63);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_548 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(64);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_549 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(65);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_550 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(66);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_551 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(67);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_552 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(68);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_553 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(69);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_554 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(70);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_555 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(71);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_556 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(72);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_557 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(73);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_558 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(74);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_559 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(75);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_560 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(76);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_561 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(77);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_562 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(78);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_563 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(79);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_564 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(80);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_565 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(81);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_566 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(82);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_567 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(83);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_568 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(84);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_569 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(85);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_570 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(86);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_571 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(87);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_572 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(88);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_573 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(89);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_574 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(90);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_575 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(91);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_576 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(92);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_577 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(93);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_578 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(94);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_579 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(95);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_580 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(96);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_581 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(97);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_582 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(98);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_583 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(99);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_584 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(100);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_585 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(101);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_586 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(102);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_587 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(103);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_588 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(104);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_601 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(105);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_604 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(106);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_606 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(107);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_610 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(108);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_611 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(109);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_612 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(110);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_613 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(111);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_615 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(112);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_616 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(113);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_617 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(114);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_618 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(115);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_619 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(116);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_620 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(117);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_651 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(118);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_653 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(119);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_654 = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_655 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(120);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_656 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(121);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_657 = function() {
	this.initialize(ss["humedalesanim_atlas_2"]);
	this.gotoAndStop(49);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_658 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(122);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_659 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(123);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_660 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(124);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_661 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(125);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_662 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(126);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_663 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(127);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_664 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(128);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_665 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(129);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_681 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(130);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_683 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(131);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_686 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(132);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_687 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(133);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_688 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(134);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_689 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(135);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_690 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(136);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_691 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(137);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_692 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(138);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_693 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(139);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_694 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(140);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_695 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(141);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_696 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(142);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_697 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(143);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_729 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(144);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_730 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(145);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_731 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(146);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_732 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(147);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_733 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(148);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_734 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(149);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_735 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(150);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_736 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(151);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_737 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(152);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_738 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(153);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_739 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(154);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_740 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(155);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_741 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(156);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_742 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(157);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_743 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(158);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_744 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(159);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_745 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(160);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_746 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(161);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_748 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(162);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_749 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(35);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_750 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(36);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_751 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(37);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_752 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(38);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_753 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(163);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_754 = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_755 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(164);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_756 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(165);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_757 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(166);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_758 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(167);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_759 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(168);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_760 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(169);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_761 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(170);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_762 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(171);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_763 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(172);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_764 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(173);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_765 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(174);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_766 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(175);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_767 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(176);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_768 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(177);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_769 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(178);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_770 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(179);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_771 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(180);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_782 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(181);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_783 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(182);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_784 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(183);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_786 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(184);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_787 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(185);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_788 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(186);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_789 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(187);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_790 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(188);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_791 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(189);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_792 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(190);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_793 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(191);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_794 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(192);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_795 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(193);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_796 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(194);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_797 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(195);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_798 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(196);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_799 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(197);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_805 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(198);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_806 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(39);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_807 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(40);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_808 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(199);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_809 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(200);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_810 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(201);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_811 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(41);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_812 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(42);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_813 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(202);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_814 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(203);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_815 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(204);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_816 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(43);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_817 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(44);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_818 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(205);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_819 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(206);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_820 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(207);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_821 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(45);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_822 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(46);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_823 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(208);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_824 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(209);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_825 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(210);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_826 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(47);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_827 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(48);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_828 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(211);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_829 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(212);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_830 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(213);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_831 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(49);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_832 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(50);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_833 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(214);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_834 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(51);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_835 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(215);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_836 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(52);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_837 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(53);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_838 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(216);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_839 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(54);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_840 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(217);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_841 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(55);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_842 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(56);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_843 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(218);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_844 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(219);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_845 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(220);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_846 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(57);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_847 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(58);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_848 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(221);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_849 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(59);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_850 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(222);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_851 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(60);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_852 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(61);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_853 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(223);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_854 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(62);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_855 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(224);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_856 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(63);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_857 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(64);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_858 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(225);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_859 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(65);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_860 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(226);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_861 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(66);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_862 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(67);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_863 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(227);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_864 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(68);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_865 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(228);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_866 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(69);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_867 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(70);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_868 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(229);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_869 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(71);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_870 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(230);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_871 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(72);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_872 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(73);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_873 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(231);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_874 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(232);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_875 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(233);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_876 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(74);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_877 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(75);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_878 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(234);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_879 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(235);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_880 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(236);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_881 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(76);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_882 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(77);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_883 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(237);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_884 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(238);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_885 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(239);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_886 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(78);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_887 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(79);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_888 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(240);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_889 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(241);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_890 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(242);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_891 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(80);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_892 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(81);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_893 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(243);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_894 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(244);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_895 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(245);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_896 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(82);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_897 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(83);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_898 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(246);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_899 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(247);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_900 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(248);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_901 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(84);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_902 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(85);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_903 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(249);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_904 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(250);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_905 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(251);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_906 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(86);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_907 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(87);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_908 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(252);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_909 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(253);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_910 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(254);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_911 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(88);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_912 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(89);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_913 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(255);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_914 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(256);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_915 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(257);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_916 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(90);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_917 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(91);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_918 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(258);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_919 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(259);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_920 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(260);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_921 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(92);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_922 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(93);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_923 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(261);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_924 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(262);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_925 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(263);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_926 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(94);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_927 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(95);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_928 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(264);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_929 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(265);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_930 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(266);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_931 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(96);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_932 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(97);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_933 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(267);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_934 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(268);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_935 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(269);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_936 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(98);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_937 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(99);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_938 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(270);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_939 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(271);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_940 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(272);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_941 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(100);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_942 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(101);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_943 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(273);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_944 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(274);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_945 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(275);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_946 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(102);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_947 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(103);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_948 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(276);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_949 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(277);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_950 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(278);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_951 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(104);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_952 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(105);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_953 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(279);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_954 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(280);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_955 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(281);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_956 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(106);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_957 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(107);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_958 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(282);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_959 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(283);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_960 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(284);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_961 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(108);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_962 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(109);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_963 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(285);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_964 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(286);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_965 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(287);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_966 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(110);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_967 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(111);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_968 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(288);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_969 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(289);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_970 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(290);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_971 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(112);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_972 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(113);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_973 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(291);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_974 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(292);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_975 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(293);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_976 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(114);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_977 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(115);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_978 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(294);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_979 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(295);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_980 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(296);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_981 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(116);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_982 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(117);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_983 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(297);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_984 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(298);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_985 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(299);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_986 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(118);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_987 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(119);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_988 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(300);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_989 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(301);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_990 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(302);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_991 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(120);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_992 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(121);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_993 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(303);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_994 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(304);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_995 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(305);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_996 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(122);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_997 = function() {
	this.initialize(ss["humedalesanim_atlas_3"]);
	this.gotoAndStop(123);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_998 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(306);
}).prototype = p = new cjs.Sprite();



(lib.CachedTexturedBitmap_999 = function() {
	this.initialize(ss["humedalesanim_atlas_4"]);
	this.gotoAndStop(307);
}).prototype = p = new cjs.Sprite();



(lib.copiafondo = function() {
	this.initialize(ss["humedalesanim_atlas_"]);
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.yerba1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_1088();
	this.instance.parent = this;
	this.instance.setTransform(42.95,-0.45,0.4999,0.4999);

	this.instance_1 = new lib.CachedTexturedBitmap_1087();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.2,3.15,0.4999,0.4999);

	this.instance_2 = new lib.CachedTexturedBitmap_1086();
	this.instance_2.parent = this;
	this.instance_2.setTransform(61.95,58.7,0.4999,0.4999);

	this.instance_3 = new lib.CachedTexturedBitmap_1085();
	this.instance_3.parent = this;
	this.instance_3.setTransform(56.85,53.75,0.4999,0.4999);

	this.instance_4 = new lib.CachedTexturedBitmap_1084();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-0.45,36,0.4999,0.4999);

	this.instance_5 = new lib.CachedTexturedBitmap_1083();
	this.instance_5.parent = this;
	this.instance_5.setTransform(0.2,38.65,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-0.4,-0.4,101.4,120);


(lib.WarpedAsset_5 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_1082();
	this.instance.parent = this;
	this.instance.setTransform(-42.7,-33.85,0.5,0.5);

	this.instance_1 = new lib.CachedTexturedBitmap_1081();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-42.55,-33.65,0.5,0.5);

	this.instance_2 = new lib.CachedTexturedBitmap_1080();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-55.35,-42.85,0.5,0.5);

	this.instance_3 = new lib.CachedTexturedBitmap_1079();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-55.2,-42.75,0.5,0.5);

	this.instance_4 = new lib.CachedTexturedBitmap_1078();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-12,5.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-55.3,-42.8,110.8,85.8);


(lib.WarpedAsset_3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_1077();
	this.instance.parent = this;
	this.instance.setTransform(-22.9,-18.85,0.4999,0.4999);

	this.instance_1 = new lib.CachedTexturedBitmap_1076();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-19.4,-15.85,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22.9,-18.8,46,38);


(lib.WarpedAsset_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.BMP_8e0e9871_90dd_4b20_a211_3ed0f6883d7f();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,359,198);


(lib.Símbolo5 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_1075();
	this.instance.parent = this;
	this.instance.setTransform(85.2,27.6,0.4999,0.4999);

	this.instance_1 = new lib.CachedTexturedBitmap_1074();
	this.instance_1.parent = this;
	this.instance_1.setTransform(85.8,30.35,0.4999,0.4999);

	this.instance_2 = new lib.CachedTexturedBitmap_1073();
	this.instance_2.parent = this;
	this.instance_2.setTransform(64.95,17,0.4999,0.4999);

	this.instance_3 = new lib.CachedTexturedBitmap_1072();
	this.instance_3.parent = this;
	this.instance_3.setTransform(79.95,7,0.4999,0.4999);

	this.instance_4 = new lib.CachedTexturedBitmap_1072();
	this.instance_4.parent = this;
	this.instance_4.setTransform(76.95,7,0.4999,0.4999);

	this.instance_5 = new lib.CachedTexturedBitmap_1070();
	this.instance_5.parent = this;
	this.instance_5.setTransform(42,14.5,0.4999,0.4999);

	this.instance_6 = new lib.CachedTexturedBitmap_1069();
	this.instance_6.parent = this;
	this.instance_6.setTransform(43.15,17,0.4999,0.4999);

	this.instance_7 = new lib.CachedTexturedBitmap_1068();
	this.instance_7.parent = this;
	this.instance_7.setTransform(26.5,-0.45,0.4999,0.4999);

	this.instance_8 = new lib.CachedTexturedBitmap_1067();
	this.instance_8.parent = this;
	this.instance_8.setTransform(29.35,1.9,0.4999,0.4999);

	this.instance_9 = new lib.CachedTexturedBitmap_1066();
	this.instance_9.parent = this;
	this.instance_9.setTransform(18.1,18.05,0.4999,0.4999);

	this.instance_10 = new lib.CachedTexturedBitmap_1065();
	this.instance_10.parent = this;
	this.instance_10.setTransform(15.05,18.05,0.4999,0.4999);

	this.instance_11 = new lib.CachedTexturedBitmap_1064();
	this.instance_11.parent = this;
	this.instance_11.setTransform(48.45,41.65,0.4999,0.4999);

	this.instance_12 = new lib.CachedTexturedBitmap_1063();
	this.instance_12.parent = this;
	this.instance_12.setTransform(44.05,38.4,0.4999,0.4999);

	this.instance_13 = new lib.CachedTexturedBitmap_1062();
	this.instance_13.parent = this;
	this.instance_13.setTransform(15.05,7,0.4999,0.4999);

	this.instance_14 = new lib.CachedTexturedBitmap_1061();
	this.instance_14.parent = this;
	this.instance_14.setTransform(9.85,8.1,0.4999,0.4999);

	this.instance_15 = new lib.CachedTexturedBitmap_1060();
	this.instance_15.parent = this;
	this.instance_15.setTransform(-0.45,28.2,0.4999,0.4999);

	this.instance_16 = new lib.CachedTexturedBitmap_1059();
	this.instance_16.parent = this;
	this.instance_16.setTransform(0.3,30.4,0.4999,0.4999);

	this.instance_17 = new lib.CachedTexturedBitmap_1058();
	this.instance_17.parent = this;
	this.instance_17.setTransform(64.55,14.8,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.Símbolo5, new cjs.Rectangle(-0.4,-0.4,117.10000000000001,84.9), null);


(lib.Símbolo4 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_1057();
	this.instance.parent = this;
	this.instance.setTransform(0.3,-0.45,0.4999,0.4999);

	this.instance_1 = new lib.CachedTexturedBitmap_1056();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-0.45,1.1,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.Símbolo4, new cjs.Rectangle(-0.4,-0.4,69.7,70), null);


(lib.Símbolo3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_1055();
	this.instance.parent = this;
	this.instance.setTransform(20.25,5.7,0.4999,0.4999);

	this.instance_1 = new lib.CachedTexturedBitmap_1054();
	this.instance_1.parent = this;
	this.instance_1.setTransform(6.85,0.8,0.4999,0.4999);

	this.instance_2 = new lib.CachedTexturedBitmap_1053();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-0.45,-0.45,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.Símbolo3, new cjs.Rectangle(-0.4,-0.4,88,61.5), null);


(lib.Símbolo2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_1052();
	this.instance.parent = this;
	this.instance.setTransform(0,2.35,0.4999,0.4999);

	this.instance_1 = new lib.CachedTexturedBitmap_1051();
	this.instance_1.parent = this;
	this.instance_1.setTransform(0,0,0.4999,0.4999);

	this.instance_2 = new lib.CachedTexturedBitmap_1050();
	this.instance_2.parent = this;
	this.instance_2.setTransform(0.1,0.05,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.Símbolo2, new cjs.Rectangle(0,0,17,23.5), null);


(lib.picogarza1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_762();
	this.instance.parent = this;
	this.instance.setTransform(2.3,2.95,0.4999,0.4999);

	this.instance_1 = new lib.CachedTexturedBitmap_761();
	this.instance_1.parent = this;
	this.instance_1.setTransform(0,0,0.4999,0.4999);

	this.instance_2 = new lib.CachedTexturedBitmap_760();
	this.instance_2.parent = this;
	this.instance_2.setTransform(0.05,0,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,18.6,26);


(lib.Path_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_757();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Path_2, new cjs.Rectangle(0,0,40,8), null);


(lib.Path_1_0 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_756();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Path_1_0, new cjs.Rectangle(0,0,41.5,13.5), null);


(lib.Path_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_755();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Path_1, new cjs.Rectangle(0,0,40,12.5), null);


(lib.nube7 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_754();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.nube7, new cjs.Rectangle(0,0,342,69.5), null);


(lib.nube6 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_753();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.nube6, new cjs.Rectangle(0,0,102,19), null);


(lib.nube5 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_752();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.nube5, new cjs.Rectangle(0,0,177.5,33), null);


(lib.nube4 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_751();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.nube4, new cjs.Rectangle(0,0,177.5,33), null);


(lib.nube3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_750();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.nube3, new cjs.Rectangle(0,0,177.5,33), null);


(lib.nube1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_749();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.nube1, new cjs.Rectangle(0,0,177.5,33), null);


(lib.Path_1_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance_1 = new lib.CachedTexturedBitmap_748();
	this.instance_1.parent = this;
	this.instance_1.setTransform(0,0,0.2499,0.2499);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.Path_1_1, new cjs.Rectangle(0,0,68.8,12.8), null);


(lib.Path = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_748();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.2499,0.2499);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Path, new cjs.Rectangle(0,0,68.8,12.8), null);


(lib.alap2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_563();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.4011,0.4011);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.alap2, new cjs.Rectangle(0,0,28.1,13.3), null);


(lib.alap1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_562();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.5001,0.5001);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.alap1, new cjs.Rectangle(0,0,33.5,13.5), null);


(lib.Símbolo1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.nube4();
	this.instance.parent = this;
	this.instance.setTransform(88.8,16.5,1,1,0,0,0,88.8,16.5);
	this.instance.alpha = 0.0781;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Símbolo1, new cjs.Rectangle(0,0,177.5,33), null);


(lib.PuppetShape_5 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.WarpedAsset_5("synched",0);
	this.instance.parent = this;

	this.instance_1 = new lib.CachedTexturedBitmap_1049();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-42.6,-33.75,0.5,0.5);

	this.instance_2 = new lib.CachedTexturedBitmap_1048();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-42.45,-33.55,0.5,0.5);

	this.instance_3 = new lib.CachedTexturedBitmap_1047();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-55.25,-42.8,0.5,0.5);

	this.instance_4 = new lib.CachedTexturedBitmap_1046();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-55.1,-42.7,0.5,0.5);

	this.instance_5 = new lib.CachedTexturedBitmap_1045();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-12,5.6,0.5,0.5);

	this.instance_6 = new lib.CachedTexturedBitmap_809();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-42.6,-33.75,0.5,0.5);

	this.instance_7 = new lib.CachedTexturedBitmap_808();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-42.45,-33.55,0.5,0.5);

	this.instance_8 = new lib.CachedTexturedBitmap_807();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-55.25,-42.75,0.5,0.5);

	this.instance_9 = new lib.CachedTexturedBitmap_806();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-55.1,-42.7,0.5,0.5);

	this.instance_10 = new lib.CachedTexturedBitmap_805();
	this.instance_10.parent = this;
	this.instance_10.setTransform(-11.95,5.55,0.5,0.5);

	this.instance_11 = new lib.CachedTexturedBitmap_814();
	this.instance_11.parent = this;
	this.instance_11.setTransform(-42.8,-33.8,0.5,0.5);

	this.instance_12 = new lib.CachedTexturedBitmap_813();
	this.instance_12.parent = this;
	this.instance_12.setTransform(-42.6,-33.6,0.5,0.5);

	this.instance_13 = new lib.CachedTexturedBitmap_812();
	this.instance_13.parent = this;
	this.instance_13.setTransform(-55.15,-43.2,0.5,0.5);

	this.instance_14 = new lib.CachedTexturedBitmap_811();
	this.instance_14.parent = this;
	this.instance_14.setTransform(-54.95,-43.1,0.5,0.5);

	this.instance_15 = new lib.CachedTexturedBitmap_810();
	this.instance_15.parent = this;
	this.instance_15.setTransform(-13.15,6.3,0.5,0.5);

	this.instance_16 = new lib.CachedTexturedBitmap_819();
	this.instance_16.parent = this;
	this.instance_16.setTransform(-43,-33.9,0.5,0.5);

	this.instance_17 = new lib.CachedTexturedBitmap_818();
	this.instance_17.parent = this;
	this.instance_17.setTransform(-42.8,-33.7,0.5,0.5);

	this.instance_18 = new lib.CachedTexturedBitmap_817();
	this.instance_18.parent = this;
	this.instance_18.setTransform(-55,-43.65,0.5,0.5);

	this.instance_19 = new lib.CachedTexturedBitmap_816();
	this.instance_19.parent = this;
	this.instance_19.setTransform(-54.8,-43.55,0.5,0.5);

	this.instance_20 = new lib.CachedTexturedBitmap_815();
	this.instance_20.parent = this;
	this.instance_20.setTransform(-14.4,7,0.5,0.5);

	this.instance_21 = new lib.CachedTexturedBitmap_824();
	this.instance_21.parent = this;
	this.instance_21.setTransform(-43.2,-33.95,0.5,0.5);

	this.instance_22 = new lib.CachedTexturedBitmap_823();
	this.instance_22.parent = this;
	this.instance_22.setTransform(-43,-33.75,0.5,0.5);

	this.instance_23 = new lib.CachedTexturedBitmap_822();
	this.instance_23.parent = this;
	this.instance_23.setTransform(-54.85,-44,0.5,0.5);

	this.instance_24 = new lib.CachedTexturedBitmap_821();
	this.instance_24.parent = this;
	this.instance_24.setTransform(-54.65,-43.95,0.5,0.5);

	this.instance_25 = new lib.CachedTexturedBitmap_820();
	this.instance_25.parent = this;
	this.instance_25.setTransform(-15.55,7.65,0.5,0.5);

	this.instance_26 = new lib.CachedTexturedBitmap_829();
	this.instance_26.parent = this;
	this.instance_26.setTransform(-43.35,-34,0.5,0.5);

	this.instance_27 = new lib.CachedTexturedBitmap_828();
	this.instance_27.parent = this;
	this.instance_27.setTransform(-43.2,-33.8,0.5,0.5);

	this.instance_28 = new lib.CachedTexturedBitmap_827();
	this.instance_28.parent = this;
	this.instance_28.setTransform(-54.7,-44.35,0.5,0.5);

	this.instance_29 = new lib.CachedTexturedBitmap_826();
	this.instance_29.parent = this;
	this.instance_29.setTransform(-54.5,-44.25,0.5,0.5);

	this.instance_30 = new lib.CachedTexturedBitmap_825();
	this.instance_30.parent = this;
	this.instance_30.setTransform(-16.6,8.2,0.5,0.5);

	this.instance_31 = new lib.CachedTexturedBitmap_834();
	this.instance_31.parent = this;
	this.instance_31.setTransform(-43.55,-34.05,0.5,0.5);

	this.instance_32 = new lib.CachedTexturedBitmap_833();
	this.instance_32.parent = this;
	this.instance_32.setTransform(-43.35,-33.85,0.5,0.5);

	this.instance_33 = new lib.CachedTexturedBitmap_832();
	this.instance_33.parent = this;
	this.instance_33.setTransform(-54.55,-44.7,0.5,0.5);

	this.instance_34 = new lib.CachedTexturedBitmap_831();
	this.instance_34.parent = this;
	this.instance_34.setTransform(-54.35,-44.6,0.5,0.5);

	this.instance_35 = new lib.CachedTexturedBitmap_830();
	this.instance_35.parent = this;
	this.instance_35.setTransform(-17.7,8.75,0.5,0.5);

	this.instance_36 = new lib.CachedTexturedBitmap_839();
	this.instance_36.parent = this;
	this.instance_36.setTransform(-43.75,-34.1,0.5,0.5);

	this.instance_37 = new lib.CachedTexturedBitmap_838();
	this.instance_37.parent = this;
	this.instance_37.setTransform(-43.55,-33.9,0.5,0.5);

	this.instance_38 = new lib.CachedTexturedBitmap_837();
	this.instance_38.parent = this;
	this.instance_38.setTransform(-54.4,-45.05,0.5,0.5);

	this.instance_39 = new lib.CachedTexturedBitmap_836();
	this.instance_39.parent = this;
	this.instance_39.setTransform(-54.2,-44.95,0.5,0.5);

	this.instance_40 = new lib.CachedTexturedBitmap_835();
	this.instance_40.parent = this;
	this.instance_40.setTransform(-18.85,9.3,0.5,0.5);

	this.instance_41 = new lib.CachedTexturedBitmap_844();
	this.instance_41.parent = this;
	this.instance_41.setTransform(-43.9,-34.2,0.5,0.5);

	this.instance_42 = new lib.CachedTexturedBitmap_843();
	this.instance_42.parent = this;
	this.instance_42.setTransform(-43.7,-33.95,0.5,0.5);

	this.instance_43 = new lib.CachedTexturedBitmap_842();
	this.instance_43.parent = this;
	this.instance_43.setTransform(-54.25,-45.35,0.5,0.5);

	this.instance_44 = new lib.CachedTexturedBitmap_841();
	this.instance_44.parent = this;
	this.instance_44.setTransform(-54.05,-45.25,0.5,0.5);

	this.instance_45 = new lib.CachedTexturedBitmap_840();
	this.instance_45.parent = this;
	this.instance_45.setTransform(-19.85,9.8,0.5,0.5);

	this.instance_46 = new lib.CachedTexturedBitmap_849();
	this.instance_46.parent = this;
	this.instance_46.setTransform(-43.7,-34.1,0.5,0.5);

	this.instance_47 = new lib.CachedTexturedBitmap_848();
	this.instance_47.parent = this;
	this.instance_47.setTransform(-43.5,-33.9,0.5,0.5);

	this.instance_48 = new lib.CachedTexturedBitmap_847();
	this.instance_48.parent = this;
	this.instance_48.setTransform(-54.4,-45,0.5,0.5);

	this.instance_49 = new lib.CachedTexturedBitmap_846();
	this.instance_49.parent = this;
	this.instance_49.setTransform(-54.25,-44.9,0.5,0.5);

	this.instance_50 = new lib.CachedTexturedBitmap_845();
	this.instance_50.parent = this;
	this.instance_50.setTransform(-18.65,9.25,0.5,0.5);

	this.instance_51 = new lib.CachedTexturedBitmap_854();
	this.instance_51.parent = this;
	this.instance_51.setTransform(-43.5,-34.05,0.5,0.5);

	this.instance_52 = new lib.CachedTexturedBitmap_853();
	this.instance_52.parent = this;
	this.instance_52.setTransform(-43.3,-33.85,0.5,0.5);

	this.instance_53 = new lib.CachedTexturedBitmap_852();
	this.instance_53.parent = this;
	this.instance_53.setTransform(-54.6,-44.55,0.5,0.5);

	this.instance_54 = new lib.CachedTexturedBitmap_851();
	this.instance_54.parent = this;
	this.instance_54.setTransform(-54.4,-44.5,0.5,0.5);

	this.instance_55 = new lib.CachedTexturedBitmap_850();
	this.instance_55.parent = this;
	this.instance_55.setTransform(-17.4,8.65,0.5,0.5);

	this.instance_56 = new lib.CachedTexturedBitmap_859();
	this.instance_56.parent = this;
	this.instance_56.setTransform(-43.25,-33.95,0.5,0.5);

	this.instance_57 = new lib.CachedTexturedBitmap_858();
	this.instance_57.parent = this;
	this.instance_57.setTransform(-43.05,-33.75,0.5,0.5);

	this.instance_58 = new lib.CachedTexturedBitmap_857();
	this.instance_58.parent = this;
	this.instance_58.setTransform(-54.8,-44.1,0.5,0.5);

	this.instance_59 = new lib.CachedTexturedBitmap_856();
	this.instance_59.parent = this;
	this.instance_59.setTransform(-54.6,-44,0.5,0.5);

	this.instance_60 = new lib.CachedTexturedBitmap_855();
	this.instance_60.parent = this;
	this.instance_60.setTransform(-16.1,7.95,0.5,0.5);

	this.instance_61 = new lib.CachedTexturedBitmap_864();
	this.instance_61.parent = this;
	this.instance_61.setTransform(-43,-33.9,0.5,0.5);

	this.instance_62 = new lib.CachedTexturedBitmap_863();
	this.instance_62.parent = this;
	this.instance_62.setTransform(-42.85,-33.7,0.5,0.5);

	this.instance_63 = new lib.CachedTexturedBitmap_862();
	this.instance_63.parent = this;
	this.instance_63.setTransform(-54.95,-43.7,0.5,0.5);

	this.instance_64 = new lib.CachedTexturedBitmap_861();
	this.instance_64.parent = this;
	this.instance_64.setTransform(-54.75,-43.6,0.5,0.5);

	this.instance_65 = new lib.CachedTexturedBitmap_860();
	this.instance_65.parent = this;
	this.instance_65.setTransform(-14.8,7.25,0.5,0.5);

	this.instance_66 = new lib.CachedTexturedBitmap_869();
	this.instance_66.parent = this;
	this.instance_66.setTransform(-42.8,-33.85,0.5,0.5);

	this.instance_67 = new lib.CachedTexturedBitmap_868();
	this.instance_67.parent = this;
	this.instance_67.setTransform(-42.65,-33.6,0.5,0.5);

	this.instance_68 = new lib.CachedTexturedBitmap_867();
	this.instance_68.parent = this;
	this.instance_68.setTransform(-55.1,-43.25,0.5,0.5);

	this.instance_69 = new lib.CachedTexturedBitmap_866();
	this.instance_69.parent = this;
	this.instance_69.setTransform(-54.95,-43.15,0.5,0.5);

	this.instance_70 = new lib.CachedTexturedBitmap_865();
	this.instance_70.parent = this;
	this.instance_70.setTransform(-13.5,6.55,0.5,0.5);

	this.instance_71 = new lib.CachedTexturedBitmap_874();
	this.instance_71.parent = this;
	this.instance_71.setTransform(-42.6,-33.75,0.5,0.5);

	this.instance_72 = new lib.CachedTexturedBitmap_873();
	this.instance_72.parent = this;
	this.instance_72.setTransform(-42.45,-33.55,0.5,0.5);

	this.instance_73 = new lib.CachedTexturedBitmap_872();
	this.instance_73.parent = this;
	this.instance_73.setTransform(-55.25,-42.8,0.5,0.5);

	this.instance_74 = new lib.CachedTexturedBitmap_871();
	this.instance_74.parent = this;
	this.instance_74.setTransform(-55.05,-42.75,0.5,0.5);

	this.instance_75 = new lib.CachedTexturedBitmap_870();
	this.instance_75.parent = this;
	this.instance_75.setTransform(-12.2,5.8,0.5,0.5);

	this.instance_76 = new lib.CachedTexturedBitmap_879();
	this.instance_76.parent = this;
	this.instance_76.setTransform(-42.4,-33.7,0.5,0.5);

	this.instance_77 = new lib.CachedTexturedBitmap_878();
	this.instance_77.parent = this;
	this.instance_77.setTransform(-42.25,-33.5,0.5,0.5);

	this.instance_78 = new lib.CachedTexturedBitmap_877();
	this.instance_78.parent = this;
	this.instance_78.setTransform(-55.4,-42.3,0.5,0.5);

	this.instance_79 = new lib.CachedTexturedBitmap_876();
	this.instance_79.parent = this;
	this.instance_79.setTransform(-55.2,-42.25,0.5,0.5);

	this.instance_80 = new lib.CachedTexturedBitmap_875();
	this.instance_80.parent = this;
	this.instance_80.setTransform(-10.95,5.05,0.5,0.5);

	this.instance_81 = new lib.CachedTexturedBitmap_884();
	this.instance_81.parent = this;
	this.instance_81.setTransform(-42.2,-33.65,0.5,0.5);

	this.instance_82 = new lib.CachedTexturedBitmap_883();
	this.instance_82.parent = this;
	this.instance_82.setTransform(-42.05,-33.45,0.5,0.5);

	this.instance_83 = new lib.CachedTexturedBitmap_882();
	this.instance_83.parent = this;
	this.instance_83.setTransform(-55.5,-41.85,0.5,0.5);

	this.instance_84 = new lib.CachedTexturedBitmap_881();
	this.instance_84.parent = this;
	this.instance_84.setTransform(-55.3,-41.75,0.5,0.5);

	this.instance_85 = new lib.CachedTexturedBitmap_880();
	this.instance_85.parent = this;
	this.instance_85.setTransform(-9.65,4.25,0.5,0.5);

	this.instance_86 = new lib.CachedTexturedBitmap_889();
	this.instance_86.parent = this;
	this.instance_86.setTransform(-42,-33.6,0.5,0.5);

	this.instance_87 = new lib.CachedTexturedBitmap_888();
	this.instance_87.parent = this;
	this.instance_87.setTransform(-41.85,-33.4,0.5,0.5);

	this.instance_88 = new lib.CachedTexturedBitmap_887();
	this.instance_88.parent = this;
	this.instance_88.setTransform(-55.6,-41.4,0.5,0.5);

	this.instance_89 = new lib.CachedTexturedBitmap_886();
	this.instance_89.parent = this;
	this.instance_89.setTransform(-55.4,-41.3,0.5,0.5);

	this.instance_90 = new lib.CachedTexturedBitmap_885();
	this.instance_90.parent = this;
	this.instance_90.setTransform(-8.45,3.45,0.5,0.5);

	this.instance_91 = new lib.CachedTexturedBitmap_894();
	this.instance_91.parent = this;
	this.instance_91.setTransform(-41.8,-33.55,0.5,0.5);

	this.instance_92 = new lib.CachedTexturedBitmap_893();
	this.instance_92.parent = this;
	this.instance_92.setTransform(-41.7,-33.35,0.5,0.5);

	this.instance_93 = new lib.CachedTexturedBitmap_892();
	this.instance_93.parent = this;
	this.instance_93.setTransform(-55.7,-40.95,0.5,0.5);

	this.instance_94 = new lib.CachedTexturedBitmap_891();
	this.instance_94.parent = this;
	this.instance_94.setTransform(-55.5,-40.85,0.5,0.5);

	this.instance_95 = new lib.CachedTexturedBitmap_890();
	this.instance_95.parent = this;
	this.instance_95.setTransform(-7.25,2.65,0.5,0.5);

	this.instance_96 = new lib.CachedTexturedBitmap_899();
	this.instance_96.parent = this;
	this.instance_96.setTransform(-41.65,-33.55,0.5,0.5);

	this.instance_97 = new lib.CachedTexturedBitmap_898();
	this.instance_97.parent = this;
	this.instance_97.setTransform(-41.45,-33.3,0.5,0.5);

	this.instance_98 = new lib.CachedTexturedBitmap_897();
	this.instance_98.parent = this;
	this.instance_98.setTransform(-55.75,-40.55,0.5,0.5);

	this.instance_99 = new lib.CachedTexturedBitmap_896();
	this.instance_99.parent = this;
	this.instance_99.setTransform(-55.55,-40.4,0.5,0.5);

	this.instance_100 = new lib.CachedTexturedBitmap_895();
	this.instance_100.parent = this;
	this.instance_100.setTransform(-6.05,1.85,0.5,0.5);

	this.instance_101 = new lib.CachedTexturedBitmap_904();
	this.instance_101.parent = this;
	this.instance_101.setTransform(-41.45,-33.5,0.5,0.5);

	this.instance_102 = new lib.CachedTexturedBitmap_903();
	this.instance_102.parent = this;
	this.instance_102.setTransform(-41.3,-33.3,0.5,0.5);

	this.instance_103 = new lib.CachedTexturedBitmap_902();
	this.instance_103.parent = this;
	this.instance_103.setTransform(-55.8,-40.1,0.5,0.5);

	this.instance_104 = new lib.CachedTexturedBitmap_901();
	this.instance_104.parent = this;
	this.instance_104.setTransform(-55.6,-39.95,0.5,0.5);

	this.instance_105 = new lib.CachedTexturedBitmap_900();
	this.instance_105.parent = this;
	this.instance_105.setTransform(-4.9,1.1,0.5,0.5);

	this.instance_106 = new lib.CachedTexturedBitmap_909();
	this.instance_106.parent = this;
	this.instance_106.setTransform(-41.25,-33.45,0.5,0.5);

	this.instance_107 = new lib.CachedTexturedBitmap_908();
	this.instance_107.parent = this;
	this.instance_107.setTransform(-41.15,-33.25,0.5,0.5);

	this.instance_108 = new lib.CachedTexturedBitmap_907();
	this.instance_108.parent = this;
	this.instance_108.setTransform(-55.8,-39.7,0.5,0.5);

	this.instance_109 = new lib.CachedTexturedBitmap_906();
	this.instance_109.parent = this;
	this.instance_109.setTransform(-55.6,-39.55,0.5,0.5);

	this.instance_110 = new lib.CachedTexturedBitmap_905();
	this.instance_110.parent = this;
	this.instance_110.setTransform(-3.85,0.4,0.5,0.5);

	this.instance_111 = new lib.CachedTexturedBitmap_914();
	this.instance_111.parent = this;
	this.instance_111.setTransform(-41.1,-33.45,0.5,0.5);

	this.instance_112 = new lib.CachedTexturedBitmap_913();
	this.instance_112.parent = this;
	this.instance_112.setTransform(-40.9,-33.25,0.5,0.5);

	this.instance_113 = new lib.CachedTexturedBitmap_912();
	this.instance_113.parent = this;
	this.instance_113.setTransform(-55.85,-39.35,0.5,0.5);

	this.instance_114 = new lib.CachedTexturedBitmap_911();
	this.instance_114.parent = this;
	this.instance_114.setTransform(-55.65,-39.2,0.5,0.5);

	this.instance_115 = new lib.CachedTexturedBitmap_910();
	this.instance_115.parent = this;
	this.instance_115.setTransform(-2.75,-0.3,0.5,0.5);

	this.instance_116 = new lib.CachedTexturedBitmap_919();
	this.instance_116.parent = this;
	this.instance_116.setTransform(-40.9,-33.45,0.5,0.5);

	this.instance_117 = new lib.CachedTexturedBitmap_918();
	this.instance_117.parent = this;
	this.instance_117.setTransform(-40.75,-33.2,0.5,0.5);

	this.instance_118 = new lib.CachedTexturedBitmap_917();
	this.instance_118.parent = this;
	this.instance_118.setTransform(-55.85,-39,0.5,0.5);

	this.instance_119 = new lib.CachedTexturedBitmap_916();
	this.instance_119.parent = this;
	this.instance_119.setTransform(-55.65,-38.8,0.5,0.5);

	this.instance_120 = new lib.CachedTexturedBitmap_915();
	this.instance_120.parent = this;
	this.instance_120.setTransform(-1.7,-1,0.5,0.5);

	this.instance_121 = new lib.CachedTexturedBitmap_924();
	this.instance_121.parent = this;
	this.instance_121.setTransform(-40.75,-33.45,0.5,0.5);

	this.instance_122 = new lib.CachedTexturedBitmap_923();
	this.instance_122.parent = this;
	this.instance_122.setTransform(-40.6,-33.2,0.5,0.5);

	this.instance_123 = new lib.CachedTexturedBitmap_922();
	this.instance_123.parent = this;
	this.instance_123.setTransform(-55.8,-38.7,0.5,0.5);

	this.instance_124 = new lib.CachedTexturedBitmap_921();
	this.instance_124.parent = this;
	this.instance_124.setTransform(-55.6,-38.4,0.5,0.5);

	this.instance_125 = new lib.CachedTexturedBitmap_920();
	this.instance_125.parent = this;
	this.instance_125.setTransform(-0.7,-1.65,0.5,0.5);

	this.instance_126 = new lib.CachedTexturedBitmap_929();
	this.instance_126.parent = this;
	this.instance_126.setTransform(-40.6,-33.45,0.5,0.5);

	this.instance_127 = new lib.CachedTexturedBitmap_928();
	this.instance_127.parent = this;
	this.instance_127.setTransform(-40.45,-33.2,0.5,0.5);

	this.instance_128 = new lib.CachedTexturedBitmap_927();
	this.instance_128.parent = this;
	this.instance_128.setTransform(-55.8,-38.45,0.5,0.5);

	this.instance_129 = new lib.CachedTexturedBitmap_926();
	this.instance_129.parent = this;
	this.instance_129.setTransform(-55.6,-38.25,0.5,0.5);

	this.instance_130 = new lib.CachedTexturedBitmap_925();
	this.instance_130.parent = this;
	this.instance_130.setTransform(0.25,-2.3,0.5,0.5);

	this.instance_131 = new lib.CachedTexturedBitmap_934();
	this.instance_131.parent = this;
	this.instance_131.setTransform(-40.65,-33.45,0.5,0.5);

	this.instance_132 = new lib.CachedTexturedBitmap_933();
	this.instance_132.parent = this;
	this.instance_132.setTransform(-40.5,-33.2,0.5,0.5);

	this.instance_133 = new lib.CachedTexturedBitmap_932();
	this.instance_133.parent = this;
	this.instance_133.setTransform(-55.8,-38.55,0.5,0.5);

	this.instance_134 = new lib.CachedTexturedBitmap_931();
	this.instance_134.parent = this;
	this.instance_134.setTransform(-55.6,-38.3,0.5,0.5);

	this.instance_135 = new lib.CachedTexturedBitmap_930();
	this.instance_135.parent = this;
	this.instance_135.setTransform(-0.15,-2.05,0.5,0.5);

	this.instance_136 = new lib.CachedTexturedBitmap_939();
	this.instance_136.parent = this;
	this.instance_136.setTransform(-40.75,-33.4,0.5,0.5);

	this.instance_137 = new lib.CachedTexturedBitmap_938();
	this.instance_137.parent = this;
	this.instance_137.setTransform(-40.6,-33.2,0.5,0.5);

	this.instance_138 = new lib.CachedTexturedBitmap_937();
	this.instance_138.parent = this;
	this.instance_138.setTransform(-55.8,-38.65,0.5,0.5);

	this.instance_139 = new lib.CachedTexturedBitmap_936();
	this.instance_139.parent = this;
	this.instance_139.setTransform(-55.6,-38.4,0.5,0.5);

	this.instance_140 = new lib.CachedTexturedBitmap_935();
	this.instance_140.parent = this;
	this.instance_140.setTransform(-0.6,-1.8,0.5,0.5);

	this.instance_141 = new lib.CachedTexturedBitmap_944();
	this.instance_141.parent = this;
	this.instance_141.setTransform(-40.8,-33.45,0.5,0.5);

	this.instance_142 = new lib.CachedTexturedBitmap_943();
	this.instance_142.parent = this;
	this.instance_142.setTransform(-40.65,-33.2,0.5,0.5);

	this.instance_143 = new lib.CachedTexturedBitmap_942();
	this.instance_143.parent = this;
	this.instance_143.setTransform(-55.8,-38.8,0.5,0.5);

	this.instance_144 = new lib.CachedTexturedBitmap_941();
	this.instance_144.parent = this;
	this.instance_144.setTransform(-55.65,-38.6,0.5,0.5);

	this.instance_145 = new lib.CachedTexturedBitmap_940();
	this.instance_145.parent = this;
	this.instance_145.setTransform(-1.05,-1.5,0.5,0.5);

	this.instance_146 = new lib.CachedTexturedBitmap_949();
	this.instance_146.parent = this;
	this.instance_146.setTransform(-40.9,-33.4,0.5,0.5);

	this.instance_147 = new lib.CachedTexturedBitmap_948();
	this.instance_147.parent = this;
	this.instance_147.setTransform(-40.75,-33.2,0.5,0.5);

	this.instance_148 = new lib.CachedTexturedBitmap_947();
	this.instance_148.parent = this;
	this.instance_148.setTransform(-55.85,-38.95,0.5,0.5);

	this.instance_149 = new lib.CachedTexturedBitmap_946();
	this.instance_149.parent = this;
	this.instance_149.setTransform(-55.65,-38.75,0.5,0.5);

	this.instance_150 = new lib.CachedTexturedBitmap_945();
	this.instance_150.parent = this;
	this.instance_150.setTransform(-1.5,-1.2,0.5,0.5);

	this.instance_151 = new lib.CachedTexturedBitmap_954();
	this.instance_151.parent = this;
	this.instance_151.setTransform(-40.95,-33.45,0.5,0.5);

	this.instance_152 = new lib.CachedTexturedBitmap_953();
	this.instance_152.parent = this;
	this.instance_152.setTransform(-40.8,-33.25,0.5,0.5);

	this.instance_153 = new lib.CachedTexturedBitmap_952();
	this.instance_153.parent = this;
	this.instance_153.setTransform(-55.85,-39.05,0.5,0.5);

	this.instance_154 = new lib.CachedTexturedBitmap_951();
	this.instance_154.parent = this;
	this.instance_154.setTransform(-55.65,-38.9,0.5,0.5);

	this.instance_155 = new lib.CachedTexturedBitmap_950();
	this.instance_155.parent = this;
	this.instance_155.setTransform(-1.9,-0.95,0.5,0.5);

	this.instance_156 = new lib.CachedTexturedBitmap_959();
	this.instance_156.parent = this;
	this.instance_156.setTransform(-41,-33.45,0.5,0.5);

	this.instance_157 = new lib.CachedTexturedBitmap_958();
	this.instance_157.parent = this;
	this.instance_157.setTransform(-40.85,-33.25,0.5,0.5);

	this.instance_158 = new lib.CachedTexturedBitmap_957();
	this.instance_158.parent = this;
	this.instance_158.setTransform(-55.85,-39.25,0.5,0.5);

	this.instance_159 = new lib.CachedTexturedBitmap_956();
	this.instance_159.parent = this;
	this.instance_159.setTransform(-55.65,-39.05,0.5,0.5);

	this.instance_160 = new lib.CachedTexturedBitmap_955();
	this.instance_160.parent = this;
	this.instance_160.setTransform(-2.35,-0.65,0.5,0.5);

	this.instance_161 = new lib.CachedTexturedBitmap_964();
	this.instance_161.parent = this;
	this.instance_161.setTransform(-41.1,-33.45,0.5,0.5);

	this.instance_162 = new lib.CachedTexturedBitmap_963();
	this.instance_162.parent = this;
	this.instance_162.setTransform(-40.95,-33.25,0.5,0.5);

	this.instance_163 = new lib.CachedTexturedBitmap_962();
	this.instance_163.parent = this;
	this.instance_163.setTransform(-55.85,-39.35,0.5,0.5);

	this.instance_164 = new lib.CachedTexturedBitmap_961();
	this.instance_164.parent = this;
	this.instance_164.setTransform(-55.65,-39.2,0.5,0.5);

	this.instance_165 = new lib.CachedTexturedBitmap_960();
	this.instance_165.parent = this;
	this.instance_165.setTransform(-2.85,-0.3,0.5,0.5);

	this.instance_166 = new lib.CachedTexturedBitmap_969();
	this.instance_166.parent = this;
	this.instance_166.setTransform(-41.15,-33.5,0.5,0.5);

	this.instance_167 = new lib.CachedTexturedBitmap_968();
	this.instance_167.parent = this;
	this.instance_167.setTransform(-41,-33.25,0.5,0.5);

	this.instance_168 = new lib.CachedTexturedBitmap_967();
	this.instance_168.parent = this;
	this.instance_168.setTransform(-55.8,-39.55,0.5,0.5);

	this.instance_169 = new lib.CachedTexturedBitmap_966();
	this.instance_169.parent = this;
	this.instance_169.setTransform(-55.65,-39.4,0.5,0.5);

	this.instance_170 = new lib.CachedTexturedBitmap_965();
	this.instance_170.parent = this;
	this.instance_170.setTransform(-3.3,0,0.5,0.5);

	this.instance_171 = new lib.CachedTexturedBitmap_974();
	this.instance_171.parent = this;
	this.instance_171.setTransform(-41.25,-33.45,0.5,0.5);

	this.instance_172 = new lib.CachedTexturedBitmap_973();
	this.instance_172.parent = this;
	this.instance_172.setTransform(-41.15,-33.25,0.5,0.5);

	this.instance_173 = new lib.CachedTexturedBitmap_972();
	this.instance_173.parent = this;
	this.instance_173.setTransform(-55.8,-39.7,0.5,0.5);

	this.instance_174 = new lib.CachedTexturedBitmap_971();
	this.instance_174.parent = this;
	this.instance_174.setTransform(-55.6,-39.55,0.5,0.5);

	this.instance_175 = new lib.CachedTexturedBitmap_970();
	this.instance_175.parent = this;
	this.instance_175.setTransform(-3.8,0.25,0.5,0.5);

	this.instance_176 = new lib.CachedTexturedBitmap_979();
	this.instance_176.parent = this;
	this.instance_176.setTransform(-41.35,-33.5,0.5,0.5);

	this.instance_177 = new lib.CachedTexturedBitmap_978();
	this.instance_177.parent = this;
	this.instance_177.setTransform(-41.2,-33.3,0.5,0.5);

	this.instance_178 = new lib.CachedTexturedBitmap_977();
	this.instance_178.parent = this;
	this.instance_178.setTransform(-55.8,-39.85,0.5,0.5);

	this.instance_179 = new lib.CachedTexturedBitmap_976();
	this.instance_179.parent = this;
	this.instance_179.setTransform(-55.6,-39.75,0.5,0.5);

	this.instance_180 = new lib.CachedTexturedBitmap_975();
	this.instance_180.parent = this;
	this.instance_180.setTransform(-4.25,0.6,0.5,0.5);

	this.instance_181 = new lib.CachedTexturedBitmap_984();
	this.instance_181.parent = this;
	this.instance_181.setTransform(-41.45,-33.5,0.5,0.5);

	this.instance_182 = new lib.CachedTexturedBitmap_983();
	this.instance_182.parent = this;
	this.instance_182.setTransform(-41.3,-33.3,0.5,0.5);

	this.instance_183 = new lib.CachedTexturedBitmap_982();
	this.instance_183.parent = this;
	this.instance_183.setTransform(-55.8,-40.05,0.5,0.5);

	this.instance_184 = new lib.CachedTexturedBitmap_981();
	this.instance_184.parent = this;
	this.instance_184.setTransform(-55.6,-39.95,0.5,0.5);

	this.instance_185 = new lib.CachedTexturedBitmap_980();
	this.instance_185.parent = this;
	this.instance_185.setTransform(-4.8,0.9,0.5,0.5);

	this.instance_186 = new lib.CachedTexturedBitmap_989();
	this.instance_186.parent = this;
	this.instance_186.setTransform(-41.5,-33.5,0.5,0.5);

	this.instance_187 = new lib.CachedTexturedBitmap_988();
	this.instance_187.parent = this;
	this.instance_187.setTransform(-41.35,-33.3,0.5,0.5);

	this.instance_188 = new lib.CachedTexturedBitmap_987();
	this.instance_188.parent = this;
	this.instance_188.setTransform(-55.75,-40.25,0.5,0.5);

	this.instance_189 = new lib.CachedTexturedBitmap_986();
	this.instance_189.parent = this;
	this.instance_189.setTransform(-55.6,-40.15,0.5,0.5);

	this.instance_190 = new lib.CachedTexturedBitmap_985();
	this.instance_190.parent = this;
	this.instance_190.setTransform(-5.25,1.25,0.5,0.5);

	this.instance_191 = new lib.CachedTexturedBitmap_994();
	this.instance_191.parent = this;
	this.instance_191.setTransform(-41.6,-33.5,0.5,0.5);

	this.instance_192 = new lib.CachedTexturedBitmap_993();
	this.instance_192.parent = this;
	this.instance_192.setTransform(-41.45,-33.3,0.5,0.5);

	this.instance_193 = new lib.CachedTexturedBitmap_992();
	this.instance_193.parent = this;
	this.instance_193.setTransform(-55.75,-40.45,0.5,0.5);

	this.instance_194 = new lib.CachedTexturedBitmap_991();
	this.instance_194.parent = this;
	this.instance_194.setTransform(-55.55,-40.3,0.5,0.5);

	this.instance_195 = new lib.CachedTexturedBitmap_990();
	this.instance_195.parent = this;
	this.instance_195.setTransform(-5.8,1.6,0.5,0.5);

	this.instance_196 = new lib.CachedTexturedBitmap_999();
	this.instance_196.parent = this;
	this.instance_196.setTransform(-41.7,-33.55,0.5,0.5);

	this.instance_197 = new lib.CachedTexturedBitmap_998();
	this.instance_197.parent = this;
	this.instance_197.setTransform(-41.5,-33.35,0.5,0.5);

	this.instance_198 = new lib.CachedTexturedBitmap_997();
	this.instance_198.parent = this;
	this.instance_198.setTransform(-55.7,-40.65,0.5,0.5);

	this.instance_199 = new lib.CachedTexturedBitmap_996();
	this.instance_199.parent = this;
	this.instance_199.setTransform(-55.55,-40.55,0.5,0.5);

	this.instance_200 = new lib.CachedTexturedBitmap_995();
	this.instance_200.parent = this;
	this.instance_200.setTransform(-6.35,1.95,0.5,0.5);

	this.instance_201 = new lib.CachedTexturedBitmap_1004();
	this.instance_201.parent = this;
	this.instance_201.setTransform(-41.75,-33.55,0.5,0.5);

	this.instance_202 = new lib.CachedTexturedBitmap_1003();
	this.instance_202.parent = this;
	this.instance_202.setTransform(-41.65,-33.35,0.5,0.5);

	this.instance_203 = new lib.CachedTexturedBitmap_1002();
	this.instance_203.parent = this;
	this.instance_203.setTransform(-55.7,-40.85,0.5,0.5);

	this.instance_204 = new lib.CachedTexturedBitmap_1001();
	this.instance_204.parent = this;
	this.instance_204.setTransform(-55.5,-40.75,0.5,0.5);

	this.instance_205 = new lib.CachedTexturedBitmap_1000();
	this.instance_205.parent = this;
	this.instance_205.setTransform(-6.9,2.3,0.5,0.5);

	this.instance_206 = new lib.CachedTexturedBitmap_1009();
	this.instance_206.parent = this;
	this.instance_206.setTransform(-41.85,-33.6,0.5,0.5);

	this.instance_207 = new lib.CachedTexturedBitmap_1008();
	this.instance_207.parent = this;
	this.instance_207.setTransform(-41.75,-33.35,0.5,0.5);

	this.instance_208 = new lib.CachedTexturedBitmap_1007();
	this.instance_208.parent = this;
	this.instance_208.setTransform(-55.65,-41.05,0.5,0.5);

	this.instance_209 = new lib.CachedTexturedBitmap_1006();
	this.instance_209.parent = this;
	this.instance_209.setTransform(-55.45,-40.95,0.5,0.5);

	this.instance_210 = new lib.CachedTexturedBitmap_1005();
	this.instance_210.parent = this;
	this.instance_210.setTransform(-7.45,2.65,0.5,0.5);

	this.instance_211 = new lib.CachedTexturedBitmap_1014();
	this.instance_211.parent = this;
	this.instance_211.setTransform(-41.95,-33.6,0.5,0.5);

	this.instance_212 = new lib.CachedTexturedBitmap_1013();
	this.instance_212.parent = this;
	this.instance_212.setTransform(-41.8,-33.4,0.5,0.5);

	this.instance_213 = new lib.CachedTexturedBitmap_1012();
	this.instance_213.parent = this;
	this.instance_213.setTransform(-55.65,-41.25,0.5,0.5);

	this.instance_214 = new lib.CachedTexturedBitmap_1011();
	this.instance_214.parent = this;
	this.instance_214.setTransform(-55.45,-41.15,0.5,0.5);

	this.instance_215 = new lib.CachedTexturedBitmap_1010();
	this.instance_215.parent = this;
	this.instance_215.setTransform(-7.95,3,0.5,0.5);

	this.instance_216 = new lib.CachedTexturedBitmap_1019();
	this.instance_216.parent = this;
	this.instance_216.setTransform(-42,-33.6,0.5,0.5);

	this.instance_217 = new lib.CachedTexturedBitmap_1018();
	this.instance_217.parent = this;
	this.instance_217.setTransform(-41.9,-33.4,0.5,0.5);

	this.instance_218 = new lib.CachedTexturedBitmap_1017();
	this.instance_218.parent = this;
	this.instance_218.setTransform(-55.6,-41.5,0.5,0.5);

	this.instance_219 = new lib.CachedTexturedBitmap_1016();
	this.instance_219.parent = this;
	this.instance_219.setTransform(-55.4,-41.35,0.5,0.5);

	this.instance_220 = new lib.CachedTexturedBitmap_1015();
	this.instance_220.parent = this;
	this.instance_220.setTransform(-8.5,3.4,0.5,0.5);

	this.instance_221 = new lib.CachedTexturedBitmap_1024();
	this.instance_221.parent = this;
	this.instance_221.setTransform(-42.1,-33.65,0.5,0.5);

	this.instance_222 = new lib.CachedTexturedBitmap_1023();
	this.instance_222.parent = this;
	this.instance_222.setTransform(-41.95,-33.45,0.5,0.5);

	this.instance_223 = new lib.CachedTexturedBitmap_1022();
	this.instance_223.parent = this;
	this.instance_223.setTransform(-55.55,-41.7,0.5,0.5);

	this.instance_224 = new lib.CachedTexturedBitmap_1021();
	this.instance_224.parent = this;
	this.instance_224.setTransform(-55.35,-41.6,0.5,0.5);

	this.instance_225 = new lib.CachedTexturedBitmap_1020();
	this.instance_225.parent = this;
	this.instance_225.setTransform(-9.1,3.75,0.5,0.5);

	this.instance_226 = new lib.CachedTexturedBitmap_1029();
	this.instance_226.parent = this;
	this.instance_226.setTransform(-42.25,-33.65,0.5,0.5);

	this.instance_227 = new lib.CachedTexturedBitmap_1028();
	this.instance_227.parent = this;
	this.instance_227.setTransform(-42.1,-33.45,0.5,0.5);

	this.instance_228 = new lib.CachedTexturedBitmap_1027();
	this.instance_228.parent = this;
	this.instance_228.setTransform(-55.5,-41.9,0.5,0.5);

	this.instance_229 = new lib.CachedTexturedBitmap_1026();
	this.instance_229.parent = this;
	this.instance_229.setTransform(-55.3,-41.8,0.5,0.5);

	this.instance_230 = new lib.CachedTexturedBitmap_1025();
	this.instance_230.parent = this;
	this.instance_230.setTransform(-9.65,4.1,0.5,0.5);

	this.instance_231 = new lib.CachedTexturedBitmap_1034();
	this.instance_231.parent = this;
	this.instance_231.setTransform(-42.3,-33.7,0.5,0.5);

	this.instance_232 = new lib.CachedTexturedBitmap_1033();
	this.instance_232.parent = this;
	this.instance_232.setTransform(-42.2,-33.5,0.5,0.5);

	this.instance_233 = new lib.CachedTexturedBitmap_1032();
	this.instance_233.parent = this;
	this.instance_233.setTransform(-55.45,-42.15,0.5,0.5);

	this.instance_234 = new lib.CachedTexturedBitmap_1031();
	this.instance_234.parent = this;
	this.instance_234.setTransform(-55.25,-42.05,0.5,0.5);

	this.instance_235 = new lib.CachedTexturedBitmap_1030();
	this.instance_235.parent = this;
	this.instance_235.setTransform(-10.2,4.5,0.5,0.5);

	this.instance_236 = new lib.CachedTexturedBitmap_1039();
	this.instance_236.parent = this;
	this.instance_236.setTransform(-42.4,-33.7,0.5,0.5);

	this.instance_237 = new lib.CachedTexturedBitmap_1038();
	this.instance_237.parent = this;
	this.instance_237.setTransform(-42.25,-33.5,0.5,0.5);

	this.instance_238 = new lib.CachedTexturedBitmap_1037();
	this.instance_238.parent = this;
	this.instance_238.setTransform(-55.4,-42.35,0.5,0.5);

	this.instance_239 = new lib.CachedTexturedBitmap_1036();
	this.instance_239.parent = this;
	this.instance_239.setTransform(-55.2,-42.25,0.5,0.5);

	this.instance_240 = new lib.CachedTexturedBitmap_1035();
	this.instance_240.parent = this;
	this.instance_240.setTransform(-10.8,4.9,0.5,0.5);

	this.instance_241 = new lib.CachedTexturedBitmap_1044();
	this.instance_241.parent = this;
	this.instance_241.setTransform(-42.55,-33.75,0.5,0.5);

	this.instance_242 = new lib.CachedTexturedBitmap_1043();
	this.instance_242.parent = this;
	this.instance_242.setTransform(-42.4,-33.55,0.5,0.5);

	this.instance_243 = new lib.CachedTexturedBitmap_1042();
	this.instance_243.parent = this;
	this.instance_243.setTransform(-55.3,-42.55,0.5,0.5);

	this.instance_244 = new lib.CachedTexturedBitmap_1041();
	this.instance_244.parent = this;
	this.instance_244.setTransform(-55.15,-42.5,0.5,0.5);

	this.instance_245 = new lib.CachedTexturedBitmap_1040();
	this.instance_245.parent = this;
	this.instance_245.setTransform(-11.45,5.25,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},1).to({state:[{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6}]},23).to({state:[{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11}]},1).to({state:[{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16}]},1).to({state:[{t:this.instance_25},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21}]},1).to({state:[{t:this.instance_30},{t:this.instance_29},{t:this.instance_28},{t:this.instance_27},{t:this.instance_26}]},1).to({state:[{t:this.instance_35},{t:this.instance_34},{t:this.instance_33},{t:this.instance_32},{t:this.instance_31}]},1).to({state:[{t:this.instance_40},{t:this.instance_39},{t:this.instance_38},{t:this.instance_37},{t:this.instance_36}]},1).to({state:[{t:this.instance_45},{t:this.instance_44},{t:this.instance_43},{t:this.instance_42},{t:this.instance_41}]},1).to({state:[{t:this.instance_50},{t:this.instance_49},{t:this.instance_48},{t:this.instance_47},{t:this.instance_46}]},1).to({state:[{t:this.instance_55},{t:this.instance_54},{t:this.instance_53},{t:this.instance_52},{t:this.instance_51}]},1).to({state:[{t:this.instance_60},{t:this.instance_59},{t:this.instance_58},{t:this.instance_57},{t:this.instance_56}]},1).to({state:[{t:this.instance_65},{t:this.instance_64},{t:this.instance_63},{t:this.instance_62},{t:this.instance_61}]},1).to({state:[{t:this.instance_70},{t:this.instance_69},{t:this.instance_68},{t:this.instance_67},{t:this.instance_66}]},1).to({state:[{t:this.instance_75},{t:this.instance_74},{t:this.instance_73},{t:this.instance_72},{t:this.instance_71}]},1).to({state:[{t:this.instance_80},{t:this.instance_79},{t:this.instance_78},{t:this.instance_77},{t:this.instance_76}]},1).to({state:[{t:this.instance_85},{t:this.instance_84},{t:this.instance_83},{t:this.instance_82},{t:this.instance_81}]},1).to({state:[{t:this.instance_90},{t:this.instance_89},{t:this.instance_88},{t:this.instance_87},{t:this.instance_86}]},1).to({state:[{t:this.instance_95},{t:this.instance_94},{t:this.instance_93},{t:this.instance_92},{t:this.instance_91}]},1).to({state:[{t:this.instance_100},{t:this.instance_99},{t:this.instance_98},{t:this.instance_97},{t:this.instance_96}]},1).to({state:[{t:this.instance_105},{t:this.instance_104},{t:this.instance_103},{t:this.instance_102},{t:this.instance_101}]},1).to({state:[{t:this.instance_110},{t:this.instance_109},{t:this.instance_108},{t:this.instance_107},{t:this.instance_106}]},1).to({state:[{t:this.instance_115},{t:this.instance_114},{t:this.instance_113},{t:this.instance_112},{t:this.instance_111}]},1).to({state:[{t:this.instance_120},{t:this.instance_119},{t:this.instance_118},{t:this.instance_117},{t:this.instance_116}]},1).to({state:[{t:this.instance_125},{t:this.instance_124},{t:this.instance_123},{t:this.instance_122},{t:this.instance_121}]},1).to({state:[{t:this.instance_130},{t:this.instance_129},{t:this.instance_128},{t:this.instance_127},{t:this.instance_126}]},1).to({state:[{t:this.instance_135},{t:this.instance_134},{t:this.instance_133},{t:this.instance_132},{t:this.instance_131}]},1).to({state:[{t:this.instance_140},{t:this.instance_139},{t:this.instance_138},{t:this.instance_137},{t:this.instance_136}]},1).to({state:[{t:this.instance_145},{t:this.instance_144},{t:this.instance_143},{t:this.instance_142},{t:this.instance_141}]},1).to({state:[{t:this.instance_150},{t:this.instance_149},{t:this.instance_148},{t:this.instance_147},{t:this.instance_146}]},1).to({state:[{t:this.instance_155},{t:this.instance_154},{t:this.instance_153},{t:this.instance_152},{t:this.instance_151}]},1).to({state:[{t:this.instance_160},{t:this.instance_159},{t:this.instance_158},{t:this.instance_157},{t:this.instance_156}]},1).to({state:[{t:this.instance_165},{t:this.instance_164},{t:this.instance_163},{t:this.instance_162},{t:this.instance_161}]},1).to({state:[{t:this.instance_170},{t:this.instance_169},{t:this.instance_168},{t:this.instance_167},{t:this.instance_166}]},1).to({state:[{t:this.instance_175},{t:this.instance_174},{t:this.instance_173},{t:this.instance_172},{t:this.instance_171}]},1).to({state:[{t:this.instance_180},{t:this.instance_179},{t:this.instance_178},{t:this.instance_177},{t:this.instance_176}]},1).to({state:[{t:this.instance_185},{t:this.instance_184},{t:this.instance_183},{t:this.instance_182},{t:this.instance_181}]},1).to({state:[{t:this.instance_190},{t:this.instance_189},{t:this.instance_188},{t:this.instance_187},{t:this.instance_186}]},1).to({state:[{t:this.instance_195},{t:this.instance_194},{t:this.instance_193},{t:this.instance_192},{t:this.instance_191}]},1).to({state:[{t:this.instance_200},{t:this.instance_199},{t:this.instance_198},{t:this.instance_197},{t:this.instance_196}]},1).to({state:[{t:this.instance_205},{t:this.instance_204},{t:this.instance_203},{t:this.instance_202},{t:this.instance_201}]},1).to({state:[{t:this.instance_210},{t:this.instance_209},{t:this.instance_208},{t:this.instance_207},{t:this.instance_206}]},1).to({state:[{t:this.instance_215},{t:this.instance_214},{t:this.instance_213},{t:this.instance_212},{t:this.instance_211}]},1).to({state:[{t:this.instance_220},{t:this.instance_219},{t:this.instance_218},{t:this.instance_217},{t:this.instance_216}]},1).to({state:[{t:this.instance_225},{t:this.instance_224},{t:this.instance_223},{t:this.instance_222},{t:this.instance_221}]},1).to({state:[{t:this.instance_230},{t:this.instance_229},{t:this.instance_228},{t:this.instance_227},{t:this.instance_226}]},1).to({state:[{t:this.instance_235},{t:this.instance_234},{t:this.instance_233},{t:this.instance_232},{t:this.instance_231}]},1).to({state:[{t:this.instance_240},{t:this.instance_239},{t:this.instance_238},{t:this.instance_237},{t:this.instance_236}]},1).to({state:[{t:this.instance_245},{t:this.instance_244},{t:this.instance_243},{t:this.instance_242},{t:this.instance_241}]},1).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},1).wait(25));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-55.8,-45.3,127.6,96.1);


(lib.PuppetShape_3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.WarpedAsset_3("synched",0);
	this.instance.parent = this;

	this.instance_1 = new lib.CachedTexturedBitmap_799();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-25.05,-19.8,0.4999,0.4999);

	this.instance_2 = new lib.CachedTexturedBitmap_798();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-21.5,-16.35,0.4999,0.4999);

	this.instance_3 = new lib.CachedTexturedBitmap_797();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-18.55,-22.55,0.4999,0.4999);

	this.instance_4 = new lib.CachedTexturedBitmap_796();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-15.5,-19.2,0.4999,0.4999);

	this.instance_5 = new lib.CachedTexturedBitmap_795();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-12.2,-25.15,0.4999,0.4999);

	this.instance_6 = new lib.CachedTexturedBitmap_794();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-9.3,-22.1,0.4999,0.4999);

	this.instance_7 = new lib.CachedTexturedBitmap_793();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-5.8,-28.05,0.4999,0.4999);

	this.instance_8 = new lib.CachedTexturedBitmap_792();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-3,-24.9,0.4999,0.4999);

	this.instance_9 = new lib.CachedTexturedBitmap_783();
	this.instance_9.parent = this;
	this.instance_9.setTransform(1,-31.5,0.4999,0.4999);

	this.instance_10 = new lib.CachedTexturedBitmap_782();
	this.instance_10.parent = this;
	this.instance_10.setTransform(2.45,-27.7,0.4999,0.4999);

	this.instance_11 = new lib.CachedTexturedBitmap_789();
	this.instance_11.parent = this;
	this.instance_11.setTransform(8.95,-34.95,0.4999,0.4999);

	this.instance_12 = new lib.CachedTexturedBitmap_784();
	this.instance_12.parent = this;
	this.instance_12.setTransform(7.05,-31.1,0.4999,0.4999);

	this.instance_13 = new lib.CachedTexturedBitmap_787();
	this.instance_13.parent = this;
	this.instance_13.setTransform(14,-37.7,0.4999,0.4999);

	this.instance_14 = new lib.CachedTexturedBitmap_786();
	this.instance_14.parent = this;
	this.instance_14.setTransform(11.5,-33.85,0.4999,0.4999);

	this.instance_15 = new lib.CachedTexturedBitmap_788();
	this.instance_15.parent = this;
	this.instance_15.setTransform(7,-31.1,0.4999,0.4999);

	this.instance_16 = new lib.CachedTexturedBitmap_791();
	this.instance_16.parent = this;
	this.instance_16.setTransform(1.05,-31.55,0.4999,0.4999);

	this.instance_17 = new lib.CachedTexturedBitmap_790();
	this.instance_17.parent = this;
	this.instance_17.setTransform(2.4,-27.7,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},1).to({state:[{t:this.instance_2},{t:this.instance_1}]},11).to({state:[{t:this.instance_4},{t:this.instance_3}]},1).to({state:[{t:this.instance_6},{t:this.instance_5}]},1).to({state:[{t:this.instance_8},{t:this.instance_7}]},1).to({state:[{t:this.instance_10},{t:this.instance_9}]},1).to({state:[{t:this.instance_12},{t:this.instance_11}]},1).to({state:[{t:this.instance_14},{t:this.instance_13}]},1).to({state:[{t:this.instance_15},{t:this.instance_11}]},1).to({state:[{t:this.instance_17},{t:this.instance_16}]},1).to({state:[{t:this.instance_8},{t:this.instance_7}]},1).to({state:[{t:this.instance_6},{t:this.instance_5}]},1).to({state:[{t:this.instance_4},{t:this.instance_3}]},1).to({state:[{t:this.instance_2},{t:this.instance_1}]},1).wait(49));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-25,-37.7,48.2,57.300000000000004);


(lib.PuppetShape_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.WarpedAsset_2("synched",0);
	this.instance.parent = this;

	this.instance_1 = new lib.BMP_9280328b_df68_4d29_8964_103bfcbf756b();
	this.instance_1.parent = this;

	this.instance_2 = new lib.BMP_101f6613_7c41_40b0_ab1c_069749d8e2a0();
	this.instance_2.parent = this;

	this.instance_3 = new lib.BMP_56ba9556_8ba9_422a_a4cd_2e6359d3b493();
	this.instance_3.parent = this;

	this.instance_4 = new lib.BMP_07bfe81a_5a2a_47a9_aba6_e5acacedc168();
	this.instance_4.parent = this;

	this.instance_5 = new lib.BMP_fe7a8dcb_bf2d_4ee5_96ce_3da903d5c95a();
	this.instance_5.parent = this;

	this.instance_6 = new lib.BMP_e692f0c9_cf9d_4094_a9ed_3f81922b5ce4();
	this.instance_6.parent = this;

	this.instance_7 = new lib.BMP_3fc890df_d020_4a69_b064_4d24cfc5bc24();
	this.instance_7.parent = this;

	this.instance_8 = new lib.BMP_26c819df_d244_4119_8d91_34fd54ea03db();
	this.instance_8.parent = this;

	this.instance_9 = new lib.BMP_f56b3921_5dd7_4a21_9327_d4c710de8c13();
	this.instance_9.parent = this;

	this.instance_10 = new lib.BMP_a856fcf9_202a_4753_a120_ff2441b5d6f3();
	this.instance_10.parent = this;

	this.instance_11 = new lib.BMP_96c19964_5971_4e9c_bddc_00a3a4941521();
	this.instance_11.parent = this;

	this.instance_12 = new lib.BMP_bb04de0c_b5ca_401b_ae32_68d780e3d5c3();
	this.instance_12.parent = this;

	this.instance_13 = new lib.BMP_e8d28562_1ad3_40ee_89ad_69f802d8a51e();
	this.instance_13.parent = this;

	this.instance_14 = new lib.BMP_afc4a0ec_8d54_4323_a2b8_48d06497516c();
	this.instance_14.parent = this;

	this.instance_15 = new lib.BMP_2a342ecf_ca03_4eb7_ada6_b57699f6f7f5();
	this.instance_15.parent = this;

	this.instance_16 = new lib.BMP_bc054416_be44_4787_8f80_d46e6bcc871d();
	this.instance_16.parent = this;

	this.instance_17 = new lib.BMP_0039e909_9113_4f97_b5c4_75a50fca7e2c();
	this.instance_17.parent = this;

	this.instance_18 = new lib.BMP_ff09aaf9_73e4_49bd_ae90_d2b5e4f0cf6c();
	this.instance_18.parent = this;

	this.instance_19 = new lib.BMP_1d9f0d3f_26ad_495b_81e5_79c5f9b22152();
	this.instance_19.parent = this;

	this.instance_20 = new lib.BMP_1426134b_2f58_4938_b274_17a84c2817bb();
	this.instance_20.parent = this;

	this.instance_21 = new lib.BMP_3be2981d_965c_4c96_ab3d_39eeece0f147();
	this.instance_21.parent = this;

	this.instance_22 = new lib.BMP_b842607c_11fb_4e10_87ed_aa53136649f1();
	this.instance_22.parent = this;

	this.instance_23 = new lib.BMP_de6c92b2_3445_4c39_b8bd_4aeff0cd8883();
	this.instance_23.parent = this;

	this.instance_24 = new lib.BMP_5f0dddab_0e22_4dc5_9482_a54f2966c00e();
	this.instance_24.parent = this;

	this.instance_25 = new lib.BMP_e7d48300_8b10_4cd2_9658_860fab4cc9ad();
	this.instance_25.parent = this;

	this.instance_26 = new lib.BMP_5dc6d934_ccfe_4be3_9f2f_2ca5c1825984();
	this.instance_26.parent = this;

	this.instance_27 = new lib.BMP_136dc9fd_f41f_48db_863e_a4b277ac0232();
	this.instance_27.parent = this;

	this.instance_28 = new lib.BMP_4a4c39c7_5e6e_4b72_94cb_ac21fa4955b3();
	this.instance_28.parent = this;

	this.instance_29 = new lib.BMP_97375757_d075_49bb_83c7_0abba9be2e23();
	this.instance_29.parent = this;

	this.instance_30 = new lib.BMP_8cdcf638_fe0f_422d_90d0_a1ee81eaad03();
	this.instance_30.parent = this;

	this.instance_31 = new lib.BMP_dfa04e9e_f9e7_4ba9_9c53_a5bd8efff3d1();
	this.instance_31.parent = this;

	this.instance_32 = new lib.BMP_8ef17a96_8d16_4be1_a75b_06cb350501a4();
	this.instance_32.parent = this;

	this.instance_33 = new lib.BMP_c98b71f9_dd46_4681_82a1_4ead25d3756a();
	this.instance_33.parent = this;

	this.instance_34 = new lib.BMP_bcee5066_f5cd_4718_afca_2c74dea604c3();
	this.instance_34.parent = this;

	this.instance_35 = new lib.BMP_4c98a9ad_8eb4_4104_9245_f5b9779d2007();
	this.instance_35.parent = this;

	this.instance_36 = new lib.BMP_986aa69d_ca1c_4f75_bba8_f5cbc87e5ea1();
	this.instance_36.parent = this;

	this.instance_37 = new lib.BMP_bc2b0ddc_6aa4_458c_ba32_5e216e6e46c5();
	this.instance_37.parent = this;

	this.instance_38 = new lib.BMP_d31d4e36_a0d8_4c42_ba3e_e704335a7575();
	this.instance_38.parent = this;

	this.instance_39 = new lib.BMP_780db005_9699_4530_9277_dbc0f9d23d22();
	this.instance_39.parent = this;

	this.instance_40 = new lib.BMP_ce8338eb_cef1_47f4_9205_841ebece360b();
	this.instance_40.parent = this;

	this.instance_41 = new lib.BMP_f6672567_f901_4dbc_a1d9_07c58febeb1e();
	this.instance_41.parent = this;

	this.instance_42 = new lib.BMP_b67b950e_cd65_404a_923d_cdc567946aab();
	this.instance_42.parent = this;

	this.instance_43 = new lib.BMP_e70fab21_f523_4f15_9219_c50ab72ee7b7();
	this.instance_43.parent = this;

	this.instance_44 = new lib.BMP_aaf2e1ec_e03d_4de6_876d_641b80b32cad();
	this.instance_44.parent = this;

	this.instance_45 = new lib.BMP_ff4a3c92_22ce_4df8_a2ae_8eaaf49bad58();
	this.instance_45.parent = this;

	this.instance_46 = new lib.BMP_4cfd895f_ce5a_4085_8c22_76aa808d1d22();
	this.instance_46.parent = this;

	this.instance_47 = new lib.BMP_fe88dd60_c197_439a_a521_2012be1ac092();
	this.instance_47.parent = this;

	this.instance_48 = new lib.BMP_80aa09da_5b98_491e_8be9_3b0a7429dd7b();
	this.instance_48.parent = this;

	this.instance_49 = new lib.BMP_fe8e15b7_d0b7_4c7e_bc82_917354123d4d();
	this.instance_49.parent = this;

	this.instance_50 = new lib.BMP_9a58cdf3_3af3_423d_8b53_fcf142a088e5();
	this.instance_50.parent = this;

	this.instance_51 = new lib.BMP_f5090d4d_f119_4927_aba6_8dbc7d6cdcbc();
	this.instance_51.parent = this;

	this.instance_52 = new lib.BMP_c12888b1_5d7c_4283_98f1_0adf29364a26();
	this.instance_52.parent = this;

	this.instance_53 = new lib.BMP_ac1519f3_2d10_40e5_b856_9c8b76e053d2();
	this.instance_53.parent = this;

	this.instance_54 = new lib.BMP_3fa2c1bf_8b68_485c_9fad_165128e2403d();
	this.instance_54.parent = this;

	this.instance_55 = new lib.BMP_881071d9_b057_4d90_b212_f45506a24f6a();
	this.instance_55.parent = this;

	this.instance_56 = new lib.BMP_56ede838_872c_4c76_aa25_cf9972872787();
	this.instance_56.parent = this;

	this.instance_57 = new lib.BMP_1fada321_8604_423f_bd2e_cecb5a58e76c();
	this.instance_57.parent = this;

	this.instance_58 = new lib.BMP_b7ca37b0_7916_4152_8e23_11fe57e8c9db();
	this.instance_58.parent = this;

	this.instance_59 = new lib.BMP_b248a9a1_dc51_4ad1_a999_676b548b3110();
	this.instance_59.parent = this;

	this.instance_60 = new lib.BMP_7204e884_904b_4162_b731_0482d453cf1f();
	this.instance_60.parent = this;

	this.instance_61 = new lib.BMP_ce82f2c6_69eb_47d1_941e_55808f8a6edf();
	this.instance_61.parent = this;

	this.instance_62 = new lib.BMP_18f6840d_732f_4cd3_b076_7b7a37c6b9b9();
	this.instance_62.parent = this;

	this.instance_63 = new lib.BMP_75430fcb_87e9_4c0b_ae4d_6a13900a1455();
	this.instance_63.parent = this;

	this.instance_64 = new lib.BMP_67d07f98_4fe8_4ea6_afd3_74665148c74b();
	this.instance_64.parent = this;

	this.instance_65 = new lib.BMP_f1510f03_de73_4fa4_86dd_aecc998e8402();
	this.instance_65.parent = this;

	this.instance_66 = new lib.BMP_f3d4a934_776c_487f_b801_ac2abd31b37b();
	this.instance_66.parent = this;

	this.instance_67 = new lib.BMP_33da36d6_137a_4103_80e2_21622e23873c();
	this.instance_67.parent = this;

	this.instance_68 = new lib.BMP_9dc7b225_7532_4660_b0dd_877e8601e60f();
	this.instance_68.parent = this;

	this.instance_69 = new lib.BMP_bd0dddd7_863c_4f17_bc8f_06a8a466a779();
	this.instance_69.parent = this;

	this.instance_70 = new lib.BMP_d409241b_50e0_4a93_98ac_6068fef1ecb8();
	this.instance_70.parent = this;

	this.instance_71 = new lib.BMP_f7688039_34f2_4d35_91a3_7acbd2a71c3d();
	this.instance_71.parent = this;

	this.instance_72 = new lib.BMP_90bb3712_32b0_44e5_9666_a570916e7fcd();
	this.instance_72.parent = this;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_11}]},1).to({state:[{t:this.instance_12}]},1).to({state:[{t:this.instance_13}]},1).to({state:[{t:this.instance_14}]},1).to({state:[{t:this.instance_15}]},1).to({state:[{t:this.instance_16}]},1).to({state:[{t:this.instance_17}]},1).to({state:[{t:this.instance_18}]},1).to({state:[{t:this.instance_19}]},1).to({state:[{t:this.instance_20}]},1).to({state:[{t:this.instance_21}]},1).to({state:[{t:this.instance_22}]},1).to({state:[{t:this.instance_23}]},1).to({state:[{t:this.instance_24}]},1).to({state:[{t:this.instance_25}]},1).to({state:[{t:this.instance_26}]},1).to({state:[{t:this.instance_27}]},1).to({state:[{t:this.instance_28}]},1).to({state:[{t:this.instance_29}]},1).to({state:[{t:this.instance_30}]},1).to({state:[{t:this.instance_31}]},1).to({state:[{t:this.instance_32}]},1).to({state:[{t:this.instance_33}]},1).to({state:[{t:this.instance_34}]},1).to({state:[{t:this.instance_35}]},1).to({state:[{t:this.instance_36}]},1).to({state:[{t:this.instance_37}]},1).to({state:[{t:this.instance_38}]},1).to({state:[{t:this.instance_39}]},1).to({state:[{t:this.instance_40}]},1).to({state:[{t:this.instance_41}]},1).to({state:[{t:this.instance_42}]},1).to({state:[{t:this.instance_43}]},1).to({state:[{t:this.instance_44}]},1).to({state:[{t:this.instance_45}]},1).to({state:[{t:this.instance_46}]},1).to({state:[{t:this.instance_47}]},1).to({state:[{t:this.instance_48}]},1).to({state:[{t:this.instance_49}]},1).to({state:[{t:this.instance_50}]},1).to({state:[{t:this.instance_51}]},1).to({state:[{t:this.instance_52}]},1).to({state:[{t:this.instance_53}]},1).to({state:[{t:this.instance_54}]},1).to({state:[{t:this.instance_55}]},1).to({state:[{t:this.instance_56}]},1).to({state:[{t:this.instance_57}]},1).to({state:[{t:this.instance_58}]},1).to({state:[{t:this.instance_59}]},1).to({state:[{t:this.instance_60}]},1).to({state:[{t:this.instance_61}]},1).to({state:[{t:this.instance_62}]},1).to({state:[{t:this.instance_63}]},1).to({state:[{t:this.instance_64}]},1).to({state:[{t:this.instance_65}]},1).to({state:[{t:this.instance_66}]},1).to({state:[{t:this.instance_67}]},1).to({state:[{t:this.instance_68}]},1).to({state:[{t:this.instance_69}]},1).to({state:[{t:this.instance_70}]},1).to({state:[{t:this.instance_71}]},1).to({state:[{t:this.instance_72}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,363,198);


(lib.piedramov = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_771();
	this.instance.parent = this;
	this.instance.setTransform(16.25,58.95,0.4999,0.4999);

	this.instance_1 = new lib.Path_1_0();
	this.instance_1.parent = this;
	this.instance_1.setTransform(42,76.6,1,1,0,0,0,20.8,6.7);
	this.instance_1.alpha = 0.3281;

	this.instance_2 = new lib.CachedTexturedBitmap_770();
	this.instance_2.parent = this;
	this.instance_2.setTransform(17.15,61,0.4999,0.4999);

	this.instance_3 = new lib.CachedTexturedBitmap_769();
	this.instance_3.parent = this;
	this.instance_3.setTransform(42.9,53.2,0.4999,0.4999);

	this.instance_4 = new lib.Path_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(63.45,72.85,1,1,0,0,0,20,6.3);
	this.instance_4.alpha = 0.3906;

	this.instance_5 = new lib.CachedTexturedBitmap_768();
	this.instance_5.parent = this;
	this.instance_5.setTransform(43.45,53.5,0.4999,0.4999);

	this.instance_6 = new lib.CachedTexturedBitmap_767();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-0.15,48.35,0.4999,0.4999);

	this.instance_7 = new lib.CachedTexturedBitmap_766();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.9,62.9,0.4999,0.4999);

	this.instance_8 = new lib.Path_2();
	this.instance_8.parent = this;
	this.instance_8.setTransform(19.9,66.05,1,1,0,0,0,19.9,4);
	this.instance_8.alpha = 0.3398;

	this.instance_9 = new lib.CachedTexturedBitmap_765();
	this.instance_9.parent = this;
	this.instance_9.setTransform(0,48.9,0.4999,0.4999);

	this.instance_10 = new lib.CachedTexturedBitmap_764();
	this.instance_10.parent = this;
	this.instance_10.setTransform(4.05,6.1,0.4999,0.4999);

	this.instance_11 = new lib.CachedTexturedBitmap_763();
	this.instance_11.parent = this;
	this.instance_11.setTransform(42.1,-0.45,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.piedramov, new cjs.Rectangle(-0.1,-0.4,90,83.9), null);


(lib.piedra = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.piedramov();
	this.instance.parent = this;
	this.instance.setTransform(44.6,83.3,1,1,0,0,0,44.6,83.3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({regX:44.9,regY:41.5,rotation:-0.4307,y:41.45},0).wait(1).to({rotation:-0.8614,x:44.3,y:41.5},0).wait(1).to({rotation:-1.2922,x:44},0).wait(1).to({rotation:-1.7229,x:43.7},0).wait(1).to({rotation:-2.1536,x:43.35,y:41.45},0).wait(1).to({rotation:-2.5843,x:43,y:41.5},0).wait(1).to({rotation:-2.0477,x:43.45,y:41.45},0).wait(1).to({rotation:-1.5111,x:43.85,y:41.5},0).wait(1).to({rotation:-0.9745,x:44.2},0).wait(1).to({rotation:-0.4379,x:44.6,y:41.45},0).wait(1).to({rotation:0.0987,x:44.95,y:41.55},0).wait(1).to({rotation:0.6353,x:45.35},0).wait(1).to({rotation:1.1719,x:45.75},0).wait(1).to({rotation:1.7085,x:46.15,y:41.6},0).wait(1).to({rotation:2.2451,x:46.45,y:41.55},0).wait(1).to({rotation:2.7817,x:46.9,y:41.6},0).wait(1).to({rotation:3.3183,x:47.25,y:41.65},0).wait(1).to({rotation:3.855,x:47.7,y:41.6},0).wait(1).to({rotation:4.3916,x:48.05,y:41.7},0).wait(1).to({rotation:3.7565,x:47.65,y:41.65},0).wait(1).to({rotation:3.1214,x:47.2,y:41.6},0).wait(1).to({rotation:2.4864,x:46.7,y:41.55},0).wait(1).to({rotation:1.8513,x:46.25,y:41.6},0).wait(1).to({rotation:1.2163,x:45.75,y:41.55},0).wait(1).to({rotation:0.5812,x:45.3},0).wait(1).to({rotation:-0.0538,x:44.9,y:41.45},0).wait(1).to({rotation:-0.6889,x:44.45},0).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.6,-1.7,93.6,87.10000000000001);


(lib.pajaro2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_759();
	this.instance.parent = this;
	this.instance.setTransform(28.35,11.3,0.4011,0.4011);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(12));

	// Capa_3
	this.instance_1 = new lib.alap2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.7,13.1,1,1,0,0,0,28.2,0);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1).to({regX:14,regY:6.6,rotation:4.9999,x:15.95,y:18.35},0).wait(1).to({rotation:9.9997,x:15.55,y:17.15},0).wait(1).to({rotation:14.9996,x:15.25,y:15.8},0).wait(1).to({rotation:19.9995,x:15.1,y:14.45},0).wait(1).to({rotation:24.9993,x:15,y:13.05},0).wait(1).to({rotation:29.9992,x:15.05,y:11.75},0).wait(1).to({rotation:23.9994,x:15,y:13.35},0).wait(1).to({rotation:17.9995,x:15.1,y:15},0).wait(1).to({rotation:11.9997,x:15.45,y:16.55},0).wait(1).to({rotation:5.9998,x:15.85,y:18.15},0).wait(1).to({rotation:0,x:16.5,y:19.7},0).wait(1));

	// Capa_2
	this.instance_2 = new lib.alap2();
	this.instance_2.parent = this;
	this.instance_2.setTransform(32.35,13.1,1,1,0,0,0,0,13.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1).to({regX:14,regY:6.6,rotation:-6.6589,x:45.45,y:5},0).wait(1).to({rotation:-13.3179,x:44.4,y:3.55},0).wait(1).to({rotation:-19.9768,x:43.25,y:2.15},0).wait(1).to({rotation:-26.6357,x:41.9,y:0.95},0).wait(1).to({rotation:-33.2947,x:40.45,y:-0.05},0).wait(1).to({rotation:-39.9536,x:38.9,y:-0.9},0).wait(1).to({rotation:-31.9629,x:40.8,y:0.15},0).wait(1).to({rotation:-23.9722,x:42.5,y:1.45},0).wait(1).to({rotation:-15.9814,x:43.95,y:3},0).wait(1).to({rotation:-7.9907,x:45.25,y:4.7},0).wait(1).to({rotation:0,x:46.35,y:6.6},0).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-0.4,-14.9,60.9,41.3);


(lib.pajaro1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_2
	this.instance = new lib.CachedTexturedBitmap_758();
	this.instance.parent = this;
	this.instance.setTransform(36.45,9.4,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(12));

	// Capa_3
	this.instance_1 = new lib.alap1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(42.4,13.7,0.9985,0.9985,32.6142,0,0,0.5,13.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1).to({regX:16.8,regY:6.8,scaleX:1,scaleY:1,rotation:20.7153,x:59.85,y:13.55},0).wait(1).to({rotation:8.69,x:59.45,y:9.9},0).wait(1).to({rotation:-3.3352,x:58.3,y:6.45},0).wait(1).to({rotation:-15.3605,x:56.45,y:3.25},0).wait(1).to({rotation:-27.3858,x:54,y:0.55},0).wait(1).to({rotation:-17.3986,x:56.1,y:2.8},0).wait(1).to({rotation:-7.4114,x:57.75,y:5.35},0).wait(1).to({rotation:2.5758,x:59,y:8.15},0).wait(1).to({rotation:12.5629,x:59.65,y:11.1},0).wait(1).to({rotation:22.5501,x:59.85,y:14.15},0).wait(1).to({rotation:32.5373,x:59.5,y:17.2},0).wait(1));

	// Capa_4
	this.instance_2 = new lib.alap1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(39.05,13.95,0.9996,0.9996,7.5586,0,0,33.8,0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1).to({regX:16.8,regY:6.8,scaleX:1,scaleY:1,rotation:13.6928,x:20.9,y:16.45},0).wait(1).to({rotation:19.6588,x:20.7,y:14.5},0).wait(1).to({rotation:25.6248,x:20.8,y:12.7},0).wait(1).to({rotation:31.5908,x:21.05,y:10.8},0).wait(1).to({rotation:37.5568,x:21.45,y:8.95},0).wait(1).to({rotation:32.5851,x:21.1,y:10.5},0).wait(1).to({rotation:27.6135,x:20.85,y:12.1},0).wait(1).to({rotation:22.6418,x:20.75,y:13.6},0).wait(1).to({rotation:17.6701,x:20.8,y:15.15},0).wait(1).to({rotation:12.6985,x:20.95,y:16.75},0).wait(1).to({scaleX:1.0001,scaleY:1.0001,rotation:7.7268,x:21.25,y:18.25},0).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(2.7,-13.1,75.3,45);


(lib.nubews = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// nube4
	this.instance = new lib.Símbolo1();
	this.instance.parent = this;
	this.instance.setTransform(-128.7,16.5,1,1,0,0,0,88.8,16.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({x:2047.85},240).to({_off:true},1).wait(47));

	// Capa_3
	this.instance_1 = new lib.Path();
	this.instance_1.parent = this;
	this.instance_1.setTransform(1661.95,248.2,1,1,0,0,0,34.4,6.5);
	this.instance_1.alpha = 0.0781;

	this.instance_2 = new lib.Path_1_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(1751.5,184.85,1,1,0,0,0,34.4,6.5);
	this.instance_2.alpha = 0.0781;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1}]}).wait(288));

	// nube1
	this.instance_3 = new lib.nube1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(88.8,300.1,1,1,0,0,0,88.8,16.6);
	this.instance_3.alpha = 0.0781;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(288));

	// nube3
	this.instance_4 = new lib.nube3();
	this.instance_4.parent = this;
	this.instance_4.setTransform(346.4,104.45,1,1,0,0,0,88.8,16.6);
	this.instance_4.alpha = 0.0781;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(288));

	// nube2
	this.instance_5 = new lib.Símbolo1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-2.3,360.85,0.4421,0.6938,0,0,0,86.4,16.6);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(1).to({regX:88.7,regY:16.5,scaleX:0.4513,scaleY:0.7018,x:7.3,y:359.35},0).wait(1).to({scaleX:0.4604,scaleY:0.7097,x:15.8,y:357.9},0).wait(1).to({scaleX:0.4695,scaleY:0.7176,x:24.3,y:356.55},0).wait(1).to({scaleX:0.4786,scaleY:0.7255,x:32.8,y:355.15},0).wait(1).to({scaleX:0.4877,scaleY:0.7334,x:41.25,y:353.85},0).wait(1).to({scaleX:0.4969,scaleY:0.7413,x:49.7,y:352.6},0).wait(1).to({scaleX:0.506,scaleY:0.7492,x:58.15,y:351.3},0).wait(1).to({scaleX:0.5151,scaleY:0.7571,x:66.6,y:350.05},0).wait(1).to({scaleX:0.5242,scaleY:0.7651,x:75,y:348.85},0).wait(1).to({scaleX:0.5333,scaleY:0.773,x:83.4,y:347.7},0).wait(1).to({scaleX:0.5425,scaleY:0.7809,x:91.8,y:346.55},0).wait(1).to({scaleX:0.5516,scaleY:0.7888,x:100.2,y:345.45},0).wait(1).to({scaleX:0.5607,scaleY:0.7967,x:108.6,y:344.35},0).wait(1).to({scaleX:0.5698,scaleY:0.8046,x:116.95,y:343.35},0).wait(1).to({scaleX:0.579,scaleY:0.8125,x:125.25,y:342.3},0).wait(1).to({scaleX:0.5881,scaleY:0.8204,x:133.6,y:341.3},0).wait(1).to({scaleX:0.5972,scaleY:0.8284,x:141.9,y:340.35},0).wait(1).to({scaleX:0.6063,scaleY:0.8363,x:150.25,y:339.45},0).wait(1).to({scaleX:0.6154,scaleY:0.8442,x:158.5,y:338.55},0).wait(1).to({scaleX:0.6246,scaleY:0.8521,x:166.75,y:337.65},0).wait(1).to({scaleX:0.6337,scaleY:0.86,x:175,y:336.85},0).wait(1).to({scaleX:0.6428,scaleY:0.8679,x:183.25,y:336},0).wait(1).to({scaleX:0.6519,scaleY:0.8758,x:191.5,y:335.25},0).wait(1).to({scaleX:0.661,scaleY:0.8837,x:199.75,y:334.5},0).wait(1).to({scaleX:0.6702,scaleY:0.8917,x:207.95,y:333.75},0).wait(1).to({scaleX:0.6793,scaleY:0.8996,x:216.1,y:333.1},0).wait(1).to({scaleX:0.6884,scaleY:0.9075,x:224.3,y:332.4},0).wait(1).to({scaleX:0.6975,scaleY:0.9154,x:232.45,y:331.8},0).wait(1).to({scaleX:0.7066,scaleY:0.9233,x:240.6,y:331.25},0).wait(1).to({scaleX:0.7158,scaleY:0.9312,x:248.75,y:330.65},0).wait(1).to({scaleX:0.7249,scaleY:0.9391,x:256.85,y:330.15},0).wait(1).to({scaleX:0.734,scaleY:0.947,x:264.95,y:329.65},0).wait(1).to({scaleX:0.7431,scaleY:0.9549,x:273.05,y:329.15},0).wait(1).to({scaleX:0.7522,scaleY:0.9629,x:281.1,y:328.75},0).wait(1).to({scaleX:0.7614,scaleY:0.9708,x:289.2,y:328.3},0).wait(1).to({scaleX:0.7705,scaleY:0.9787,x:297.25,y:327.95},0).wait(1).to({scaleX:0.7796,scaleY:0.9866,x:305.3,y:327.6},0).wait(1).to({scaleX:0.7887,scaleY:0.9945,x:313.3,y:327.25},0).wait(1).to({scaleX:0.7978,scaleY:1.0024,x:321.3,y:327},0).wait(1).to({scaleX:0.807,scaleY:1.0103,x:329.35,y:326.7},0).wait(1).to({scaleX:0.8161,scaleY:1.0182,x:337.35,y:326.5},0).wait(1).to({scaleX:0.8252,scaleY:1.0262,x:345.3,y:326.3},0).wait(1).to({scaleX:0.8343,scaleY:1.0341,x:353.25,y:326.1},0).wait(1).to({scaleX:0.8435,scaleY:1.042,x:361.2,y:326},0).wait(1).to({scaleX:0.8526,scaleY:1.0499,x:369.1,y:325.85},0).wait(1).to({scaleX:0.8617,scaleY:1.0578,x:377.05,y:325.8},0).wait(1).to({scaleX:0.8708,scaleY:1.0657,x:384.95,y:325.75},0).wait(1).to({scaleX:0.8799,scaleY:1.0736,x:392.85,y:325.7},0).wait(1).to({scaleX:0.8891,scaleY:1.0815,x:400.7,y:325.75},0).wait(1).to({scaleX:0.8982,scaleY:1.0895,x:408.55,y:325.8},0).wait(1).to({scaleX:0.9073,scaleY:1.0974,x:416.45,y:325.85},0).wait(1).to({scaleX:0.9164,scaleY:1.1053,x:424.3,y:326},0).wait(1).to({scaleX:0.9255,scaleY:1.1132,x:432.1,y:326.1},0).wait(1).to({scaleX:0.9347,scaleY:1.1211,x:439.9,y:326.25},0).wait(1).to({scaleX:0.9438,scaleY:1.129,x:447.7,y:326.5},0).wait(1).to({scaleX:0.9529,scaleY:1.1369,x:455.45,y:326.7},0).wait(1).to({scaleX:0.962,scaleY:1.1448,x:463.25,y:326.95},0).wait(1).to({scaleX:0.9711,scaleY:1.1528,x:471,y:327.2},0).wait(1).to({scaleX:0.9803,scaleY:1.1607,x:478.75,y:327.55},0).wait(1).to({scaleX:0.9894,scaleY:1.1686,x:486.45,y:327.9},0).wait(1).to({scaleX:0.9985,scaleY:1.1765,x:494.15,y:328.25},0).wait(1).to({scaleX:1.0076,scaleY:1.1844,x:501.9,y:328.7},0).wait(1).to({scaleX:1.0167,scaleY:1.1923,x:509.6,y:329.1},0).wait(1).to({scaleX:1.0259,scaleY:1.2002,x:517.25,y:329.6},0).wait(1).to({scaleX:1.035,scaleY:1.2081,x:524.9,y:330.1},0).wait(1).to({scaleX:1.0441,scaleY:1.216,x:532.55,y:330.6},0).wait(1).to({scaleX:1.0532,scaleY:1.224,x:540.2,y:331.2},0).wait(1).to({scaleX:1.0623,scaleY:1.2319,x:547.85,y:331.8},0).wait(1).to({scaleX:1.0715,scaleY:1.2398,x:555.45,y:332.4},0).wait(1).to({scaleX:1.0806,scaleY:1.2477,x:563.05,y:333.05},0).wait(1).to({scaleX:1.0897,scaleY:1.2556,x:570.6,y:333.7},0).wait(1).to({scaleX:1.0988,scaleY:1.2635,x:578.15,y:334.45},0).wait(1).to({scaleX:1.108,scaleY:1.2714,x:585.7,y:335.2},0).wait(1).to({scaleX:1.1171,scaleY:1.2793,x:593.3,y:335.95},0).wait(1).to({scaleX:1.1262,scaleY:1.2873,x:600.85,y:336.75},0).wait(1).to({scaleX:1.1353,scaleY:1.2952,x:608.35,y:337.55},0).wait(1).to({scaleX:1.1444,scaleY:1.3031,x:615.85,y:338.45},0).wait(1).to({scaleX:1.1536,scaleY:1.311,x:623.3,y:339.35},0).wait(1).to({scaleX:1.1627,scaleY:1.3189,x:630.85,y:340.25},0).wait(1).to({scaleX:1.1718,scaleY:1.3268,x:638.3,y:341.25},0).wait(1).to({scaleX:1.1809,scaleY:1.3347,x:645.7,y:342.2},0).wait(1).to({scaleX:1.19,scaleY:1.3426,x:653.15,y:343.25},0).wait(1).to({scaleX:1.1992,scaleY:1.3506,x:660.55,y:344.3},0).wait(1).to({scaleX:1.2083,scaleY:1.3585,x:667.95,y:345.35},0).wait(1).to({scaleX:1.2174,scaleY:1.3664,x:675.4,y:346.45},0).wait(1).to({scaleX:1.2265,scaleY:1.3743,x:682.8,y:347.65},0).wait(1).to({scaleX:1.2356,scaleY:1.3822,x:690.15,y:348.75},0).wait(1).to({scaleX:1.2448,scaleY:1.3901,x:697.5,y:350},0).wait(1).to({scaleX:1.2539,scaleY:1.398,x:704.85,y:351.2},0).wait(1).to({scaleX:1.263,scaleY:1.4059,x:712.2,y:352.45},0).wait(1).to({scaleX:1.2721,scaleY:1.4138,x:719.5,y:353.75},0).wait(1).to({scaleX:1.2812,scaleY:1.4218,x:726.8,y:355.05},0).wait(1).to({scaleX:1.2904,scaleY:1.4297,x:734.1,y:356.45},0).wait(1).to({scaleX:1.2995,scaleY:1.4376,x:741.35,y:357.8},0).wait(1).to({scaleX:1.3086,scaleY:1.4455,x:748.65,y:359.2},0).wait(1).to({scaleX:1.3177,scaleY:1.4534,x:755.9,y:360.7},0).wait(1).to({scaleX:1.3102,scaleY:1.445,x:760.85,y:362.3},0).wait(1).to({scaleX:1.3027,scaleY:1.4365,x:765.85,y:363.85},0).wait(1).to({scaleX:1.2953,scaleY:1.4281,x:770.85,y:365.4},0).wait(1).to({scaleX:1.2878,scaleY:1.4197,x:775.75,y:366.95},0).wait(1).to({scaleX:1.2803,scaleY:1.4112,x:780.7,y:368.5},0).wait(1).to({scaleX:1.2728,scaleY:1.4028,x:785.65,y:369.95},0).wait(1).to({scaleX:1.2653,scaleY:1.3944,x:790.6,y:371.45},0).wait(1).to({scaleX:1.2578,scaleY:1.3859,x:795.45,y:372.9},0).wait(1).to({scaleX:1.2503,scaleY:1.3775,x:800.35,y:374.35},0).wait(1).to({scaleX:1.2428,scaleY:1.3691,x:805.25,y:375.75},0).wait(1).to({scaleX:1.2353,scaleY:1.3606,x:810.1,y:377.1},0).wait(1).to({scaleX:1.2278,scaleY:1.3522,x:815,y:378.45},0).wait(1).to({scaleX:1.2203,scaleY:1.3438,x:819.85,y:379.8},0).wait(1).to({scaleX:1.2129,scaleY:1.3353,x:824.7,y:381.15},0).wait(1).to({scaleX:1.2054,scaleY:1.3269,x:829.5,y:382.4},0).wait(1).to({scaleX:1.1979,scaleY:1.3185,x:834.35,y:383.7},0).wait(1).to({scaleX:1.1904,scaleY:1.31,x:839.15,y:384.9},0).wait(1).to({scaleX:1.1829,scaleY:1.3016,x:843.95,y:386.2},0).wait(1).to({scaleX:1.1754,scaleY:1.2932,x:848.75,y:387.35},0).wait(1).to({scaleX:1.1679,scaleY:1.2847,x:853.55,y:388.55},0).wait(1).to({scaleX:1.1604,scaleY:1.2763,x:858.3,y:389.7},0).wait(1).to({scaleX:1.1529,scaleY:1.2679,x:863.05,y:390.8},0).wait(1).to({scaleX:1.1454,scaleY:1.2594,x:867.8,y:391.95},0).wait(1).to({scaleX:1.1379,scaleY:1.251,x:872.55,y:393.05},0).wait(1).to({scaleX:1.1304,scaleY:1.2426,x:877.25,y:394.1},0).wait(1).to({scaleX:1.123,scaleY:1.2341,x:881.95,y:395.15},0).wait(1).to({scaleX:1.1155,scaleY:1.2257,x:886.7,y:396.15},0).wait(1).to({scaleX:1.108,scaleY:1.2173,x:891.4,y:397.2},0).wait(1).to({scaleX:1.1005,scaleY:1.2088,x:896.05,y:398.15},0).wait(1).to({scaleX:1.093,scaleY:1.2004,x:900.75,y:399.1},0).wait(1).to({scaleX:1.0855,scaleY:1.192,x:905.4,y:400},0).wait(1).to({scaleX:1.078,scaleY:1.1835,x:910.05,y:400.95},0).wait(1).to({scaleX:1.0705,scaleY:1.1751,x:914.7,y:401.85},0).wait(1).to({scaleX:1.063,scaleY:1.1666,x:919.35,y:402.7},0).wait(1).to({scaleX:1.0555,scaleY:1.1582,x:923.95,y:403.55},0).wait(1).to({scaleX:1.048,scaleY:1.1498,x:928.55,y:404.35},0).wait(1).to({scaleX:1.0405,scaleY:1.1413,x:933.15,y:405.2},0).wait(1).to({scaleX:1.0331,scaleY:1.1329,x:937.75,y:405.95},0).wait(1).to({scaleX:1.0256,scaleY:1.1245,x:942.3,y:406.7},0).wait(1).to({scaleX:1.0181,scaleY:1.116,x:946.9,y:407.4},0).wait(1).to({scaleX:1.0106,scaleY:1.1076,x:951.45,y:408.15},0).wait(1).to({scaleX:1.0031,scaleY:1.0992,x:955.95,y:408.85},0).wait(1).to({scaleX:0.9956,scaleY:1.0907,x:960.5,y:409.5},0).wait(1).to({scaleX:0.9881,scaleY:1.0823,x:965.05,y:410.1},0).wait(1).to({scaleX:0.9806,scaleY:1.0739,x:969.6,y:410.7},0).wait(1).to({scaleX:0.9731,scaleY:1.0654,x:974.05,y:411.35},0).wait(1).to({scaleX:0.9656,scaleY:1.057,x:978.55,y:411.9},0).wait(1).to({scaleX:0.9581,scaleY:1.0486,x:983.05,y:412.45},0).wait(1).to({scaleX:0.9507,scaleY:1.0401,x:987.5,y:413},0).wait(1).to({scaleX:0.9432,scaleY:1.0317,x:991.95,y:413.45},0).wait(1).to({scaleX:0.9357,scaleY:1.0233,x:996.45,y:414},0).wait(1).to({scaleX:0.9282,scaleY:1.0148,x:1000.9,y:414.45},0).wait(1).to({scaleX:0.9207,scaleY:1.0064,x:1005.3,y:414.85},0).wait(1).to({scaleX:0.9132,scaleY:0.998,x:1009.7,y:415.3},0).wait(1).to({scaleX:0.9057,scaleY:0.9895,x:1014.15,y:415.7},0).wait(1).to({scaleX:0.8982,scaleY:0.9811,x:1018.5,y:416.05},0).wait(1).to({scaleX:0.8907,scaleY:0.9727,x:1022.9,y:416.4},0).wait(1).to({scaleX:0.8832,scaleY:0.9642,x:1027.3,y:416.7},0).wait(1).to({scaleX:0.8757,scaleY:0.9558,x:1031.7,y:417},0).wait(1).to({scaleX:0.8682,scaleY:0.9474,x:1036,y:417.35},0).wait(1).to({scaleX:0.8608,scaleY:0.9389,x:1040.35,y:417.6},0).wait(1).to({scaleX:0.8533,scaleY:0.9305,x:1044.7,y:417.8},0).wait(1).to({scaleX:0.8458,scaleY:0.9221,x:1049,y:418},0).wait(1).to({scaleX:0.8383,scaleY:0.9136,x:1053.35,y:418.2},0).wait(1).to({scaleX:0.8308,scaleY:0.9052,x:1057.65,y:418.4},0).wait(1).to({scaleX:0.8233,scaleY:0.8968,x:1061.95,y:418.55},0).wait(1).to({scaleX:0.8158,scaleY:0.8883,x:1066.2,y:418.65},0).wait(1).to({scaleX:0.8083,scaleY:0.8799,x:1070.5,y:418.75},0).wait(1).to({scaleX:0.8008,scaleY:0.8715,x:1074.75,y:418.85},0).wait(1).to({scaleX:0.7933,scaleY:0.863,x:1079,y:418.9},0).wait(1).to({scaleX:0.7858,scaleY:0.8546,x:1083.25,y:418.95},0).wait(1).to({scaleX:0.7783,scaleY:0.8462,x:1087.5},0).wait(1).to({scaleX:0.7709,scaleY:0.8377,x:1091.65,y:418.9},0).wait(1).to({scaleX:0.7634,scaleY:0.8293,x:1095.9,y:418.95},0).wait(1).to({scaleX:0.7559,scaleY:0.8208,x:1100.1,y:418.85},0).wait(1).to({scaleX:0.7484,scaleY:0.8124,x:1104.3,y:418.75},0).wait(1).to({scaleX:0.7409,scaleY:0.804,x:1108.45,y:418.65},0).wait(1).to({scaleX:0.7334,scaleY:0.7955,x:1112.65,y:418.6},0).wait(1).to({scaleX:0.7259,scaleY:0.7871,x:1116.8,y:418.4},0).wait(1).to({scaleX:0.7184,scaleY:0.7787,x:1120.9,y:418.25},0).wait(1).to({scaleX:0.7109,scaleY:0.7702,x:1125.05,y:418.05},0).wait(1).to({scaleX:0.7034,scaleY:0.7618,x:1129.2,y:417.8},0).wait(1).to({scaleX:0.6959,scaleY:0.7534,x:1133.35,y:417.65},0).wait(1).to({scaleX:0.6885,scaleY:0.7449,x:1137.4,y:417.35},0).wait(1).to({scaleX:0.681,scaleY:0.7365,x:1141.5,y:417.05},0).wait(1).to({scaleX:0.6735,scaleY:0.7281,x:1145.6,y:416.75},0).wait(1).to({scaleX:0.666,scaleY:0.7196,x:1149.65,y:416.4},0).wait(1).to({scaleX:0.6585,scaleY:0.7112,x:1153.7,y:416.1},0).wait(1).to({scaleX:0.651,scaleY:0.7028,x:1157.8,y:415.75},0).wait(1).to({scaleX:0.6435,scaleY:0.6943,x:1161.85,y:415.35},0).wait(1).to({scaleX:0.636,scaleY:0.6859,x:1165.85,y:414.9},0).wait(1).to({scaleX:0.6285,scaleY:0.6775,x:1169.9,y:414.5},0).wait(1).to({scaleX:0.621,scaleY:0.669,x:1173.9,y:414.05},0).wait(1).to({scaleX:0.6135,scaleY:0.6606,x:1177.85,y:413.55},0).wait(1).to({scaleX:0.606,scaleY:0.6522,x:1181.85,y:413.05},0).wait(1).to({scaleX:0.5986,scaleY:0.6437,x:1185.85,y:412.5},0).wait(1).to({scaleX:0.5911,scaleY:0.6353,x:1189.85,y:412},0).wait(1).to({scaleX:0.5836,scaleY:0.6269,x:1193.75,y:411.4},0).wait(1).to({scaleX:0.5761,scaleY:0.6184,x:1197.75,y:410.8},0).wait(1).to({scaleX:0.5686,scaleY:0.61,x:1201.7,y:410.2},0).wait(1).to({scaleX:0.5611,scaleY:0.6016,x:1205.6,y:409.6},0).wait(1).to({scaleX:0.5536,scaleY:0.5931,x:1209.5,y:408.9},0).wait(1).to({scaleX:0.5461,scaleY:0.5847,x:1213.45,y:408.2},0).wait(1).to({scaleX:0.5386,scaleY:0.5763,x:1217.35,y:407.5},0).wait(1).to({scaleX:0.5311,scaleY:0.5678,x:1221.2,y:406.75},0).wait(1).to({scaleX:0.5236,scaleY:0.5594,x:1225.1,y:406.05},0).wait(1).to({scaleX:0.5161,scaleY:0.551,x:1228.95,y:405.25},0).wait(1).to({scaleX:0.5087,scaleY:0.5425,x:1232.8,y:404.45},0).wait(1).to({scaleX:0.5012,scaleY:0.5341,x:1236.65,y:403.65},0).wait(1).to({scaleX:0.4937,scaleY:0.5257,x:1240.5,y:402.8},0).wait(1).to({scaleX:0.4862,scaleY:0.5172,x:1244.25,y:401.95},0).wait(1).to({scaleX:0.4787,scaleY:0.5088,x:1248.1,y:401.05},0).wait(1).to({scaleX:0.4712,scaleY:0.5004,x:1251.9,y:400.15},0).wait(1).to({scaleX:0.4637,scaleY:0.4919,x:1255.7,y:399.2},0).wait(1).to({scaleX:0.4562,scaleY:0.4835,x:1259.45,y:398.3},0).wait(1).to({scaleX:0.4487,scaleY:0.475,x:1263.25,y:397.3},0).wait(1).to({scaleX:0.4412,scaleY:0.4666,x:1267.05,y:396.3},0).wait(1).to({scaleX:0.4337,scaleY:0.4582,x:1270.75,y:395.25},0).wait(1).to({scaleX:0.4263,scaleY:0.4497,x:1274.5,y:394.2},0).wait(1).to({scaleX:0.4188,scaleY:0.4413,x:1278.25,y:393.2},0).wait(1).to({scaleX:0.4113,scaleY:0.4329,x:1282,y:392.1},0).wait(1).to({scaleX:0.4038,scaleY:0.4244,x:1285.65,y:390.95},0).wait(1).to({scaleX:0.3963,scaleY:0.416,x:1289.35,y:389.8},0).wait(1).to({scaleX:0.3888,scaleY:0.4076,x:1293.05,y:388.65},0).wait(1).to({scaleX:0.3813,scaleY:0.3991,x:1296.7,y:387.5},0).wait(1).to({scaleX:0.3738,scaleY:0.3907,x:1300.4,y:386.3},0).wait(1).to({scaleX:0.3663,scaleY:0.3823,x:1304.05,y:385.05},0).wait(1).to({scaleX:0.3588,scaleY:0.3738,x:1307.7,y:383.8},0).wait(1).to({scaleX:0.3513,scaleY:0.3654,x:1311.3,y:382.6},0).wait(1).to({scaleX:0.3438,scaleY:0.357,x:1314.95,y:381.3},0).wait(1).to({scaleX:0.3364,scaleY:0.3485,x:1318.6,y:379.95},0).wait(1).to({scaleX:0.3289,scaleY:0.3401,x:1322.15,y:378.6},0).wait(1).to({scaleX:0.3214,scaleY:0.3317,x:1325.75,y:377.25},0).wait(1).to({scaleX:0.3139,scaleY:0.3232,x:1329.35,y:375.9},0).wait(1).to({scaleX:0.3064,scaleY:0.3148,x:1332.95,y:374.5},0).wait(1).to({scaleX:0.2989,scaleY:0.3064,x:1336.5,y:373.05},0).wait(1).to({scaleX:0.2914,scaleY:0.2979,x:1340.05,y:371.6},0).wait(1).to({scaleX:0.2839,scaleY:0.2895,x:1343.6,y:370.15},0).wait(1).to({scaleX:0.2764,scaleY:0.2811,x:1347.1,y:368.65},0).wait(1).to({scaleX:0.2689,scaleY:0.2726,x:1350.65,y:367.15},0).wait(1).to({scaleX:0.2614,scaleY:0.2642,x:1354.15,y:365.6},0).wait(1).to({scaleX:0.254,scaleY:0.2558,x:1357.65,y:364},0).wait(1).to({scaleX:0.2465,scaleY:0.2473,x:1361.15,y:362.45},0).wait(1).to({scaleX:0.239,scaleY:0.2389,x:1364.65,y:360.85},0).to({_off:true},1).wait(47));

	// nube6
	this.instance_6 = new lib.nube6();
	this.instance_6.parent = this;
	this.instance_6.setTransform(1266.15,241.25,1,1,0,0,0,51,9.5);
	this.instance_6.alpha = 0.0781;

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(288));

	// nube5
	this.instance_7 = new lib.nube5();
	this.instance_7.parent = this;
	this.instance_7.setTransform(1132,197.25,1,1,0,0,0,88.8,16.5);
	this.instance_7.alpha = 0.0781;

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(288));

	// nube7
	this.instance_8 = new lib.nube7();
	this.instance_8.parent = this;
	this.instance_8.setTransform(2201.8,92.25,1,1,0,0,0,171.1,34.6);
	this.instance_8.alpha = 0.0781;

	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(1).to({regX:171,regY:34.7,x:2193.35,y:92.9,alpha:0.08},0).wait(1).to({x:2184.95,y:93.5},0).wait(1).to({x:2176.6,y:94.05},0).wait(1).to({x:2168.25,y:94.65},0).wait(1).to({x:2159.9,y:95.2},0).wait(1).to({x:2151.55,y:95.75},0).wait(1).to({x:2143.2,y:96.3},0).wait(1).to({x:2134.85,y:96.85},0).wait(1).to({x:2126.5,y:97.4},0).wait(1).to({x:2118.15,y:97.95},0).wait(1).to({x:2109.8,y:98.5},0).wait(1).to({x:2101.45,y:99.05},0).wait(1).to({x:2093.1,y:99.55},0).wait(1).to({x:2084.75,y:100.1},0).wait(1).to({x:2076.4,y:100.6},0).wait(1).to({x:2068.05,y:101.15},0).wait(1).to({x:2059.75,y:101.65},0).wait(1).to({x:2051.4,y:102.15},0).wait(1).to({x:2043.05,y:102.65},0).wait(1).to({x:2034.7,y:103.15},0).wait(1).to({x:2026.35,y:103.65},0).wait(1).to({x:2018,y:104.15},0).wait(1).to({x:2009.65,y:104.65},0).wait(1).to({x:2001.35,y:105.1},0).wait(1).to({x:1993,y:105.6},0).wait(1).to({x:1984.65,y:106.1},0).wait(1).to({x:1976.3,y:106.55},0).wait(1).to({x:1968,y:107},0).wait(1).to({x:1959.65,y:107.5},0).wait(1).to({x:1951.3,y:107.95},0).wait(1).to({x:1943,y:108.4},0).wait(1).to({x:1934.65,y:108.85},0).wait(1).to({x:1926.3,y:109.3},0).wait(1).to({x:1918,y:109.75},0).wait(1).to({x:1909.65,y:110.15},0).wait(1).to({x:1901.3,y:110.6},0).wait(1).to({x:1893,y:111.05},0).wait(1).to({x:1884.65,y:111.45},0).wait(1).to({x:1876.35,y:111.9},0).wait(1).to({x:1868,y:112.3},0).wait(1).to({x:1859.65,y:112.7},0).wait(1).to({x:1851.35,y:113.1},0).wait(1).to({x:1843,y:113.5},0).wait(1).to({x:1834.7,y:113.9},0).wait(1).to({x:1826.35,y:114.3},0).wait(1).to({x:1818.05,y:114.7},0).wait(1).to({x:1809.7,y:115.1},0).wait(1).to({x:1801.4,y:115.5},0).wait(1).to({x:1793.1,y:115.85},0).wait(1).to({x:1784.75,y:116.25},0).wait(1).to({x:1776.45,y:116.6},0).wait(1).to({x:1768.1,y:116.95},0).wait(1).to({x:1759.8,y:117.35},0).wait(1).to({x:1751.45,y:117.7},0).wait(1).to({x:1743.15,y:118.05},0).wait(1).to({x:1734.85,y:118.4},0).wait(1).to({x:1726.5,y:118.75},0).wait(1).to({x:1718.2,y:119.1},0).wait(1).to({x:1709.9,y:119.4},0).wait(1).to({x:1701.6,y:119.75},0).wait(1).to({x:1693.25,y:120.1},0).wait(1).to({x:1684.95,y:120.4},0).wait(1).to({x:1676.65,y:120.7},0).wait(1).to({x:1668.3,y:121.05},0).wait(1).to({x:1660,y:121.35},0).wait(1).to({x:1651.7,y:121.65},0).wait(1).to({x:1643.4,y:121.95},0).wait(1).to({x:1635.1,y:122.25},0).wait(1).to({x:1626.75,y:122.55},0).wait(1).to({x:1618.45,y:122.85},0).wait(1).to({x:1610.15,y:123.15},0).wait(1).to({x:1601.85,y:123.4},0).wait(1).to({x:1593.55,y:123.7},0).wait(1).to({x:1585.25,y:123.95},0).wait(1).to({x:1576.95,y:124.25},0).wait(1).to({x:1568.65,y:124.5},0).wait(1).to({x:1560.35,y:124.75},0).wait(1).to({x:1552,y:125},0).wait(1).to({x:1543.7,y:125.25},0).wait(1).to({x:1535.4,y:125.5},0).wait(1).to({x:1527.1,y:125.75},0).wait(1).to({x:1518.8,y:126},0).wait(1).to({x:1510.5,y:126.25},0).wait(1).to({x:1502.2,y:126.45},0).wait(1).to({x:1493.9,y:126.7},0).wait(1).to({x:1485.6,y:126.9},0).wait(1).to({x:1477.3,y:127.15},0).wait(1).to({x:1469.05,y:127.35},0).wait(1).to({x:1460.75,y:127.55},0).wait(1).to({x:1452.45,y:127.75},0).wait(1).to({x:1444.15,y:127.95},0).wait(1).to({x:1435.85,y:128.15},0).wait(1).to({x:1427.55,y:128.35},0).wait(1).to({x:1419.25,y:128.55},0).wait(1).to({x:1410.95,y:128.75},0).wait(1).to({x:1402.7,y:128.9},0).wait(1).to({x:1394.4,y:129.1},0).wait(1).to({x:1386.1,y:129.25},0).wait(1).to({x:1377.8,y:129.45},0).wait(1).to({x:1369.5,y:129.6},0).wait(1).to({x:1361.25,y:129.75},0).wait(1).to({x:1352.95,y:129.9},0).wait(1).to({x:1344.65,y:130.05},0).wait(1).to({x:1336.35,y:130.2},0).wait(1).to({x:1328.1,y:130.35},0).wait(1).to({x:1319.8,y:130.5},0).wait(1).to({x:1311.5,y:130.65},0).wait(1).to({x:1303.2,y:130.75},0).wait(1).to({x:1294.95,y:130.9},0).wait(1).to({x:1286.65,y:131},0).wait(1).to({x:1278.4,y:131.15},0).wait(1).to({x:1270.1,y:131.25},0).wait(1).to({x:1261.8,y:131.35},0).wait(1).to({x:1253.55,y:131.45},0).wait(1).to({x:1245.25,y:131.55},0).wait(1).to({x:1236.95,y:131.65},0).wait(1).to({x:1228.7,y:131.75},0).wait(1).to({x:1220.4,y:131.85},0).wait(1).to({x:1212.15,y:131.9},0).wait(1).to({x:1203.85,y:132},0).wait(1).to({x:1195.6,y:132.1},0).wait(1).to({x:1187.3,y:132.15},0).wait(1).to({x:1179.05,y:132.2},0).wait(1).to({x:1170.75,y:132.3},0).wait(1).to({x:1162.5,y:132.35},0).wait(1).to({x:1154.2,y:132.4},0).wait(1).to({x:1145.95,y:132.45},0).wait(1).to({x:1137.65,y:132.5},0).wait(1).to({x:1129.4,y:132.55},0).wait(1).to({x:1121.1},0).wait(1).to({x:1112.85,y:132.6},0).wait(1).to({x:1104.6,y:132.65},0).wait(1).to({x:1096.3},0).wait(1).to({x:1088.05,y:132.7},0).wait(1).to({x:1079.75},0).wait(1).to({x:1071.5},0).wait(1).to({x:1063.25},0).wait(1).to({x:1054.95,y:132.75},0).wait(1).to({x:1046.7},0).wait(1).to({x:1038.45,y:132.7},0).wait(1).to({x:1030.15},0).wait(1).to({x:1021.9},0).wait(1).to({x:1013.65},0).wait(1).to({x:1005.4,y:132.65},0).wait(1).to({x:997.1},0).wait(1).to({x:988.85,y:132.6},0).wait(1).to({x:980.6},0).wait(1).to({x:972.35,y:132.55},0).wait(1).to({x:964.05,y:132.5},0).wait(1).to({x:955.8,y:132.45},0).wait(1).to({x:947.55,y:132.4},0).wait(1).to({x:939.3,y:132.35},0).wait(1).to({x:931.05,y:132.3},0).wait(1).to({x:922.8,y:132.2},0).wait(1).to({x:914.5,y:132.15},0).wait(1).to({x:906.25,y:132.1},0).wait(1).to({x:898,y:132},0).wait(1).to({x:889.75,y:131.95},0).wait(1).to({x:881.5,y:131.85},0).wait(1).to({x:873.25,y:131.75},0).wait(1).to({x:865,y:131.65},0).wait(1).to({x:856.75,y:131.55},0).wait(1).to({x:848.5,y:131.45},0).wait(1).to({x:840.25,y:131.35},0).wait(1).to({x:832,y:131.25},0).wait(1).to({x:823.75,y:131.15},0).wait(1).to({x:815.5,y:131},0).wait(1).to({x:807.25,y:130.9},0).wait(1).to({x:799,y:130.75},0).wait(1).to({x:790.75,y:130.65},0).wait(1).to({x:782.5,y:130.5},0).wait(1).to({x:774.25,y:130.35},0).wait(1).to({x:766,y:130.25},0).wait(1).to({x:757.75,y:130.1},0).wait(1).to({x:749.5,y:129.95},0).wait(1).to({x:741.25,y:129.75},0).wait(1).to({x:733,y:129.6},0).wait(1).to({x:724.75,y:129.45},0).wait(1).to({x:716.5,y:129.3},0).wait(1).to({x:708.25,y:129.1},0).wait(1).to({x:700,y:128.95},0).wait(1).to({x:691.8,y:128.75},0).wait(1).to({x:683.55,y:128.55},0).wait(1).to({x:675.3,y:128.4},0).wait(1).to({x:667.05,y:128.2},0).wait(1).to({x:658.8,y:128},0).wait(1).to({x:650.55,y:127.8},0).wait(1).to({x:642.35,y:127.6},0).wait(1).to({x:634.1,y:127.35},0).wait(1).to({x:625.85,y:127.15},0).wait(1).to({x:617.6,y:126.95},0).wait(1).to({x:609.35,y:126.7},0).wait(1).to({x:601.15,y:126.5},0).wait(1).to({x:592.9,y:126.25},0).wait(1).to({x:584.65,y:126},0).wait(1).to({x:576.45,y:125.8},0).wait(1).to({x:568.2,y:125.55},0).wait(1).to({x:559.95,y:125.3},0).wait(1).to({x:551.7,y:125.05},0).wait(1).to({x:543.5,y:124.8},0).wait(1).to({x:535.25,y:124.5},0).wait(1).to({x:527,y:124.25},0).wait(1).to({x:518.8,y:124},0).wait(1).to({x:510.55,y:123.7},0).wait(1).to({x:502.35,y:123.45},0).wait(1).to({x:494.1,y:123.15},0).wait(1).to({x:485.85,y:122.85},0).wait(1).to({x:477.65,y:122.6},0).wait(1).to({x:469.4,y:122.3},0).wait(1).to({x:461.2,y:122},0).wait(1).to({x:452.95,y:121.7},0).wait(1).to({x:444.7,y:121.35},0).wait(1).to({x:436.5,y:121.05},0).wait(1).to({x:428.25,y:120.75},0).wait(1).to({x:420.05,y:120.45},0).wait(1).to({x:411.8,y:120.1},0).wait(1).to({x:403.6,y:119.8},0).wait(1).to({x:395.35,y:119.45},0).wait(1).to({x:387.15,y:119.1},0).wait(1).to({x:378.9,y:118.75},0).wait(1).to({x:370.7,y:118.4},0).wait(1).to({x:362.45,y:118.05},0).wait(1).to({x:354.25,y:117.7},0).wait(1).to({x:346,y:117.35},0).wait(1).to({x:337.8,y:117},0).wait(1).to({x:329.55,y:116.65},0).wait(1).to({x:321.35,y:116.25},0).wait(1).to({x:313.15,y:115.9},0).wait(1).to({x:304.9,y:115.5},0).wait(1).to({x:296.7,y:115.15},0).wait(1).to({x:288.45,y:114.75},0).wait(1).to({x:280.25,y:114.35},0).wait(1).to({x:272.05,y:113.95},0).wait(1).to({x:263.8,y:113.55},0).wait(1).to({x:255.6,y:113.15},0).wait(1).to({x:247.4,y:112.75},0).wait(1).to({x:239.15,y:112.35},0).wait(1).to({x:230.95,y:111.9},0).wait(1).to({x:222.75,y:111.5},0).wait(1).to({x:214.5,y:111.05},0).wait(1).to({x:206.3,y:110.65},0).wait(1).to({x:198.1,y:110.2},0).wait(1).to({x:189.9,y:109.75},0).wait(1).to({x:181.65,y:109.3},0).wait(1).to({x:173.45,y:108.9},0).wait(1).to({x:165.3,y:108.45},0).wait(1).to({x:157.1,y:107.95},0).wait(1).to({x:148.85,y:107.5},0).wait(1).to({x:140.65,y:107.05},0).wait(1).to({x:132.45,y:106.6},0).wait(1).to({x:124.25,y:106.1},0).wait(1).to({x:116,y:105.65},0).wait(1).to({x:107.8,y:105.15},0).wait(1).to({x:99.6,y:104.65},0).wait(1).to({x:91.4,y:104.2},0).wait(1).to({x:83.2,y:103.7},0).wait(1).to({x:75,y:103.2},0).wait(1).to({x:66.75,y:102.7},0).wait(1).to({x:58.55,y:102.2},0).wait(1).to({x:50.35,y:101.7},0).wait(1).to({x:42.15,y:101.15},0).wait(1).to({x:33.95,y:100.65},0).wait(1).to({x:25.75,y:100.15},0).wait(1).to({x:17.55,y:99.6},0).wait(1).to({x:9.35,y:99.05},0).wait(1).to({x:1.15,y:98.55},0).wait(1).to({x:-7.1,y:98},0).wait(1).to({x:-15.3,y:97.45},0).wait(1).to({x:-23.5,y:96.9},0).wait(1).to({x:-31.7,y:96.35},0).wait(1).to({x:-39.9,y:95.8},0).wait(1).to({x:-48.1,y:95.25},0).wait(1).to({x:-56.3,y:94.65},0).wait(1).to({x:-64.5,y:94.1},0).wait(1).to({x:-72.7,y:93.55},0).wait(1).to({x:-80.9,y:92.95},0).wait(1).to({x:-89.1,y:92.35},0).wait(1).to({x:-97.3,y:91.8},0).wait(1).to({x:-105.5,y:91.2},0).wait(1).to({x:-113.7,y:90.6},0).wait(1).to({x:-121.9,y:90},0).wait(1).to({x:-130.1,y:89.4},0).wait(1).to({x:-138.3,y:88.8},0).wait(1).to({x:-146.5,y:88.2},0).wait(1).to({x:-154.7,y:87.55},0).wait(1).to({x:-162.85,y:86.95},0).wait(1).to({x:-171.1,y:86.35},0).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-342.1,0,2714.7999999999997,433.4);


(lib.nenufar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.CachedTexturedBitmap_746();
	this.instance.parent = this;
	this.instance.setTransform(265.55,77,0.5,0.5);

	this.instance_1 = new lib.CachedTexturedBitmap_745();
	this.instance_1.parent = this;
	this.instance_1.setTransform(219,107.7,0.5,0.5);

	this.instance_2 = new lib.CachedTexturedBitmap_744();
	this.instance_2.parent = this;
	this.instance_2.setTransform(218.7,116.75,0.5,0.5);

	this.instance_3 = new lib.CachedTexturedBitmap_743();
	this.instance_3.parent = this;
	this.instance_3.setTransform(218.65,107.95,0.5,0.5);

	this.instance_4 = new lib.CachedTexturedBitmap_742();
	this.instance_4.parent = this;
	this.instance_4.setTransform(278.95,85.95,0.5,0.5);

	this.instance_5 = new lib.CachedTexturedBitmap_741();
	this.instance_5.parent = this;
	this.instance_5.setTransform(233.4,108.85,0.5,0.5);

	this.instance_6 = new lib.CachedTexturedBitmap_740();
	this.instance_6.parent = this;
	this.instance_6.setTransform(233.35,105.1,0.5,0.5);

	this.instance_7 = new lib.CachedTexturedBitmap_739();
	this.instance_7.parent = this;
	this.instance_7.setTransform(234.15,108.2,0.5,0.5);

	this.instance_8 = new lib.CachedTexturedBitmap_738();
	this.instance_8.parent = this;
	this.instance_8.setTransform(233.55,105.3,0.5,0.5);

	this.instance_9 = new lib.CachedTexturedBitmap_737();
	this.instance_9.parent = this;
	this.instance_9.setTransform(265.5,86.05,0.5,0.5);

	this.instance_10 = new lib.CachedTexturedBitmap_736();
	this.instance_10.parent = this;
	this.instance_10.setTransform(265.55,77.2,0.5,0.5);

	this.instance_11 = new lib.CachedTexturedBitmap_735();
	this.instance_11.parent = this;
	this.instance_11.setTransform(280.1,95.35,0.5,0.5);

	this.instance_12 = new lib.CachedTexturedBitmap_734();
	this.instance_12.parent = this;
	this.instance_12.setTransform(278.9,86.2,0.5,0.5);

	this.instance_13 = new lib.CachedTexturedBitmap_733();
	this.instance_13.parent = this;
	this.instance_13.setTransform(0.55,24.8,0.5,0.5);

	this.instance_14 = new lib.CachedTexturedBitmap_732();
	this.instance_14.parent = this;
	this.instance_14.setTransform(80.2,21.3,0.5,0.5);

	this.instance_15 = new lib.CachedTexturedBitmap_731();
	this.instance_15.parent = this;
	this.instance_15.setTransform(0,53.05,0.5,0.5);

	this.instance_16 = new lib.CachedTexturedBitmap_730();
	this.instance_16.parent = this;
	this.instance_16.setTransform(3.25,77.65,0.5,0.5);

	this.instance_17 = new lib.CachedTexturedBitmap_729();
	this.instance_17.parent = this;
	this.instance_17.setTransform(5.35,79.8,0.5,0.5);

	this.instance_18 = new lib.CachedTexturedBitmap_729();
	this.instance_18.parent = this;
	this.instance_18.setTransform(8.15,82,0.5,0.5);

	this.instance_19 = new lib.CachedTexturedBitmap_730();
	this.instance_19.parent = this;
	this.instance_19.setTransform(11.3,84.8,0.5,0.5);

	this.instance_20 = new lib.CachedTexturedBitmap_729();
	this.instance_20.parent = this;
	this.instance_20.setTransform(15,86.5,0.5,0.5);

	this.instance_21 = new lib.CachedTexturedBitmap_729();
	this.instance_21.parent = this;
	this.instance_21.setTransform(18.35,88.85,0.5,0.5);

	this.instance_22 = new lib.CachedTexturedBitmap_729();
	this.instance_22.parent = this;
	this.instance_22.setTransform(22.4,90.55,0.5,0.5);

	this.instance_23 = new lib.CachedTexturedBitmap_730();
	this.instance_23.parent = this;
	this.instance_23.setTransform(27.6,91.95,0.5,0.5);

	this.instance_24 = new lib.CachedTexturedBitmap_730();
	this.instance_24.parent = this;
	this.instance_24.setTransform(33.05,94.65,0.5,0.5);

	this.instance_25 = new lib.CachedTexturedBitmap_730();
	this.instance_25.parent = this;
	this.instance_25.setTransform(39.95,97,0.5,0.5);

	this.instance_26 = new lib.CachedTexturedBitmap_730();
	this.instance_26.parent = this;
	this.instance_26.setTransform(46.65,98.7,0.5,0.5);

	this.instance_27 = new lib.CachedTexturedBitmap_730();
	this.instance_27.parent = this;
	this.instance_27.setTransform(53.2,100.05,0.5,0.5);

	this.instance_28 = new lib.CachedTexturedBitmap_729();
	this.instance_28.parent = this;
	this.instance_28.setTransform(59.65,101.75,0.5,0.5);

	this.instance_29 = new lib.CachedTexturedBitmap_730();
	this.instance_29.parent = this;
	this.instance_29.setTransform(65.95,102.75,0.5,0.5);

	this.instance_30 = new lib.CachedTexturedBitmap_730();
	this.instance_30.parent = this;
	this.instance_30.setTransform(73.6,103.5,0.5,0.5);

	this.instance_31 = new lib.CachedTexturedBitmap_730();
	this.instance_31.parent = this;
	this.instance_31.setTransform(82.35,105.1,0.5,0.5);

	this.instance_32 = new lib.CachedTexturedBitmap_729();
	this.instance_32.parent = this;
	this.instance_32.setTransform(90.15,106.8,0.5,0.5);

	this.instance_33 = new lib.CachedTexturedBitmap_729();
	this.instance_33.parent = this;
	this.instance_33.setTransform(98.35,106.8,0.5,0.5);

	this.instance_34 = new lib.CachedTexturedBitmap_729();
	this.instance_34.parent = this;
	this.instance_34.setTransform(107.05,106.8,0.5,0.5);

	this.instance_35 = new lib.CachedTexturedBitmap_729();
	this.instance_35.parent = this;
	this.instance_35.setTransform(116.2,108.15,0.5,0.5);

	this.instance_36 = new lib.CachedTexturedBitmap_730();
	this.instance_36.parent = this;
	this.instance_36.setTransform(204.75,64,0.5,0.5);

	this.instance_37 = new lib.CachedTexturedBitmap_729();
	this.instance_37.parent = this;
	this.instance_37.setTransform(202.25,69.6,0.5,0.5);

	this.instance_38 = new lib.CachedTexturedBitmap_729();
	this.instance_38.parent = this;
	this.instance_38.setTransform(199.1,74.4,0.5,0.5);

	this.instance_39 = new lib.CachedTexturedBitmap_730();
	this.instance_39.parent = this;
	this.instance_39.setTransform(195.05,78.1,0.5,0.5);

	this.instance_40 = new lib.CachedTexturedBitmap_729();
	this.instance_40.parent = this;
	this.instance_40.setTransform(189.85,81.7,0.5,0.5);

	this.instance_41 = new lib.CachedTexturedBitmap_730();
	this.instance_41.parent = this;
	this.instance_41.setTransform(185.7,84.8,0.5,0.5);

	this.instance_42 = new lib.CachedTexturedBitmap_729();
	this.instance_42.parent = this;
	this.instance_42.setTransform(181.55,87.2,0.5,0.5);

	this.instance_43 = new lib.CachedTexturedBitmap_730();
	this.instance_43.parent = this;
	this.instance_43.setTransform(177.25,89.85,0.5,0.5);

	this.instance_44 = new lib.CachedTexturedBitmap_729();
	this.instance_44.parent = this;
	this.instance_44.setTransform(172.05,92.9,0.5,0.5);

	this.instance_45 = new lib.CachedTexturedBitmap_730();
	this.instance_45.parent = this;
	this.instance_45.setTransform(166.25,95.35,0.5,0.5);

	this.instance_46 = new lib.CachedTexturedBitmap_730();
	this.instance_46.parent = this;
	this.instance_46.setTransform(161.1,97.95,0.5,0.5);

	this.instance_47 = new lib.CachedTexturedBitmap_730();
	this.instance_47.parent = this;
	this.instance_47.setTransform(155.6,101.05,0.5,0.5);

	this.instance_48 = new lib.CachedTexturedBitmap_729();
	this.instance_48.parent = this;
	this.instance_48.setTransform(149.7,104.1,0.5,0.5);

	this.instance_49 = new lib.CachedTexturedBitmap_697();
	this.instance_49.parent = this;
	this.instance_49.setTransform(202.2,51.9,0.5,0.5);

	this.instance_50 = new lib.CachedTexturedBitmap_696();
	this.instance_50.parent = this;
	this.instance_50.setTransform(198.75,47.35,0.5,0.5);

	this.instance_51 = new lib.CachedTexturedBitmap_695();
	this.instance_51.parent = this;
	this.instance_51.setTransform(194.05,43.2,0.5,0.5);

	this.instance_52 = new lib.CachedTexturedBitmap_694();
	this.instance_52.parent = this;
	this.instance_52.setTransform(189.15,40.95,0.5,0.5);

	this.instance_53 = new lib.CachedTexturedBitmap_693();
	this.instance_53.parent = this;
	this.instance_53.setTransform(183.65,38.15,0.5,0.5);

	this.instance_54 = new lib.CachedTexturedBitmap_692();
	this.instance_54.parent = this;
	this.instance_54.setTransform(178.2,35.85,0.5,0.5);

	this.instance_55 = new lib.CachedTexturedBitmap_691();
	this.instance_55.parent = this;
	this.instance_55.setTransform(172.95,34.25,0.5,0.5);

	this.instance_56 = new lib.CachedTexturedBitmap_690();
	this.instance_56.parent = this;
	this.instance_56.setTransform(167.35,32.25,0.5,0.5);

	this.instance_57 = new lib.CachedTexturedBitmap_689();
	this.instance_57.parent = this;
	this.instance_57.setTransform(160.6,29.9,0.5,0.5);

	this.instance_58 = new lib.CachedTexturedBitmap_688();
	this.instance_58.parent = this;
	this.instance_58.setTransform(153.8,28.3,0.5,0.5);

	this.instance_59 = new lib.CachedTexturedBitmap_687();
	this.instance_59.parent = this;
	this.instance_59.setTransform(146.8,26.55,0.5,0.5);

	this.instance_60 = new lib.CachedTexturedBitmap_686();
	this.instance_60.parent = this;
	this.instance_60.setTransform(139.35,25.35,0.5,0.5);

	this.instance_61 = new lib.CachedTexturedBitmap_730();
	this.instance_61.parent = this;
	this.instance_61.setTransform(133.35,24.25,0.5,0.5);

	this.instance_62 = new lib.CachedTexturedBitmap_686();
	this.instance_62.parent = this;
	this.instance_62.setTransform(126.6,23.7,0.5,0.5);

	this.instance_63 = new lib.CachedTexturedBitmap_683();
	this.instance_63.parent = this;
	this.instance_63.setTransform(120.35,23.55,0.5,0.5);

	this.instance_64 = new lib.CachedTexturedBitmap_688();
	this.instance_64.parent = this;
	this.instance_64.setTransform(114.75,23.7,0.5,0.5);

	this.instance_65 = new lib.CachedTexturedBitmap_681();
	this.instance_65.parent = this;
	this.instance_65.setTransform(101.35,25.1,0.5,0.5);

	this.instance_66 = new lib.CachedTexturedBitmap_681();
	this.instance_66.parent = this;
	this.instance_66.setTransform(108.5,24.7,0.5,0.5);

	this.instance_67 = new lib.CachedTexturedBitmap_695();
	this.instance_67.parent = this;
	this.instance_67.setTransform(5.25,55.15,0.5,0.5);

	this.instance_68 = new lib.CachedTexturedBitmap_695();
	this.instance_68.parent = this;
	this.instance_68.setTransform(7.8,52.5,0.5,0.5);

	this.instance_69 = new lib.CachedTexturedBitmap_695();
	this.instance_69.parent = this;
	this.instance_69.setTransform(11.15,50.05,0.5,0.5);

	this.instance_70 = new lib.CachedTexturedBitmap_695();
	this.instance_70.parent = this;
	this.instance_70.setTransform(15,47.4,0.5,0.5);

	this.instance_71 = new lib.CachedTexturedBitmap_695();
	this.instance_71.parent = this;
	this.instance_71.setTransform(18.8,45.3,0.5,0.5);

	this.instance_72 = new lib.CachedTexturedBitmap_695();
	this.instance_72.parent = this;
	this.instance_72.setTransform(24.1,42.55,0.5,0.5);

	this.instance_73 = new lib.CachedTexturedBitmap_695();
	this.instance_73.parent = this;
	this.instance_73.setTransform(29.75,40.4,0.5,0.5);

	this.instance_74 = new lib.CachedTexturedBitmap_695();
	this.instance_74.parent = this;
	this.instance_74.setTransform(35.5,38.3,0.5,0.5);

	this.instance_75 = new lib.CachedTexturedBitmap_695();
	this.instance_75.parent = this;
	this.instance_75.setTransform(41.45,36.5,0.5,0.5);

	this.instance_76 = new lib.CachedTexturedBitmap_695();
	this.instance_76.parent = this;
	this.instance_76.setTransform(47.3,34.75,0.5,0.5);

	this.instance_77 = new lib.CachedTexturedBitmap_695();
	this.instance_77.parent = this;
	this.instance_77.setTransform(52.45,33.45,0.5,0.5);

	this.instance_78 = new lib.CachedTexturedBitmap_695();
	this.instance_78.parent = this;
	this.instance_78.setTransform(58.5,31.7,0.5,0.5);

	this.instance_79 = new lib.CachedTexturedBitmap_695();
	this.instance_79.parent = this;
	this.instance_79.setTransform(64.65,30.45,0.5,0.5);

	this.instance_80 = new lib.CachedTexturedBitmap_695();
	this.instance_80.parent = this;
	this.instance_80.setTransform(70.15,29.2,0.5,0.5);

	this.instance_81 = new lib.CachedTexturedBitmap_665();
	this.instance_81.parent = this;
	this.instance_81.setTransform(94.25,26.85,0.5,0.5);

	this.instance_82 = new lib.CachedTexturedBitmap_664();
	this.instance_82.parent = this;
	this.instance_82.setTransform(84.05,71.15,0.5,0.5);

	this.instance_83 = new lib.CachedTexturedBitmap_663();
	this.instance_83.parent = this;
	this.instance_83.setTransform(114.3,64.8,0.5,0.5);

	this.instance_84 = new lib.CachedTexturedBitmap_662();
	this.instance_84.parent = this;
	this.instance_84.setTransform(105.15,71.2,0.5,0.5);

	this.instance_85 = new lib.CachedTexturedBitmap_661();
	this.instance_85.parent = this;
	this.instance_85.setTransform(96.6,72.6,0.5,0.5);

	this.instance_86 = new lib.CachedTexturedBitmap_660();
	this.instance_86.parent = this;
	this.instance_86.setTransform(111.4,67.55,0.5,0.5);

	this.instance_87 = new lib.CachedTexturedBitmap_659();
	this.instance_87.parent = this;
	this.instance_87.setTransform(108.55,68.85,0.5,0.5);

	this.instance_88 = new lib.CachedTexturedBitmap_658();
	this.instance_88.parent = this;
	this.instance_88.setTransform(107.05,69.55,0.5,0.5);

	this.instance_89 = new lib.CachedTexturedBitmap_657();
	this.instance_89.parent = this;
	this.instance_89.setTransform(0,33.55,0.5,0.5);

	this.instance_90 = new lib.CachedTexturedBitmap_656();
	this.instance_90.parent = this;
	this.instance_90.setTransform(130.6,106.2,0.5,0.5);

	this.instance_91 = new lib.CachedTexturedBitmap_655();
	this.instance_91.parent = this;
	this.instance_91.setTransform(83.4,33.75,0.5,0.5);

	this.instance_92 = new lib.CachedTexturedBitmap_654();
	this.instance_92.parent = this;
	this.instance_92.setTransform(0.25,21.45,0.5,0.5);

	this.instance_93 = new lib.CachedTexturedBitmap_653();
	this.instance_93.parent = this;
	this.instance_93.setTransform(237.45,26.6,0.5,0.5);

	this.instance_94 = new lib.CachedTexturedBitmap_653();
	this.instance_94.parent = this;
	this.instance_94.setTransform(236.45,27.65,0.5,0.5);

	this.instance_95 = new lib.CachedTexturedBitmap_651();
	this.instance_95.parent = this;
	this.instance_95.setTransform(235.15,28.65,0.5,0.5);

	this.instance_96 = new lib.CachedTexturedBitmap_653();
	this.instance_96.parent = this;
	this.instance_96.setTransform(233.65,30,0.5,0.5);

	this.instance_97 = new lib.CachedTexturedBitmap_653();
	this.instance_97.parent = this;
	this.instance_97.setTransform(231.85,30.8,0.5,0.5);

	this.instance_98 = new lib.CachedTexturedBitmap_653();
	this.instance_98.parent = this;
	this.instance_98.setTransform(230.3,31.95,0.5,0.5);

	this.instance_99 = new lib.CachedTexturedBitmap_653();
	this.instance_99.parent = this;
	this.instance_99.setTransform(228.35,32.75,0.5,0.5);

	this.instance_100 = new lib.CachedTexturedBitmap_653();
	this.instance_100.parent = this;
	this.instance_100.setTransform(225.85,33.4,0.5,0.5);

	this.instance_101 = new lib.CachedTexturedBitmap_651();
	this.instance_101.parent = this;
	this.instance_101.setTransform(223.3,34.65,0.5,0.5);

	this.instance_102 = new lib.CachedTexturedBitmap_653();
	this.instance_102.parent = this;
	this.instance_102.setTransform(220,35.8,0.5,0.5);

	this.instance_103 = new lib.CachedTexturedBitmap_653();
	this.instance_103.parent = this;
	this.instance_103.setTransform(216.8,36.6,0.5,0.5);

	this.instance_104 = new lib.CachedTexturedBitmap_653();
	this.instance_104.parent = this;
	this.instance_104.setTransform(213.7,37.25,0.5,0.5);

	this.instance_105 = new lib.CachedTexturedBitmap_653();
	this.instance_105.parent = this;
	this.instance_105.setTransform(210.65,38.05,0.5,0.5);

	this.instance_106 = new lib.CachedTexturedBitmap_653();
	this.instance_106.parent = this;
	this.instance_106.setTransform(207.65,38.55,0.5,0.5);

	this.instance_107 = new lib.CachedTexturedBitmap_653();
	this.instance_107.parent = this;
	this.instance_107.setTransform(204,38.9,0.5,0.5);

	this.instance_108 = new lib.CachedTexturedBitmap_653();
	this.instance_108.parent = this;
	this.instance_108.setTransform(199.85,39.65,0.5,0.5);

	this.instance_109 = new lib.CachedTexturedBitmap_653();
	this.instance_109.parent = this;
	this.instance_109.setTransform(196.15,40.45,0.5,0.5);

	this.instance_110 = new lib.CachedTexturedBitmap_653();
	this.instance_110.parent = this;
	this.instance_110.setTransform(192.25,40.45,0.5,0.5);

	this.instance_111 = new lib.CachedTexturedBitmap_653();
	this.instance_111.parent = this;
	this.instance_111.setTransform(188.1,40.45,0.5,0.5);

	this.instance_112 = new lib.CachedTexturedBitmap_653();
	this.instance_112.parent = this;
	this.instance_112.setTransform(183.75,41.1,0.5,0.5);

	this.instance_113 = new lib.CachedTexturedBitmap_653();
	this.instance_113.parent = this;
	this.instance_113.setTransform(141.65,22.25,0.5,0.5);

	this.instance_114 = new lib.CachedTexturedBitmap_653();
	this.instance_114.parent = this;
	this.instance_114.setTransform(142.85,23.9,0.5,0.5);

	this.instance_115 = new lib.CachedTexturedBitmap_651();
	this.instance_115.parent = this;
	this.instance_115.setTransform(144.35,26.15,0.5,0.5);

	this.instance_116 = new lib.CachedTexturedBitmap_653();
	this.instance_116.parent = this;
	this.instance_116.setTransform(146.25,27.95,0.5,0.5);

	this.instance_117 = new lib.CachedTexturedBitmap_653();
	this.instance_117.parent = this;
	this.instance_117.setTransform(148.75,29.65,0.5,0.5);

	this.instance_118 = new lib.CachedTexturedBitmap_651();
	this.instance_118.parent = this;
	this.instance_118.setTransform(150.7,31.1,0.5,0.5);

	this.instance_119 = new lib.CachedTexturedBitmap_653();
	this.instance_119.parent = this;
	this.instance_119.setTransform(152.7,32.25,0.5,0.5);

	this.instance_120 = new lib.CachedTexturedBitmap_653();
	this.instance_120.parent = this;
	this.instance_120.setTransform(154.7,33.5,0.5,0.5);

	this.instance_121 = new lib.CachedTexturedBitmap_653();
	this.instance_121.parent = this;
	this.instance_121.setTransform(157.2,35,0.5,0.5);

	this.instance_122 = new lib.CachedTexturedBitmap_651();
	this.instance_122.parent = this;
	this.instance_122.setTransform(159.95,36.1,0.5,0.5);

	this.instance_123 = new lib.CachedTexturedBitmap_653();
	this.instance_123.parent = this;
	this.instance_123.setTransform(162.4,37.35,0.5,0.5);

	this.instance_124 = new lib.CachedTexturedBitmap_653();
	this.instance_124.parent = this;
	this.instance_124.setTransform(165,38.85,0.5,0.5);

	this.instance_125 = new lib.CachedTexturedBitmap_653();
	this.instance_125.parent = this;
	this.instance_125.setTransform(167.85,40.3,0.5,0.5);

	this.instance_126 = new lib.CachedTexturedBitmap_620();
	this.instance_126.parent = this;
	this.instance_126.setTransform(142.85,14.35,0.5,0.5);

	this.instance_127 = new lib.CachedTexturedBitmap_619();
	this.instance_127.parent = this;
	this.instance_127.setTransform(144.5,12.2,0.5,0.5);

	this.instance_128 = new lib.CachedTexturedBitmap_618();
	this.instance_128.parent = this;
	this.instance_128.setTransform(146.7,10.2,0.5,0.5);

	this.instance_129 = new lib.CachedTexturedBitmap_617();
	this.instance_129.parent = this;
	this.instance_129.setTransform(149.05,9.15,0.5,0.5);

	this.instance_130 = new lib.CachedTexturedBitmap_616();
	this.instance_130.parent = this;
	this.instance_130.setTransform(151.65,7.8,0.5,0.5);

	this.instance_131 = new lib.CachedTexturedBitmap_615();
	this.instance_131.parent = this;
	this.instance_131.setTransform(154.25,6.7,0.5,0.5);

	this.instance_132 = new lib.CachedTexturedBitmap_618();
	this.instance_132.parent = this;
	this.instance_132.setTransform(156.8,5.95,0.5,0.5);

	this.instance_133 = new lib.CachedTexturedBitmap_613();
	this.instance_133.parent = this;
	this.instance_133.setTransform(159.4,5,0.5,0.5);

	this.instance_134 = new lib.CachedTexturedBitmap_612();
	this.instance_134.parent = this;
	this.instance_134.setTransform(162.65,3.9,0.5,0.5);

	this.instance_135 = new lib.CachedTexturedBitmap_611();
	this.instance_135.parent = this;
	this.instance_135.setTransform(165.85,3.3,0.5,0.5);

	this.instance_136 = new lib.CachedTexturedBitmap_610();
	this.instance_136.parent = this;
	this.instance_136.setTransform(169.2,2.8,0.5,0.5);

	this.instance_137 = new lib.CachedTexturedBitmap_610();
	this.instance_137.parent = this;
	this.instance_137.setTransform(172.75,2.1,0.5,0.5);

	this.instance_138 = new lib.CachedTexturedBitmap_653();
	this.instance_138.parent = this;
	this.instance_138.setTransform(175.6,1.65,0.5,0.5);

	this.instance_139 = new lib.CachedTexturedBitmap_610();
	this.instance_139.parent = this;
	this.instance_139.setTransform(178.8,1.65,0.5,0.5);

	this.instance_140 = new lib.CachedTexturedBitmap_606();
	this.instance_140.parent = this;
	this.instance_140.setTransform(181.8,1.65,0.5,0.5);

	this.instance_141 = new lib.CachedTexturedBitmap_611();
	this.instance_141.parent = this;
	this.instance_141.setTransform(184.45,1.45,0.5,0.5);

	this.instance_142 = new lib.CachedTexturedBitmap_604();
	this.instance_142.parent = this;
	this.instance_142.setTransform(190.8,1.9,0.5,0.5);

	this.instance_143 = new lib.CachedTexturedBitmap_604();
	this.instance_143.parent = this;
	this.instance_143.setTransform(187.4,1.75,0.5,0.5);

	this.instance_144 = new lib.CachedTexturedBitmap_618();
	this.instance_144.parent = this;
	this.instance_144.setTransform(236.5,15.9,0.5,0.5);

	this.instance_145 = new lib.CachedTexturedBitmap_601();
	this.instance_145.parent = this;
	this.instance_145.setTransform(235.3,14.65,0.5,0.5);

	this.instance_146 = new lib.CachedTexturedBitmap_618();
	this.instance_146.parent = this;
	this.instance_146.setTransform(233.7,13.45,0.5,0.5);

	this.instance_147 = new lib.CachedTexturedBitmap_618();
	this.instance_147.parent = this;
	this.instance_147.setTransform(231.85,12.2,0.5,0.5);

	this.instance_148 = new lib.CachedTexturedBitmap_618();
	this.instance_148.parent = this;
	this.instance_148.setTransform(230.05,11.2,0.5,0.5);

	this.instance_149 = new lib.CachedTexturedBitmap_618();
	this.instance_149.parent = this;
	this.instance_149.setTransform(227.55,9.9,0.5,0.5);

	this.instance_150 = new lib.CachedTexturedBitmap_601();
	this.instance_150.parent = this;
	this.instance_150.setTransform(224.85,8.9,0.5,0.5);

	this.instance_151 = new lib.CachedTexturedBitmap_601();
	this.instance_151.parent = this;
	this.instance_151.setTransform(222.1,7.9,0.5,0.5);

	this.instance_152 = new lib.CachedTexturedBitmap_618();
	this.instance_152.parent = this;
	this.instance_152.setTransform(219.3,7,0.5,0.5);

	this.instance_153 = new lib.CachedTexturedBitmap_601();
	this.instance_153.parent = this;
	this.instance_153.setTransform(216.5,6.2,0.5,0.5);

	this.instance_154 = new lib.CachedTexturedBitmap_601();
	this.instance_154.parent = this;
	this.instance_154.setTransform(214.05,5.6,0.5,0.5);

	this.instance_155 = new lib.CachedTexturedBitmap_601();
	this.instance_155.parent = this;
	this.instance_155.setTransform(211.2,4.75,0.5,0.5);

	this.instance_156 = new lib.CachedTexturedBitmap_601();
	this.instance_156.parent = this;
	this.instance_156.setTransform(208.25,4.15,0.5,0.5);

	this.instance_157 = new lib.CachedTexturedBitmap_618();
	this.instance_157.parent = this;
	this.instance_157.setTransform(205.65,3.55,0.5,0.5);

	this.instance_158 = new lib.CachedTexturedBitmap_588();
	this.instance_158.parent = this;
	this.instance_158.setTransform(194.2,2.45,0.5,0.5);

	this.instance_159 = new lib.CachedTexturedBitmap_587();
	this.instance_159.parent = this;
	this.instance_159.setTransform(192.25,23.45,0.5,0.5);

	this.instance_160 = new lib.CachedTexturedBitmap_586();
	this.instance_160.parent = this;
	this.instance_160.setTransform(175.2,20.4,0.5,0.5);

	this.instance_161 = new lib.CachedTexturedBitmap_585();
	this.instance_161.parent = this;
	this.instance_161.setTransform(188.35,23.55,0.5,0.5);

	this.instance_162 = new lib.CachedTexturedBitmap_584();
	this.instance_162.parent = this;
	this.instance_162.setTransform(189.95,24.2,0.5,0.5);

	this.instance_163 = new lib.CachedTexturedBitmap_583();
	this.instance_163.parent = this;
	this.instance_163.setTransform(176.7,21.7,0.5,0.5);

	this.instance_164 = new lib.CachedTexturedBitmap_582();
	this.instance_164.parent = this;
	this.instance_164.setTransform(178.55,22.35,0.5,0.5);

	this.instance_165 = new lib.CachedTexturedBitmap_581();
	this.instance_165.parent = this;
	this.instance_165.setTransform(179.45,22.7,0.5,0.5);

	this.instance_166 = new lib.CachedTexturedBitmap_580();
	this.instance_166.parent = this;
	this.instance_166.setTransform(171.05,41.6,0.5,0.5);

	this.instance_167 = new lib.CachedTexturedBitmap_579();
	this.instance_167.parent = this;
	this.instance_167.setTransform(141.7,6.95,0.5,0.5);

	this.instance_168 = new lib.CachedTexturedBitmap_578();
	this.instance_168.parent = this;
	this.instance_168.setTransform(140.95,16.7,0.5,0.5);

	this.instance_169 = new lib.CachedTexturedBitmap_577();
	this.instance_169.parent = this;
	this.instance_169.setTransform(238.85,19.4,0.5,0.5);

	this.instance_170 = new lib.CachedTexturedBitmap_576();
	this.instance_170.parent = this;
	this.instance_170.setTransform(140.95,0,0.5,0.5);

	this.instance_171 = new lib.CachedTexturedBitmap_575();
	this.instance_171.parent = this;
	this.instance_171.setTransform(193.65,7.3,0.5,0.5);

	this.instance_172 = new lib.CachedTexturedBitmap_574();
	this.instance_172.parent = this;
	this.instance_172.setTransform(141.05,0.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_172},{t:this.instance_171},{t:this.instance_170},{t:this.instance_169},{t:this.instance_168},{t:this.instance_167},{t:this.instance_166},{t:this.instance_165},{t:this.instance_164},{t:this.instance_163},{t:this.instance_162},{t:this.instance_161},{t:this.instance_160},{t:this.instance_159},{t:this.instance_158},{t:this.instance_157},{t:this.instance_156},{t:this.instance_155},{t:this.instance_154},{t:this.instance_153},{t:this.instance_152},{t:this.instance_151},{t:this.instance_150},{t:this.instance_149},{t:this.instance_148},{t:this.instance_147},{t:this.instance_146},{t:this.instance_145},{t:this.instance_144},{t:this.instance_143},{t:this.instance_142},{t:this.instance_141},{t:this.instance_140},{t:this.instance_139},{t:this.instance_138},{t:this.instance_137},{t:this.instance_136},{t:this.instance_135},{t:this.instance_134},{t:this.instance_133},{t:this.instance_132},{t:this.instance_131},{t:this.instance_130},{t:this.instance_129},{t:this.instance_128},{t:this.instance_127},{t:this.instance_126},{t:this.instance_125},{t:this.instance_124},{t:this.instance_123},{t:this.instance_122},{t:this.instance_121},{t:this.instance_120},{t:this.instance_119},{t:this.instance_118},{t:this.instance_117},{t:this.instance_116},{t:this.instance_115},{t:this.instance_114},{t:this.instance_113},{t:this.instance_112},{t:this.instance_111},{t:this.instance_110},{t:this.instance_109},{t:this.instance_108},{t:this.instance_107},{t:this.instance_106},{t:this.instance_105},{t:this.instance_104},{t:this.instance_103},{t:this.instance_102},{t:this.instance_101},{t:this.instance_100},{t:this.instance_99},{t:this.instance_98},{t:this.instance_97},{t:this.instance_96},{t:this.instance_95},{t:this.instance_94},{t:this.instance_93},{t:this.instance_92},{t:this.instance_91},{t:this.instance_90},{t:this.instance_89},{t:this.instance_88},{t:this.instance_87},{t:this.instance_86},{t:this.instance_85},{t:this.instance_84},{t:this.instance_83},{t:this.instance_82},{t:this.instance_81},{t:this.instance_80},{t:this.instance_79},{t:this.instance_78},{t:this.instance_77},{t:this.instance_76},{t:this.instance_75},{t:this.instance_74},{t:this.instance_73},{t:this.instance_72},{t:this.instance_71},{t:this.instance_70},{t:this.instance_69},{t:this.instance_68},{t:this.instance_67},{t:this.instance_66},{t:this.instance_65},{t:this.instance_64},{t:this.instance_63},{t:this.instance_62},{t:this.instance_61},{t:this.instance_60},{t:this.instance_59},{t:this.instance_58},{t:this.instance_57},{t:this.instance_56},{t:this.instance_55},{t:this.instance_54},{t:this.instance_53},{t:this.instance_52},{t:this.instance_51},{t:this.instance_50},{t:this.instance_49},{t:this.instance_48},{t:this.instance_47},{t:this.instance_46},{t:this.instance_45},{t:this.instance_44},{t:this.instance_43},{t:this.instance_42},{t:this.instance_41},{t:this.instance_40},{t:this.instance_39},{t:this.instance_38},{t:this.instance_37},{t:this.instance_36},{t:this.instance_35},{t:this.instance_34},{t:this.instance_33},{t:this.instance_32},{t:this.instance_31},{t:this.instance_30},{t:this.instance_29},{t:this.instance_28},{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(96));

	// Capa_1
	this.instance_173 = new lib.PuppetShape_5("synched",1,false);
	this.instance_173.parent = this;
	this.instance_173.setTransform(241.65,79.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_173).wait(23).to({startPosition:24},0).to({startPosition:31},7).to({startPosition:48},17).to({startPosition:72},24).wait(25));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,313.4,130.3);


(lib.garza4 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_2
	this.instance = new lib.Símbolo2();
	this.instance.parent = this;
	this.instance.setTransform(14.45,8.2,1,1,0,0,0,15.2,2.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({regX:8.5,regY:11.7,rotation:-0.5192,x:7.85,y:17.8},0).wait(1).to({rotation:-1.0384,x:7.95,y:17.9},0).wait(1).to({rotation:-1.5576,x:8,y:17.95},0).wait(1).to({rotation:-2.0768,x:8.1,y:18.05},0).wait(1).to({rotation:-2.596,x:8.25},0).wait(1).to({rotation:-3.1152,x:8.35,y:18.15},0).wait(1).to({rotation:-3.6344,x:8.4,y:18.2},0).wait(1).to({rotation:-4.1536,x:8.5,y:18.25},0).wait(1).to({rotation:-4.6728,x:8.55},0).wait(1).to({rotation:-5.192,x:8.65,y:18.35},0).wait(1).to({rotation:-3.0204,x:8.3,y:18.15},0).wait(1).to({rotation:-0.8488,x:7.9,y:17.85},0).wait(1).to({rotation:-2.9103,x:8.3,y:18.1},0).wait(1).to({rotation:-4.9717,x:8.6,y:18.3},0).wait(1).to({rotation:-7.3871,x:9.05,y:18.55},0).wait(1).to({rotation:-9.8025,x:9.55,y:18.8},0).wait(1).to({rotation:-10.2777,x:9.6},0).wait(1).to({rotation:-10.753,x:9.7,y:18.85},0).wait(1).to({rotation:-11.2282,x:9.8,y:18.9},0).wait(1).to({rotation:-11.7034,y:18.95},0).wait(1).to({rotation:-12.1786,x:9.9},0).wait(1).to({rotation:-12.6538,x:10,y:19},0).wait(1).to({rotation:-13.1291,x:10.15},0).wait(1).to({rotation:-13.6043,x:10.2,y:19.05},0).wait(1).to({rotation:-14.0795,x:10.3,y:19.15},0).wait(1).to({rotation:-14.5547,x:10.4,y:19.1},0).wait(1).to({rotation:-15.0299,x:10.5,y:19.2},0).wait(1).to({rotation:-15.5052,x:10.6},0).wait(1).to({rotation:-15.9804,y:19.25},0).wait(1).to({rotation:-16.4556,x:10.75},0).wait(1).to({rotation:-16.9308,x:10.85,y:19.3},0).wait(1).to({rotation:-17.406,x:10.95},0).wait(1).to({rotation:-17.8813,x:11.05,y:19.4},0).wait(1).to({rotation:-18.3565,x:11.1,y:19.35},0).wait(1).to({rotation:-18.8317,x:11.25,y:19.4},0).wait(1).to({rotation:-19.3069,y:19.45},0).wait(1).to({rotation:-19.7821,x:11.4},0).wait(1).to({rotation:-20.2574,x:11.45,y:19.5},0).wait(1).to({rotation:-20.7326,x:11.6,y:19.55},0).wait(1).to({rotation:-21.2078,x:11.65},0).wait(1).to({rotation:-20.7258,x:11.6},0).wait(1).to({rotation:-20.2438,x:11.45,y:19.5},0).wait(1).to({rotation:-19.7618,x:11.4,y:19.45},0).wait(1).to({rotation:-19.2798,x:11.25},0).wait(1).to({rotation:-18.7978,x:11.2,y:19.4},0).wait(1).to({rotation:-18.3158,x:11.1},0).wait(1).to({rotation:-17.8338,x:11.05,y:19.35},0).wait(1).to({rotation:-17.3518,x:10.9,y:19.3},0).wait(1).to({rotation:-16.8698,x:10.85},0).wait(1).to({rotation:-16.3878,x:10.75,y:19.25},0).wait(1).to({rotation:-15.9058,x:10.6,y:19.2},0).wait(1).to({rotation:-15.4239,x:10.55,y:19.25},0).wait(1).to({rotation:-14.9419,x:10.45,y:19.15},0).wait(1).to({rotation:-14.4599,x:10.35,y:19.2},0).wait(1).to({rotation:-13.9779,x:10.3,y:19.1},0).wait(1).to({rotation:-13.4959,x:10.2,y:19.05},0).wait(1).to({rotation:-13.0139,x:10.15},0).wait(1).to({rotation:-12.5319,x:10,y:18.95},0).wait(1).to({rotation:-12.0499,x:9.9,y:19},0).wait(1).to({rotation:-11.5679,x:9.85,y:18.9},0).wait(1).to({rotation:-11.0859,x:9.75},0).wait(1).to({rotation:-10.6039,x:9.65,y:18.85},0).wait(1).to({rotation:-10.1219,x:9.55,y:18.75},0).wait(1).to({rotation:-9.6399,x:9.5,y:18.8},0).wait(1).to({rotation:-9.1579,x:9.4,y:18.7},0).wait(1).to({rotation:-8.6759,x:9.25,y:18.65},0).wait(1).to({rotation:-8.1939,x:9.15},0).wait(1).to({rotation:-7.7119,x:9.05,y:18.6},0).wait(1).to({rotation:-7.2299,x:9,y:18.55},0).wait(1).to({rotation:-6.7479,x:8.95,y:18.45},0).wait(1).to({rotation:-6.2659,x:8.9},0).wait(1).to({rotation:-5.7839,x:8.8,y:18.4},0).wait(1).to({rotation:-5.3019,x:8.7,y:18.35},0).wait(1).to({rotation:-4.82,x:8.6,y:18.3},0).wait(1).to({rotation:-4.338,x:8.55,y:18.25},0).wait(1).to({rotation:-3.856,x:8.45,y:18.2},0).wait(1).to({rotation:-3.374,x:8.35,y:18.15},0).wait(1).to({rotation:-2.892,x:8.3,y:18.1},0).wait(1).to({rotation:-2.41,x:8.2,y:18.05},0).wait(1).to({rotation:-1.928,x:8.1,y:18},0).wait(1).to({rotation:-1.446,x:8.05,y:17.95},0).wait(1).to({rotation:-0.964,x:7.95,y:17.9},0).wait(1).to({rotation:-0.482,x:7.85,y:17.85},0).wait(1).to({rotation:0,x:7.75,y:17.8},0).wait(16));

	// Capa_1
	this.instance_1 = new lib.CachedTexturedBitmap_573();
	this.instance_1.parent = this;
	this.instance_1.setTransform(16.05,3.95,0.4999,0.4999);

	this.instance_2 = new lib.CachedTexturedBitmap_572();
	this.instance_2.parent = this;
	this.instance_2.setTransform(16.15,4.05,0.4999,0.4999);

	this.instance_3 = new lib.CachedTexturedBitmap_571();
	this.instance_3.parent = this;
	this.instance_3.setTransform(10.5,0,0.4999,0.4999);

	this.instance_4 = new lib.CachedTexturedBitmap_570();
	this.instance_4.parent = this;
	this.instance_4.setTransform(10.6,0.05,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]}).wait(100));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-0.8,0,60.8,41.6);


(lib.garza1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_2
	this.instance = new lib.picogarza1("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(49.15,8.4,1,1,0,0,0,1.1,2.3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({regX:9.3,regY:13,rotation:-1.0713,x:57.55,y:18.95},0).wait(1).to({rotation:-2.1427,x:57.75,y:18.75},0).wait(1).to({rotation:-3.214,x:57.95,y:18.65},0).wait(1).to({rotation:-4.2854,x:58.05,y:18.4},0).wait(1).to({rotation:-5.3567,x:58.25,y:18.3},0).wait(1).to({rotation:-6.4281,x:58.5,y:18.05},0).wait(1).to({rotation:-7.4994,x:58.65,y:17.95},0).wait(1).to({rotation:-8.5708,x:58.85,y:17.7},0).wait(1).to({rotation:-9.6422,x:59,y:17.55},0).wait(1).to({rotation:-10.7135,x:59.2,y:17.3},0).wait(1).to({rotation:-11.7848,x:59.35,y:17.2},0).wait(1).to({rotation:-12.8562,x:59.5,y:16.95},0).wait(1).to({rotation:-13.9275,x:59.7,y:16.75},0).wait(1).to({rotation:-14.9989,x:59.85,y:16.55},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({rotation:-13.999,x:59.65,y:16.75},0).wait(1).to({rotation:-12.999,x:59.5,y:16.9},0).wait(1).to({rotation:-11.9991,x:59.4,y:17.1},0).wait(1).to({rotation:-10.9992,x:59.25,y:17.3},0).wait(1).to({rotation:-9.9993,x:59.05,y:17.5},0).wait(1).to({rotation:-8.9993,x:58.95,y:17.65},0).wait(1).to({rotation:-7.9994,x:58.7,y:17.8},0).wait(1).to({rotation:-6.9995,x:58.6,y:17.95},0).wait(1).to({rotation:-5.9996,x:58.4,y:18.2},0).wait(1).to({rotation:-4.9996,x:58.25,y:18.35},0).wait(1).to({rotation:-3.9997,x:58.05,y:18.45},0).wait(1).to({rotation:-2.9998,x:57.9,y:18.65},0).wait(1).to({rotation:-1.9999,x:57.7,y:18.8},0).wait(1).to({rotation:-0.9999,x:57.55,y:18.95},0).wait(1).to({rotation:0,x:57.35,y:19.1},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1));

	// Capa_1
	this.instance_1 = new lib.CachedTexturedBitmap_569();
	this.instance_1.parent = this;
	this.instance_1.setTransform(19.95,31.8,0.4999,0.4999);

	this.instance_2 = new lib.CachedTexturedBitmap_568();
	this.instance_2.parent = this;
	this.instance_2.setTransform(20.05,31.9,0.4999,0.4999);

	this.instance_3 = new lib.CachedTexturedBitmap_567();
	this.instance_3.parent = this;
	this.instance_3.setTransform(47.25,4,0.4999,0.4999);

	this.instance_4 = new lib.CachedTexturedBitmap_566();
	this.instance_4.parent = this;
	this.instance_4.setTransform(47.25,4.1,0.4999,0.4999);

	this.instance_5 = new lib.CachedTexturedBitmap_565();
	this.instance_5.parent = this;
	this.instance_5.setTransform(0,0,0.4999,0.4999);

	this.instance_6 = new lib.CachedTexturedBitmap_564();
	this.instance_6.parent = this;
	this.instance_6.setTransform(0.05,0.05,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]}).wait(100));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,72,45.1);


(lib.burro = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.PuppetShape_2("synched",1,false);
	this.instance.parent = this;
	this.instance.setTransform(179.5,99,1,1,0,0,0,179.5,99);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({startPosition:10},9).to({startPosition:15},5).to({startPosition:17},2).to({startPosition:21},4).to({startPosition:65},44).to({startPosition:72},7).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,363,198);


(lib.yerba20 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_1
	this.instance = new lib.PuppetShape_3("synched",1,false);
	this.instance.parent = this;
	this.instance.setTransform(22.45,18.4);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(11).to({startPosition:12},0).to({startPosition:18},6).to({startPosition:24},6).wait(49));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.6,-19.3,48.300000000000004,57.3);


(lib.pajaros = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_2
	this.instance = new lib.pajaro1("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(38,19.45,1,1,0,0,0,38,8.8);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(216));

	// Capa_3
	this.instance_1 = new lib.pajaro2("synched",0);
	this.instance_1.parent = this;
	this.instance_1.setTransform(164.8,30.8,1,1,0,0,0,29.9,11.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(216));

	// Capa_4
	this.instance_2 = new lib.pajaro2("synched",0);
	this.instance_2.parent = this;
	this.instance_2.setTransform(256.25,12.9,1,1,0,0,0,29.9,11.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(216));

	// Capa_5
	this.instance_3 = new lib.pajaro2("synched",0);
	this.instance_3.parent = this;
	this.instance_3.setTransform(368.15,3.45,1.2463,1,14.9992,0,0,29.9,11);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(216));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(2.7,-16.6,405,62.7);


(lib.yerbas = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Capa_3
	this.instance = new lib.Símbolo5();
	this.instance.parent = this;
	this.instance.setTransform(109.55,124.9,1,1,0,0,0,58,83.8);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({regX:58.1,regY:42,scaleY:1.0041,skewX:1.4572,x:110.7,y:82.9},0).wait(1).to({scaleY:1.0081,skewX:2.9144,x:111.75,y:82.8},0).wait(1).to({scaleY:1.0121,skewX:4.3715,x:112.85,y:82.7},0).wait(1).to({scaleY:1.0162,skewX:5.8287,x:113.9,y:82.6},0).wait(1).to({scaleY:1.0202,skewX:7.2859,x:115,y:82.55},0).wait(1).to({scaleY:1.0242,skewX:8.7431,x:116.1},0).wait(1).to({scaleY:1.0283,skewX:10.2002,x:117.25},0).wait(1).to({scaleY:1.0323,skewX:11.6574,x:118.35,y:82.6},0).wait(1).to({scaleY:1.0363,skewX:13.1146,x:119.45,y:82.7},0).wait(1).to({scaleY:1.0404,skewX:14.5718,x:120.55,y:82.8},0).wait(1).to({scaleY:1.0444,skewX:16.0289,x:121.7,y:82.9},0).wait(1).to({scaleY:1.0485,skewX:17.4861,x:122.75,y:83.05},0).wait(38).to({skewX:16.6534,x:122.2,y:82.9},0).wait(1).to({skewX:15.8208,x:121.6,y:82.7},0).wait(1).to({skewX:14.9881,x:120.95,y:82.55},0).wait(1).to({skewX:14.1554,x:120.35,y:82.4},0).wait(1).to({skewX:13.3227,x:119.7,y:82.25},0).wait(1).to({skewX:12.4901,x:119.15,y:82.1},0).wait(1).to({skewX:11.6574,x:118.5,y:82},0).wait(1).to({skewX:10.8247,x:117.9,y:81.85},0).wait(1).to({skewX:9.9921,x:117.2,y:81.7},0).wait(1).to({skewX:9.1594,x:116.6,y:81.6},0).wait(1).to({skewX:8.3267,x:115.95,y:81.5},0).wait(1).to({skewX:7.494,x:115.35,y:81.4},0).wait(1).to({skewX:6.6614,x:114.7,y:81.35},0).wait(1).to({skewX:5.8287,x:114.1,y:81.25},0).wait(1).to({skewX:4.996,x:113.45,y:81.2},0).wait(1).to({skewX:4.1634,x:112.8,y:81.15},0).wait(1).to({skewX:3.3307,x:112.2,y:81.1},0).wait(1).to({skewX:2.498,x:111.55},0).wait(1).to({skewX:1.6653,x:110.9,y:81.05},0).wait(1).to({skewX:0.8327,x:110.25},0).wait(1).to({skewX:0,x:109.65},0).wait(130));

	// Capa_4
	this.instance_1 = new lib.Símbolo3();
	this.instance_1.parent = this;
	this.instance_1.setTransform(87,124.95,1,1,0,0,0,87,60.3);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1).to({regX:43.5,regY:30.3,x:43.5,y:94.95},0).wait(9).to({rotation:1.1781,x:44.15,y:94.05},0).wait(1).to({rotation:2.3562,x:44.75,y:93.15},0).wait(1).to({rotation:3.5343,x:45.4,y:92.35},0).wait(1).to({rotation:4.7124,x:46.05,y:91.45},0).wait(1).to({rotation:5.8905,x:46.75,y:90.6},0).wait(1).to({rotation:7.0685,x:47.45,y:89.8},0).wait(1).to({rotation:8.2466,x:48.2,y:89},0).wait(1).to({rotation:9.4247,x:48.95,y:88.2},0).wait(1).to({rotation:10.6028,x:49.75,y:87.45},0).wait(1).to({rotation:11.7809,x:50.5,y:86.7},0).wait(1).to({rotation:12.959,x:51.3,y:85.95},0).wait(1).to({rotation:14.1371,x:52.15,y:85.2},0).wait(1).to({rotation:15.3152,x:52.95,y:84.5},0).wait(1).to({rotation:16.4933,x:53.75,y:83.8},0).wait(1).to({rotation:17.6714,x:54.6,y:83.1},0).wait(1).to({rotation:18.8494,x:55.45,y:82.45},0).wait(1).to({rotation:20.0275,x:56.3,y:81.8},0).wait(1).to({rotation:21.2056,x:57.25,y:81.25},0).wait(1).to({rotation:22.3837,x:58.1,y:80.6},0).wait(1).to({rotation:23.5618,x:59.05,y:80},0).wait(1).to({rotation:22.9909,x:58.6,y:80.35},0).wait(1).to({rotation:22.4201,x:58.2,y:80.6},0).wait(1).to({rotation:21.8492,x:57.75,y:80.85},0).wait(1).to({rotation:21.2784,x:57.3,y:81.2},0).wait(1).to({rotation:20.7075,x:56.9,y:81.5},0).wait(1).to({rotation:20.1366,x:56.45,y:81.8},0).wait(1).to({rotation:19.5658,x:56.05,y:82.05},0).wait(1).to({rotation:18.9949,x:55.6,y:82.4},0).wait(1).to({rotation:18.4241,x:55.15,y:82.7},0).wait(1).to({rotation:17.8532,x:54.75,y:83.05},0).wait(1).to({rotation:17.2823,x:54.35,y:83.35},0).wait(1).to({rotation:16.7115,x:53.9,y:83.65},0).wait(1).to({rotation:16.1406,x:53.55,y:84},0).wait(1).to({rotation:15.5698,x:53.1,y:84.4},0).wait(1).to({rotation:14.9989,x:52.7,y:84.65},0).wait(1).to({rotation:14.6728,x:52.5,y:84.85},0).wait(1).to({rotation:14.3468,x:52.25,y:85.1},0).wait(1).to({rotation:14.0207,x:52,y:85.3},0).wait(1).to({rotation:13.6946,x:51.8,y:85.5},0).wait(1).to({rotation:13.3686,x:51.55,y:85.7},0).wait(1).to({rotation:13.0425,x:51.35,y:85.85},0).wait(1).to({rotation:12.7165,x:51.15,y:86.1},0).wait(1).to({rotation:12.3904,x:50.95,y:86.3},0).wait(1).to({rotation:12.0643,x:50.7,y:86.5},0).wait(1).to({rotation:11.7383,x:50.5,y:86.7},0).wait(1).to({rotation:11.4122,x:50.25,y:86.9},0).wait(1).to({rotation:11.0861,x:50.05,y:87.1},0).wait(1).to({rotation:10.7601,x:49.85,y:87.3},0).wait(1).to({rotation:10.434,x:49.65,y:87.55},0).wait(1).to({rotation:10.108,x:49.4,y:87.8},0).wait(1).to({rotation:9.7819,x:49.2,y:87.95},0).wait(1).to({rotation:9.4558,x:48.95,y:88.2},0).wait(1).to({rotation:9.1298,x:48.8,y:88.4},0).wait(1).to({rotation:8.8037,x:48.55,y:88.6},0).wait(1).to({rotation:8.4776,x:48.35,y:88.8},0).wait(1).to({rotation:8.1516,x:48.15,y:89.05},0).wait(1).to({rotation:7.8255,x:47.95,y:89.25},0).wait(1).to({rotation:7.4995,x:47.8,y:89.55},0).wait(1).to({rotation:7.1734,x:47.55,y:89.75},0).wait(1).to({rotation:6.8473,x:47.4,y:90},0).wait(1).to({rotation:6.5213,x:47.15,y:90.2},0).wait(1).to({rotation:6.1952,x:47,y:90.4},0).wait(1).to({rotation:5.8691,x:46.75,y:90.65},0).wait(1).to({rotation:5.5431,x:46.55,y:90.85},0).wait(1).to({rotation:5.217,x:46.35,y:91.05},0).wait(1).to({rotation:4.8909,x:46.2,y:91.35},0).wait(1).to({rotation:4.5649,x:46,y:91.55},0).wait(1).to({rotation:4.2388,x:45.8,y:91.75},0).wait(1).to({rotation:3.9128,x:45.65,y:92.05},0).wait(1).to({rotation:3.5867,x:45.4,y:92.25},0).wait(1).to({rotation:3.2606,x:45.3,y:92.45},0).wait(1).to({rotation:2.9346,x:45.05,y:92.75},0).wait(1).to({rotation:2.6085,x:44.85,y:93},0).wait(1).to({rotation:2.2824,x:44.7,y:93.25},0).wait(1).to({rotation:1.9564,x:44.5,y:93.5},0).wait(1).to({rotation:1.6303,x:44.35,y:93.7},0).wait(1).to({rotation:1.3043,x:44.15,y:93.95},0).wait(1).to({rotation:0.9782,x:44,y:94.2},0).wait(1).to({rotation:0.6521,x:43.8,y:94.45},0).wait(1).to({rotation:0.3261,x:43.65,y:94.7},0).wait(1).to({rotation:0,x:43.5,y:94.95},0).wait(110));

	// Capa_5
	this.instance_2 = new lib.Símbolo4();
	this.instance_2.parent = this;
	this.instance_2.setTransform(120.45,72,1,1,0,0,0,68.9,68.9);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1).to({regX:34.4,regY:34.5,rotation:1.0714,x:86.6,y:36.95},0).wait(1).to({rotation:2.1427,x:87.25,y:36.35},0).wait(1).to({rotation:3.2141,x:87.9,y:35.75},0).wait(1).to({rotation:4.2854,x:88.55,y:35.1},0).wait(1).to({rotation:5.3568,x:89.3,y:34.55},0).wait(1).to({rotation:6.4281,x:90,y:34},0).wait(1).to({rotation:7.4995,x:90.7,y:33.45},0).wait(1).to({rotation:8.5708,x:91.4,y:32.9},0).wait(1).to({rotation:9.6422,x:92.15,y:32.3},0).wait(1).to({rotation:10.7135,x:92.95,y:31.85},0).wait(1).to({rotation:11.7849,x:93.65,y:31.3},0).wait(1).to({rotation:12.8562,x:94.45,y:30.85},0).wait(1).to({rotation:13.9276,x:95.25,y:30.4},0).wait(1).to({rotation:14.9989,x:96,y:29.85},0).wait(23).to({rotation:14.5578,x:95.7,y:30.1},0).wait(1).to({rotation:14.1166,x:95.35,y:30.25},0).wait(1).to({rotation:13.6755,x:95,y:30.45},0).wait(1).to({rotation:13.2343,x:94.75,y:30.7},0).wait(1).to({rotation:12.7932,x:94.4,y:30.85},0).wait(1).to({rotation:12.352,x:94.05,y:31.05},0).wait(1).to({rotation:11.9109,x:93.8,y:31.25},0).wait(1).to({rotation:11.4697,x:93.45,y:31.45},0).wait(1).to({rotation:11.0286,x:93.15,y:31.7},0).wait(1).to({rotation:10.5875,x:92.8,y:31.85},0).wait(1).to({rotation:10.1463,x:92.5,y:32.05},0).wait(1).to({rotation:9.7052,x:92.25,y:32.3},0).wait(1).to({rotation:9.264,x:91.9,y:32.55},0).wait(1).to({rotation:8.8229,x:91.6,y:32.8},0).wait(1).to({rotation:8.3817,x:91.3,y:32.95},0).wait(1).to({rotation:7.9406,x:91,y:33.15},0).wait(1).to({rotation:7.4995,x:90.7,y:33.45},0).wait(1).to({rotation:7.0583,x:90.4,y:33.7},0).wait(1).to({rotation:6.6172,x:90.05,y:33.85},0).wait(1).to({rotation:6.176,x:89.85,y:34.1},0).wait(1).to({rotation:5.7349,x:89.55,y:34.4},0).wait(1).to({rotation:5.2937,x:89.25,y:34.55},0).wait(1).to({rotation:4.8526,x:89,y:34.85},0).wait(1).to({rotation:4.4114,x:88.7,y:35.1},0).wait(1).to({rotation:3.9703,x:88.35,y:35.3},0).wait(1).to({rotation:3.5292,x:88.15,y:35.55},0).wait(1).to({rotation:3.088,x:87.85,y:35.8},0).wait(1).to({rotation:2.6469,x:87.55,y:36.05},0).wait(1).to({rotation:2.2057,x:87.25,y:36.25},0).wait(1).to({rotation:1.7646,x:87.05,y:36.55},0).wait(1).to({rotation:1.3234,x:86.75,y:36.8},0).wait(1).to({rotation:0.8823,x:86.45,y:37.05},0).wait(1).to({rotation:0.4411,x:86.2,y:37.3},0).wait(1).to({rotation:0,x:85.95,y:37.6},0).wait(130));

	// Capa_6
	this.instance_3 = new lib.CachedTexturedBitmap_1090();
	this.instance_3.parent = this;
	this.instance_3.setTransform(93.6,-0.45,0.4999,0.4999);

	this.instance_4 = new lib.CachedTexturedBitmap_1089();
	this.instance_4.parent = this;
	this.instance_4.setTransform(95.6,1.8,0.4999,0.4999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3}]}).wait(200));

	// Capa_7
	this.instance_5 = new lib.yerba20("synched",0);
	this.instance_5.parent = this;
	this.instance_5.setTransform(32.95,61.95,1,1,0,0,0,22.4,18.4);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(200));

	// Capa_8
	this.instance_6 = new lib.yerba1("synched",0);
	this.instance_6.parent = this;
	this.instance_6.setTransform(183.5,127.7,1,1,0,0,0,100.4,118.9);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(1).to({regX:50.2,regY:59.5,x:133.3,y:68.3},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({rotation:0.8333,x:134.15,y:67.6},0).wait(1).to({rotation:1.6665,x:135.05,y:66.8},0).wait(1).to({rotation:2.4998,x:135.9,y:66.15},0).wait(1).to({rotation:3.3331,x:136.8,y:65.45},0).wait(1).to({rotation:4.1664,x:137.75,y:64.8},0).wait(1).to({rotation:4.9996,x:138.6,y:64.1},0).wait(1).to({rotation:5.8329,x:139.6,y:63.55},0).wait(1).to({rotation:6.6662,x:140.5,y:62.9},0).wait(1).to({rotation:7.4995,x:141.45,y:62.3},0).wait(1).to({rotation:8.3327,x:142.4,y:61.65},0).wait(1).to({rotation:9.166,x:143.35,y:61.1},0).wait(1).to({rotation:9.9993,x:144.35,y:60.5},0).wait(1).to({rotation:10.8325,x:145.3,y:59.95},0).wait(1).to({rotation:11.6658,x:146.3,y:59.4},0).wait(1).to({rotation:12.4991,x:147.3,y:58.85},0).wait(1).to({rotation:13.3324,x:148.35,y:58.4},0).wait(1).to({rotation:14.1656,x:149.35,y:57.85},0).wait(1).to({rotation:14.9989,x:150.35,y:57.35},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({rotation:14.6728,x:149.95,y:57.5},0).wait(1).to({rotation:14.3468,x:149.55,y:57.75},0).wait(1).to({rotation:14.0207,x:149.15,y:57.95},0).wait(1).to({rotation:13.6946,x:148.75,y:58.15},0).wait(1).to({rotation:13.3686,x:148.4,y:58.35},0).wait(1).to({rotation:13.0425,x:147.95,y:58.55},0).wait(1).to({rotation:12.7165,x:147.55,y:58.75},0).wait(1).to({rotation:12.3904,x:147.25,y:58.9},0).wait(1).to({rotation:12.0643,x:146.8,y:59.15},0).wait(1).to({rotation:11.7383,x:146.4,y:59.35},0).wait(1).to({rotation:11.4122,x:146.05,y:59.55},0).wait(1).to({rotation:11.0861,x:145.6,y:59.8},0).wait(1).to({rotation:10.7601,x:145.25,y:59.95},0).wait(1).to({rotation:10.434,x:144.85,y:60.2},0).wait(1).to({rotation:10.108,x:144.45,y:60.45},0).wait(1).to({rotation:9.7819,x:144.1,y:60.7},0).wait(1).to({rotation:9.4558,x:143.7,y:60.9},0).wait(1).to({rotation:9.1298,x:143.3,y:61.1},0).wait(1).to({rotation:8.8037,x:142.95,y:61.35},0).wait(1).to({rotation:8.4776,x:142.6,y:61.55},0).wait(1).to({rotation:8.1516,x:142.2,y:61.8},0).wait(1).to({rotation:7.8255,x:141.85,y:62.05},0).wait(1).to({rotation:7.4995,x:141.45,y:62.3},0).wait(1).to({rotation:7.1734,x:141.05,y:62.5},0).wait(1).to({rotation:6.8473,x:140.7,y:62.8},0).wait(1).to({rotation:6.5213,x:140.35,y:63},0).wait(1).to({rotation:6.1952,x:140,y:63.25},0).wait(1).to({rotation:5.8691,x:139.6,y:63.55},0).wait(1).to({rotation:5.5431,x:139.25,y:63.75},0).wait(1).to({rotation:5.217,x:138.9,y:63.95},0).wait(1).to({rotation:4.8909,x:138.55,y:64.25},0).wait(1).to({rotation:4.5649,x:138.15,y:64.45},0).wait(1).to({rotation:4.2388,x:137.8,y:64.75},0).wait(1).to({rotation:3.9128,x:137.45,y:65},0).wait(1).to({rotation:3.5867,x:137.1,y:65.3},0).wait(1).to({rotation:3.2606,x:136.7,y:65.5},0).wait(1).to({rotation:2.9346,x:136.4,y:65.75},0).wait(1).to({rotation:2.6085,x:136.05,y:66.1},0).wait(1).to({rotation:2.2824,x:135.7,y:66.3},0).wait(1).to({rotation:1.9564,x:135.3,y:66.55},0).wait(1).to({rotation:1.6303,x:135,y:66.9},0).wait(1).to({rotation:1.3043,x:134.65,y:67.15},0).wait(1).to({rotation:0.9782,x:134.3,y:67.45},0).wait(1).to({rotation:0.6521,x:133.95,y:67.7},0).wait(1).to({rotation:0.3261,x:133.6,y:68},0).wait(1).to({rotation:0,x:133.3,y:68.3},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-0.5,-12.4,215,141);


// stage content:
(lib.humedalesanim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// piedra
	this.instance = new lib.piedra("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(656.95,937.85,1.0001,1.0001,0,0,0,44.9,41.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(288));

	// garza4
	this.instance_1 = new lib.garza4("synched",0);
	this.instance_1.parent = this;
	this.instance_1.setTransform(263.25,833.45,1.0001,1.0001,0,0,0,30.1,20.9);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(288));

	// garza3
	this.instance_2 = new lib.CachedTexturedBitmap_552();
	this.instance_2.parent = this;
	this.instance_2.setTransform(200.8,824.3,0.5,0.5);

	this.instance_3 = new lib.CachedTexturedBitmap_551();
	this.instance_3.parent = this;
	this.instance_3.setTransform(198.5,820.3,0.5,0.5);

	this.instance_4 = new lib.CachedTexturedBitmap_550();
	this.instance_4.parent = this;
	this.instance_4.setTransform(198.6,820.35,0.5,0.5);

	this.instance_5 = new lib.CachedTexturedBitmap_549();
	this.instance_5.parent = this;
	this.instance_5.setTransform(198.55,819.45,0.5,0.5);

	this.instance_6 = new lib.CachedTexturedBitmap_548();
	this.instance_6.parent = this;
	this.instance_6.setTransform(198.6,819.55,0.5,0.5);

	this.instance_7 = new lib.CachedTexturedBitmap_547();
	this.instance_7.parent = this;
	this.instance_7.setTransform(159.25,815.15,0.5,0.5);

	this.instance_8 = new lib.CachedTexturedBitmap_546();
	this.instance_8.parent = this;
	this.instance_8.setTransform(159.35,815.25,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]}).wait(288));

	// garza2
	this.instance_9 = new lib.CachedTexturedBitmap_561();
	this.instance_9.parent = this;
	this.instance_9.setTransform(121.05,841.2,0.5,0.5);

	this.instance_10 = new lib.CachedTexturedBitmap_560();
	this.instance_10.parent = this;
	this.instance_10.setTransform(121.15,841.3,0.5,0.5);

	this.instance_11 = new lib.CachedTexturedBitmap_559();
	this.instance_11.parent = this;
	this.instance_11.setTransform(146.25,825.6,0.5,0.5);

	this.instance_12 = new lib.CachedTexturedBitmap_558();
	this.instance_12.parent = this;
	this.instance_12.setTransform(143.85,820.45,0.5,0.5);

	this.instance_13 = new lib.CachedTexturedBitmap_557();
	this.instance_13.parent = this;
	this.instance_13.setTransform(143.9,820.55,0.5,0.5);

	this.instance_14 = new lib.CachedTexturedBitmap_556();
	this.instance_14.parent = this;
	this.instance_14.setTransform(144.55,822.1,0.5,0.5);

	this.instance_15 = new lib.CachedTexturedBitmap_555();
	this.instance_15.parent = this;
	this.instance_15.setTransform(144.6,822.15,0.5,0.5);

	this.instance_16 = new lib.CachedTexturedBitmap_554();
	this.instance_16.parent = this;
	this.instance_16.setTransform(104.5,816.3,0.5,0.5);

	this.instance_17 = new lib.CachedTexturedBitmap_553();
	this.instance_17.parent = this;
	this.instance_17.setTransform(104.6,816.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9}]}).wait(288));

	// garza1
	this.instance_18 = new lib.garza1("synched",0);
	this.instance_18.parent = this;
	this.instance_18.setTransform(87.25,836,1.0001,1.0001,0,0,0,33.9,22.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).wait(288));

	// pajaros
	this.instance_19 = new lib.pajaros("synched",0);
	this.instance_19.parent = this;
	this.instance_19.setTransform(912.9,529.45,0.2475,0.2473,0,0,0,204.7,21.4);

	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:204.1,regY:20.7,scaleX:1.0001,scaleY:1.0001,x:209.65,y:-48.65,startPosition:151},215).wait(73));

	// nubes
	this.instance_20 = new lib.nubews("synched",0);
	this.instance_20.parent = this;
	this.instance_20.setTransform(983.4,271.35,1.0001,1.0001,0,0,0,1046.3,179.6);

	this.timeline.addTween(cjs.Tween.get(this.instance_20).wait(288));

	// Capa_4
	this.instance_21 = new lib.nenufar("synched",0);
	this.instance_21.parent = this;
	this.instance_21.setTransform(194.5,988,1,1,0,0,0,153.5,65);

	this.timeline.addTween(cjs.Tween.get(this.instance_21).wait(288));

	// burro
	this.instance_22 = new lib.burro("synched",0);
	this.instance_22.parent = this;
	this.instance_22.setTransform(1659.5,922.7,1,1,0,0,0,179.5,99);

	this.timeline.addTween(cjs.Tween.get(this.instance_22).wait(288));

	// yerbas
	this.instance_23 = new lib.yerbas("synched",0);
	this.instance_23.parent = this;
	this.instance_23.setTransform(987.25,900.4,1.0001,1.0001,0,0,0,92,63.9);

	this.timeline.addTween(cjs.Tween.get(this.instance_23).wait(288));

	// Capa_2
	this.instance_24 = new lib.copiafondo();
	this.instance_24.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance_24).wait(288));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(544.9,495.6,1765,664.4);
// library properties:
lib.properties = {
	id: 'C5F078DD8C0B3C47814EFE4260C0F8A9',
	width: 1900,
	height: 1163,
	fps: 24,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"https://cdn.shopify.com/s/files/1/1568/2063/files/humedalesanim_atlas.png", id:"humedalesanim_atlas_"},
		{src:"https://cdn.shopify.com/s/files/1/1568/2063/files/humedalesanim_atlas_2.png", id:"humedalesanim_atlas_2"},
		{src:"https://cdn.shopify.com/s/files/1/1568/2063/files/humedalesanim_atlas_3.png", id:"humedalesanim_atlas_3"},
		{src:"https://cdn.shopify.com/s/files/1/1568/2063/files/humedalesanim_atlas_4.png", id:"humedalesanim_atlas_4"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['C5F078DD8C0B3C47814EFE4260C0F8A9'] = {
	getStage: function() { return exportRoot.getStage(); },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}			
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;			
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});			
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;			
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
var createjs, AdobeAn;


var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;
function init() {
	canvas = document.getElementById("canvas");
	anim_container = document.getElementById("animation_container");
	dom_overlay_container = document.getElementById("dom_overlay_container");
	var comp=AdobeAn.getComposition("C5F078DD8C0B3C47814EFE4260C0F8A9");
	var lib=comp.getLibrary();
	var loader = new createjs.LoadQueue(false);
	loader.addEventListener("fileload", function(evt){handleFileLoad(evt,comp)});
	loader.addEventListener("complete", function(evt){handleComplete(evt,comp)});
	var lib=comp.getLibrary();
	loader.loadManifest(lib.properties.manifest);
}
function handleFileLoad(evt, comp) {
	var images=comp.getImages();	
	if (evt && (evt.item.type == "image")) { images[evt.item.id] = evt.result; }	
}
function handleComplete(evt,comp) {
	//This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
	var lib=comp.getLibrary();
	var ss=comp.getSpriteSheet();
	var queue = evt.target;
	var ssMetadata = lib.ssMetadata;
	for(i=0; i<ssMetadata.length; i++) {
		ss[ssMetadata[i].name] = new createjs.SpriteSheet( {"images": [queue.getResult(ssMetadata[i].name)], "frames": ssMetadata[i].frames} )
	}
	exportRoot = new lib.humedalesanim();
	stage = new lib.Stage(canvas);	
	//Registers the "tick" event listener.
	fnStartAnimation = function() {
		stage.addChild(exportRoot);
		createjs.Ticker.setFPS(lib.properties.fps);
		createjs.Ticker.addEventListener("tick", stage);
	}	    
	//Code to support hidpi screens and responsive scaling.
	AdobeAn.makeResponsive(false,'both',false,1,[canvas,anim_container,dom_overlay_container]);	
	AdobeAn.compositionLoaded(lib.properties.id);
	fnStartAnimation();
}